// Thanks to https://countriesnow.space/

export const statesPerCountry = {
    "Afghanistan": [
        {
            "label": "BDS",
            "value": "Badakhshan"
        },
        {
            "label": "BDG",
            "value": "Badghis"
        },
        {
            "label": "BGL",
            "value": "Baghlan"
        },
        {
            "label": "BAL",
            "value": "Balkh"
        },
        {
            "label": "BAM",
            "value": "Bamyan"
        },
        {
            "label": "DAY",
            "value": "Daykundi"
        },
        {
            "label": "FRA",
            "value": "Farah"
        },
        {
            "label": "FYB",
            "value": "Faryab"
        },
        {
            "label": "GHA",
            "value": "Ghazni"
        },
        {
            "label": "GHO",
            "value": "Ghōr"
        },
        {
            "label": "HEL",
            "value": "Helmand"
        },
        {
            "label": "HER",
            "value": "Herat"
        },
        {
            "label": "JOW",
            "value": "Jowzjan"
        },
        {
            "label": "KAB",
            "value": "Kabul"
        },
        {
            "label": "KAN",
            "value": "Kandahar"
        },
        {
            "label": "KAP",
            "value": "Kapisa"
        },
        {
            "label": "KHO",
            "value": "Khost"
        },
        {
            "label": "KNR",
            "value": "Kunar"
        },
        {
            "label": "KDZ",
            "value": "Kunduz Province"
        },
        {
            "label": "LAG",
            "value": "Laghman"
        },
        {
            "label": "LOG",
            "value": "Logar"
        },
        {
            "label": "NAN",
            "value": "Nangarhar"
        },
        {
            "label": "NIM",
            "value": "Nimruz"
        },
        {
            "label": "NUR",
            "value": "Nuristan"
        },
        {
            "label": "PIA",
            "value": "Paktia"
        },
        {
            "label": "PKA",
            "value": "Paktika"
        },
        {
            "label": "PAN",
            "value": "Panjshir"
        },
        {
            "label": "PAR",
            "value": "Parwan"
        },
        {
            "label": "SAM",
            "value": "Samangan"
        },
        {
            "label": "SAR",
            "value": "Sar-e Pol"
        },
        {
            "label": "TAK",
            "value": "Takhar"
        },
        {
            "label": "URU",
            "value": "Urozgan"
        },
        {
            "label": "ZAB",
            "value": "Zabul"
        }
    ],
    "Aland Islands": [

    ],
    "Albania": [
        {
            "label": "01",
            "value": "Berat County"
        },
        {
            "label": "BR",
            "value": "Berat District"
        },
        {
            "label": "BU",
            "value": "Bulqizë District"
        },
        {
            "label": "DL",
            "value": "Delvinë District"
        },
        {
            "label": "DV",
            "value": "Devoll District"
        },
        {
            "label": "09",
            "value": "Dibër County"
        },
        {
            "label": "DI",
            "value": "Dibër District"
        },
        {
            "label": "02",
            "value": "Durrës County"
        },
        {
            "label": "DR",
            "value": "Durrës District"
        },
        {
            "label": "03",
            "value": "Elbasan County"
        },
        {
            "label": "04",
            "value": "Fier County"
        },
        {
            "label": "FR",
            "value": "Fier District"
        },
        {
            "label": "05",
            "value": "Gjirokastër County"
        },
        {
            "label": "GJ",
            "value": "Gjirokastër District"
        },
        {
            "label": "GR",
            "value": "Gramsh District"
        },
        {
            "label": "HA",
            "value": "Has District"
        },
        {
            "label": "KA",
            "value": "Kavajë District"
        },
        {
            "label": "ER",
            "value": "Kolonjë District"
        },
        {
            "label": "06",
            "value": "Korçë County"
        },
        {
            "label": "KO",
            "value": "Korçë District"
        },
        {
            "label": "KR",
            "value": "Krujë District"
        },
        {
            "label": "KC",
            "value": "Kuçovë District"
        },
        {
            "label": "07",
            "value": "Kukës County"
        },
        {
            "label": "KU",
            "value": "Kukës District"
        },
        {
            "label": "KB",
            "value": "Kurbin District"
        },
        {
            "label": "08",
            "value": "Lezhë County"
        },
        {
            "label": "LE",
            "value": "Lezhë District"
        },
        {
            "label": "LB",
            "value": "Librazhd District"
        },
        {
            "label": "LU",
            "value": "Lushnjë District"
        },
        {
            "label": "MM",
            "value": "Malësi e Madhe District"
        },
        {
            "label": "MK",
            "value": "Mallakastër District"
        },
        {
            "label": "MT",
            "value": "Mat District"
        },
        {
            "label": "MR",
            "value": "Mirditë District"
        },
        {
            "label": "PQ",
            "value": "Peqin District"
        },
        {
            "label": "PR",
            "value": "Përmet District"
        },
        {
            "label": "PG",
            "value": "Pogradec District"
        },
        {
            "label": "PU",
            "value": "Pukë District"
        },
        {
            "label": "SR",
            "value": "Sarandë District"
        },
        {
            "label": "10",
            "value": "Shkodër County"
        },
        {
            "label": "SH",
            "value": "Shkodër District"
        },
        {
            "label": "SK",
            "value": "Skrapar District"
        },
        {
            "label": "TE",
            "value": "Tepelenë District"
        },
        {
            "label": "11",
            "value": "Tirana County"
        },
        {
            "label": "TR",
            "value": "Tirana District"
        },
        {
            "label": "TP",
            "value": "Tropojë District"
        },
        {
            "label": "12",
            "value": "Vlorë County"
        },
        {
            "label": "VL",
            "value": "Vlorë District"
        }
    ],
    "Algeria": [
        {
            "label": "01",
            "value": "Adrar Province"
        },
        {
            "label": "44",
            "value": "Aïn Defla Province"
        },
        {
            "label": "46",
            "value": "Aïn Témouchent Province"
        },
        {
            "label": "16",
            "value": "Algiers Province"
        },
        {
            "label": "23",
            "value": "Annaba Province"
        },
        {
            "label": "05",
            "value": "Batna Province"
        },
        {
            "label": "08",
            "value": "Béchar Province"
        },
        {
            "label": "06",
            "value": "Béjaïa Province"
        },
        {
            "label": "07",
            "value": "Biskra"
        },
        {
            "label": "09",
            "value": "Blida Province"
        },
        {
            "label": "34",
            "value": "Bordj Bou Arréridj Province"
        },
        {
            "label": "10",
            "value": "Bouïra Province"
        },
        {
            "label": "35",
            "value": "Boumerdès Province"
        },
        {
            "label": "02",
            "value": "Chlef Province"
        },
        {
            "label": "25",
            "value": "Constantine Province"
        },
        {
            "label": "17",
            "value": "Djelfa Province"
        },
        {
            "label": "32",
            "value": "El Bayadh Province"
        },
        {
            "label": "39",
            "value": "El Oued Province"
        },
        {
            "label": "36",
            "value": "El Tarf Province"
        },
        {
            "label": "47",
            "value": "Ghardaïa Province"
        },
        {
            "label": "24",
            "value": "Guelma Province"
        },
        {
            "label": "33",
            "value": "Illizi Province"
        },
        {
            "label": "18",
            "value": "Jijel Province"
        },
        {
            "label": "40",
            "value": "Khenchela Province"
        },
        {
            "label": "03",
            "value": "Laghouat Province"
        },
        {
            "label": "28",
            "value": "M'Sila Province"
        },
        {
            "label": "29",
            "value": "Mascara Province"
        },
        {
            "label": "26",
            "value": "Médéa Province"
        },
        {
            "label": "43",
            "value": "Mila Province"
        },
        {
            "label": "27",
            "value": "Mostaganem Province"
        },
        {
            "label": "45",
            "value": "Naama Province"
        },
        {
            "label": "31",
            "value": "Oran Province"
        },
        {
            "label": "30",
            "value": "Ouargla Province"
        },
        {
            "label": "04",
            "value": "Oum El Bouaghi Province"
        },
        {
            "label": "48",
            "value": "Relizane Province"
        },
        {
            "label": "20",
            "value": "Saïda Province"
        },
        {
            "label": "19",
            "value": "Sétif Province"
        },
        {
            "label": "21",
            "value": "Skikda Province"
        },
        {
            "label": "41",
            "value": "Souk Ahras Province"
        },
        {
            "label": "11",
            "value": "Tamanghasset Province"
        },
        {
            "label": "12",
            "value": "Tébessa Province"
        },
        {
            "label": "14",
            "value": "Tiaret Province"
        },
        {
            "label": "37",
            "value": "Tindouf Province"
        },
        {
            "label": "42",
            "value": "Tipasa Province"
        },
        {
            "label": "38",
            "value": "Tissemsilt Province"
        },
        {
            "label": "15",
            "value": "Tizi Ouzou Province"
        },
        {
            "label": "13",
            "value": "Tlemcen Province"
        }
    ],
    "American Samoa": [

    ],
    "Andorra": [
        {
            "label": "07",
            "value": "Andorra la Vella"
        },
        {
            "label": "02",
            "value": "Canillo"
        },
        {
            "label": "03",
            "value": "Encamp"
        },
        {
            "label": "08",
            "value": "Escaldes-Engordany"
        },
        {
            "label": "04",
            "value": "La Massana"
        },
        {
            "label": "05",
            "value": "Ordino"
        },
        {
            "label": "06",
            "value": "Sant Julià de Lòria"
        }
    ],
    "Angola": [
        {
            "label": "BGO",
            "value": "Bengo Province"
        },
        {
            "label": "BGU",
            "value": "Benguela Province"
        },
        {
            "label": "BIE",
            "value": "Bié Province"
        },
        {
            "label": "CAB",
            "value": "Cabinda Province"
        },
        {
            "label": "CCU",
            "value": "Cuando Cubango Province"
        },
        {
            "label": "CNO",
            "value": "Cuanza Norte Province"
        },
        {
            "label": "CUS",
            "value": "Cuanza Sul"
        },
        {
            "label": "CNN",
            "value": "Cunene Province"
        },
        {
            "label": "HUA",
            "value": "Huambo Province"
        },
        {
            "label": "HUI",
            "value": "Huíla Province"
        },
        {
            "label": "LUA",
            "value": "Luanda Province"
        },
        {
            "label": "LNO",
            "value": "Lunda Norte Province"
        },
        {
            "label": "LSU",
            "value": "Lunda Sul Province"
        },
        {
            "label": "MAL",
            "value": "Malanje Province"
        },
        {
            "label": "MOX",
            "value": "Moxico Province"
        },
        {
            "label": "UIG",
            "value": "Uíge Province"
        },
        {
            "label": "ZAI",
            "value": "Zaire Province"
        }
    ],
    "Anguilla": [

    ],
    "Antarctica": [

    ],
    "Antigua And Barbuda": [
        {
            "label": "10",
            "value": "Barbuda"
        },
        {
            "label": "11",
            "value": "Redonda"
        },
        {
            "label": "03",
            "value": "Saint George Parish"
        },
        {
            "label": "04",
            "value": "Saint John Parish"
        },
        {
            "label": "05",
            "value": "Saint Mary Parish"
        },
        {
            "label": "06",
            "value": "Saint Paul Parish"
        },
        {
            "label": "07",
            "value": "Saint Peter Parish"
        },
        {
            "label": "08",
            "value": "Saint Philip Parish"
        }
    ],
    "Argentina": [
        {
            "label": "C",
            "value": "Autonomous City Of Buenos Aires"
        },
        {
            "label": "B",
            "value": "Buenos Aires Province"
        },
        {
            "label": "K",
            "value": "Catamarca Province"
        },
        {
            "label": "H",
            "value": "Chaco Province"
        },
        {
            "label": "U",
            "value": "Chubut Province"
        },
        {
            "label": "X",
            "value": "Córdoba Province"
        },
        {
            "label": "W",
            "value": "Corrientes"
        },
        {
            "label": "E",
            "value": "Entre Ríos Province"
        },
        {
            "label": "P",
            "value": "Formosa Province"
        },
        {
            "label": "Y",
            "value": "Jujuy Province"
        },
        {
            "label": "L",
            "value": "La Pampa"
        },
        {
            "label": "F",
            "value": "La Rioja Province"
        },
        {
            "label": "M",
            "value": "Mendoza"
        },
        {
            "label": "N",
            "value": "Misiones Province"
        },
        {
            "label": "Q",
            "value": "Neuquén Province"
        },
        {
            "label": "R",
            "value": "Río Negro Province"
        },
        {
            "label": "A",
            "value": "Salta Province"
        },
        {
            "label": "J",
            "value": "San Juan Province"
        },
        {
            "label": "D",
            "value": "San Luis Province"
        },
        {
            "label": "Z",
            "value": "Santa Cruz Province"
        },
        {
            "label": "S",
            "value": "Santa Fe Province"
        },
        {
            "label": "G",
            "value": "Santiago del Estero Province"
        },
        {
            "label": "V",
            "value": "Tierra del Fuego Province"
        },
        {
            "label": "T",
            "value": "Tucumán Province"
        }
    ],
    "Armenia": [
        {
            "label": "AG",
            "value": "Aragatsotn Region"
        },
        {
            "label": "AR",
            "value": "Ararat Province"
        },
        {
            "label": "AV",
            "value": "Armavir Region"
        },
        {
            "label": "GR",
            "value": "Gegharkunik Province"
        },
        {
            "label": "KT",
            "value": "Kotayk Region"
        },
        {
            "label": "LO",
            "value": "Lori Region"
        },
        {
            "label": "SH",
            "value": "Shirak Region"
        },
        {
            "label": "SU",
            "value": "Syunik Province"
        },
        {
            "label": "TV",
            "value": "Tavush Region"
        },
        {
            "label": "VD",
            "value": "Vayots Dzor Region"
        },
        {
            "label": "ER",
            "value": "Yerevan"
        }
    ],
    "Aruba": [

    ],
    "Australia": [
        {
            "label": "ACT",
            "value": "Australian Capital Territory"
        },
        {
            "label": "NSW",
            "value": "New South Wales"
        },
        {
            "label": "NT",
            "value": "Northern Territory"
        },
        {
            "label": "QLD",
            "value": "Queensland"
        },
        {
            "label": "SA",
            "value": "South Australia"
        },
        {
            "label": "TAS",
            "value": "Tasmania"
        },
        {
            "label": "VIC",
            "value": "Victoria"
        },
        {
            "label": "WA",
            "value": "Western Australia"
        }
    ],
    "Austria": [
        {
            "label": "1",
            "value": "Burgenland"
        },
        {
            "label": "2",
            "value": "Carinthia"
        },
        {
            "label": "3",
            "value": "Lower Austria"
        },
        {
            "label": "5",
            "value": "Salzburg"
        },
        {
            "label": "6",
            "value": "Styria"
        },
        {
            "label": "7",
            "value": "Tyrol"
        },
        {
            "label": "4",
            "value": "Upper Austria"
        },
        {
            "label": "9",
            "value": "Vienna"
        },
        {
            "label": "8",
            "value": "Vorarlberg"
        }
    ],
    "Azerbaijan": [
        {
            "label": "ABS",
            "value": "Absheron District"
        },
        {
            "label": "AGM",
            "value": "Agdam District"
        },
        {
            "label": "AGS",
            "value": "Agdash District"
        },
        {
            "label": "AGC",
            "value": "Aghjabadi District"
        },
        {
            "label": "AGA",
            "value": "Agstafa District"
        },
        {
            "label": "AGU",
            "value": "Agsu District"
        },
        {
            "label": "AST",
            "value": "Astara District"
        },
        {
            "label": "BAB",
            "value": "Babek District"
        },
        {
            "label": "BA",
            "value": "Baku"
        },
        {
            "label": "BAL",
            "value": "Balakan District"
        },
        {
            "label": "BAR",
            "value": "Barda District"
        },
        {
            "label": "BEY",
            "value": "Beylagan District"
        },
        {
            "label": "BIL",
            "value": "Bilasuvar District"
        },
        {
            "label": "DAS",
            "value": "Dashkasan District"
        },
        {
            "label": "FUZ",
            "value": "Fizuli District"
        },
        {
            "label": "GA",
            "value": "Ganja"
        },
        {
            "label": "GAD",
            "value": "Gədəbəy"
        },
        {
            "label": "QOB",
            "value": "Gobustan District"
        },
        {
            "label": "GOR",
            "value": "Goranboy District"
        },
        {
            "label": "GOY",
            "value": "Goychay"
        },
        {
            "label": "GYG",
            "value": "Goygol District"
        },
        {
            "label": "HAC",
            "value": "Hajigabul District"
        },
        {
            "label": "IMI",
            "value": "Imishli District"
        },
        {
            "label": "ISM",
            "value": "Ismailli District"
        },
        {
            "label": "CAB",
            "value": "Jabrayil District"
        },
        {
            "label": "CAL",
            "value": "Jalilabad District"
        },
        {
            "label": "CUL",
            "value": "Julfa District"
        },
        {
            "label": "KAL",
            "value": "Kalbajar District"
        },
        {
            "label": "KAN",
            "value": "Kangarli District"
        },
        {
            "label": "XAC",
            "value": "Khachmaz District"
        },
        {
            "label": "XIZ",
            "value": "Khizi District"
        },
        {
            "label": "XCI",
            "value": "Khojali District"
        },
        {
            "label": "KUR",
            "value": "Kurdamir District"
        },
        {
            "label": "LAC",
            "value": "Lachin District"
        },
        {
            "label": "LAN",
            "value": "Lankaran"
        },
        {
            "label": "LA",
            "value": "Lankaran District"
        },
        {
            "label": "LER",
            "value": "Lerik District"
        },
        {
            "label": "XVD",
            "value": "Martuni"
        },
        {
            "label": "MAS",
            "value": "Masally District"
        },
        {
            "label": "MI",
            "value": "Mingachevir"
        },
        {
            "label": "NX",
            "value": "Nakhchivan Autonomous Republic"
        },
        {
            "label": "NEF",
            "value": "Neftchala District"
        },
        {
            "label": "OGU",
            "value": "Oghuz District"
        },
        {
            "label": "ORD",
            "value": "Ordubad District"
        },
        {
            "label": "QAB",
            "value": "Qabala District"
        },
        {
            "label": "QAX",
            "value": "Qakh District"
        },
        {
            "label": "QAZ",
            "value": "Qazakh District"
        },
        {
            "label": "QBA",
            "value": "Quba District"
        },
        {
            "label": "QBI",
            "value": "Qubadli District"
        },
        {
            "label": "QUS",
            "value": "Qusar District"
        },
        {
            "label": "SAT",
            "value": "Saatly District"
        },
        {
            "label": "SAB",
            "value": "Sabirabad District"
        },
        {
            "label": "SAD",
            "value": "Sadarak District"
        },
        {
            "label": "SAL",
            "value": "Salyan District"
        },
        {
            "label": "SMX",
            "value": "Samukh District"
        },
        {
            "label": "SBN",
            "value": "Shabran District"
        },
        {
            "label": "SAH",
            "value": "Shahbuz District"
        },
        {
            "label": "SA",
            "value": "Shaki"
        },
        {
            "label": "SAK",
            "value": "Shaki District"
        },
        {
            "label": "SMI",
            "value": "Shamakhi District"
        },
        {
            "label": "SKR",
            "value": "Shamkir District"
        },
        {
            "label": "SAR",
            "value": "Sharur District"
        },
        {
            "label": "SR",
            "value": "Shirvan"
        },
        {
            "label": "SUS",
            "value": "Shusha District"
        },
        {
            "label": "SIY",
            "value": "Siazan District"
        },
        {
            "label": "SM",
            "value": "Sumqayit"
        },
        {
            "label": "TAR",
            "value": "Tartar District"
        },
        {
            "label": "TOV",
            "value": "Tovuz District"
        },
        {
            "label": "UCA",
            "value": "Ujar District"
        },
        {
            "label": "YAR",
            "value": "Yardymli District"
        },
        {
            "label": "YE",
            "value": "Yevlakh"
        },
        {
            "label": "YEV",
            "value": "Yevlakh District"
        },
        {
            "label": "ZAN",
            "value": "Zangilan District"
        },
        {
            "label": "ZAQ",
            "value": "Zaqatala District"
        },
        {
            "label": "ZAR",
            "value": "Zardab District"
        }
    ],
    "Bahamas The": [
        {
            "label": "AK",
            "value": "Acklins"
        },
        {
            "label": "AC",
            "value": "Acklins and Crooked Islands"
        },
        {
            "label": "BY",
            "value": "Berry Islands"
        },
        {
            "label": "BI",
            "value": "Bimini"
        },
        {
            "label": "BP",
            "value": "Black Point"
        },
        {
            "label": "CI",
            "value": "Cat Island"
        },
        {
            "label": "CO",
            "value": "Central Abaco"
        },
        {
            "label": "CS",
            "value": "Central Andros"
        },
        {
            "label": "CE",
            "value": "Central Eleuthera"
        },
        {
            "label": "CK",
            "value": "Crooked Island"
        },
        {
            "label": "EG",
            "value": "East Grand Bahama"
        },
        {
            "label": "EX",
            "value": "Exuma"
        },
        {
            "label": "FP",
            "value": "Freeport"
        },
        {
            "label": "FC",
            "value": "Fresh Creek"
        },
        {
            "label": "GH",
            "value": "Governor's Harbour"
        },
        {
            "label": "GC",
            "value": "Grand Cay"
        },
        {
            "label": "GT",
            "value": "Green Turtle Cay"
        },
        {
            "label": "HI",
            "value": "Harbour Island"
        },
        {
            "label": "HR",
            "value": "High Rock"
        },
        {
            "label": "HT",
            "value": "Hope Town"
        },
        {
            "label": "IN",
            "value": "Inagua"
        },
        {
            "label": "KB",
            "value": "Kemps Bay"
        },
        {
            "label": "LI",
            "value": "Long Island"
        },
        {
            "label": "MC",
            "value": "Mangrove Cay"
        },
        {
            "label": "MH",
            "value": "Marsh Harbour"
        },
        {
            "label": "MG",
            "value": "Mayaguana District"
        },
        {
            "label": "NB",
            "value": "Nichollstown and Berry Islands"
        },
        {
            "label": "NO",
            "value": "North Abaco"
        },
        {
            "label": "NS",
            "value": "North Andros"
        },
        {
            "label": "NE",
            "value": "North Eleuthera"
        },
        {
            "label": "RI",
            "value": "Ragged Island"
        },
        {
            "label": "RS",
            "value": "Rock Sound"
        },
        {
            "label": "RC",
            "value": "Rum Cay District"
        },
        {
            "label": "SR",
            "value": "San Salvador and Rum Cay"
        },
        {
            "label": "SS",
            "value": "San Salvador Island"
        },
        {
            "label": "SP",
            "value": "Sandy Point"
        },
        {
            "label": "SO",
            "value": "South Abaco"
        },
        {
            "label": "SA",
            "value": "South Andros"
        },
        {
            "label": "SE",
            "value": "South Eleuthera"
        },
        {
            "label": "SW",
            "value": "Spanish Wells"
        },
        {
            "label": "WG",
            "value": "West Grand Bahama"
        }
    ],
    "Bahrain": [
        {
            "label": "13",
            "value": "Capital Governorate"
        },
        {
            "label": "16",
            "value": "Central Governorate"
        },
        {
            "label": "15",
            "value": "Muharraq Governorate"
        },
        {
            "label": "17",
            "value": "Northern Governorate"
        },
        {
            "label": "14",
            "value": "Southern Governorate"
        }
    ],
    "Bangladesh": [
        {
            "label": "05",
            "value": "Bagerhat District"
        },
        {
            "label": "33",
            "value": "Bahadia"
        },
        {
            "label": "01",
            "value": "Bandarban District"
        },
        {
            "label": "02",
            "value": "Barguna District"
        },
        {
            "label": "06",
            "value": "Barisal District"
        },
        {
            "label": "A",
            "value": "Barisal Division"
        },
        {
            "label": "07",
            "value": "Bhola District"
        },
        {
            "label": "03",
            "value": "Bogra District"
        },
        {
            "label": "04",
            "value": "Brahmanbaria District"
        },
        {
            "label": "09",
            "value": "Chandpur District"
        },
        {
            "label": "45",
            "value": "Chapai Nawabganj District"
        },
        {
            "label": "10",
            "value": "Chittagong District"
        },
        {
            "label": "B",
            "value": "Chittagong Division"
        },
        {
            "label": "12",
            "value": "Chuadanga District"
        },
        {
            "label": "08",
            "value": "Comilla District"
        },
        {
            "label": "11",
            "value": "Cox's Bazar District"
        },
        {
            "label": "13",
            "value": "Dhaka District"
        },
        {
            "label": "C",
            "value": "Dhaka Division"
        },
        {
            "label": "14",
            "value": "Dinajpur District"
        },
        {
            "label": "15",
            "value": "Faridpur District"
        },
        {
            "label": "16",
            "value": "Feni District"
        },
        {
            "label": "19",
            "value": "Gaibandha District"
        },
        {
            "label": "18",
            "value": "Gazipur District"
        },
        {
            "label": "17",
            "value": "Gopalganj District"
        },
        {
            "label": "20",
            "value": "Habiganj District"
        },
        {
            "label": "21",
            "value": "Jamalpur District"
        },
        {
            "label": "22",
            "value": "Jessore District"
        },
        {
            "label": "25",
            "value": "Jhalokati District"
        },
        {
            "label": "23",
            "value": "Jhenaidah District"
        },
        {
            "label": "24",
            "value": "Joypurhat District"
        },
        {
            "label": "29",
            "value": "Khagrachari District"
        },
        {
            "label": "27",
            "value": "Khulna District"
        },
        {
            "label": "D",
            "value": "Khulna Division"
        },
        {
            "label": "26",
            "value": "Kishoreganj District"
        },
        {
            "label": "28",
            "value": "Kurigram District"
        },
        {
            "label": "30",
            "value": "Kushtia District"
        },
        {
            "label": "31",
            "value": "Lakshmipur District"
        },
        {
            "label": "32",
            "value": "Lalmonirhat District"
        },
        {
            "label": "36",
            "value": "Madaripur District"
        },
        {
            "label": "39",
            "value": "Meherpur District"
        },
        {
            "label": "38",
            "value": "Moulvibazar District"
        },
        {
            "label": "35",
            "value": "Munshiganj District"
        },
        {
            "label": "34",
            "value": "Mymensingh District"
        },
        {
            "label": "H",
            "value": "Mymensingh Division"
        },
        {
            "label": "48",
            "value": "Naogaon District"
        },
        {
            "label": "43",
            "value": "Narail District"
        },
        {
            "label": "40",
            "value": "Narayanganj District"
        },
        {
            "label": "44",
            "value": "Natore District"
        },
        {
            "label": "41",
            "value": "Netrokona District"
        },
        {
            "label": "46",
            "value": "Nilphamari District"
        },
        {
            "label": "47",
            "value": "Noakhali District"
        },
        {
            "label": "49",
            "value": "Pabna District"
        },
        {
            "label": "52",
            "value": "Panchagarh District"
        },
        {
            "label": "51",
            "value": "Patuakhali District"
        },
        {
            "label": "50",
            "value": "Pirojpur District"
        },
        {
            "label": "53",
            "value": "Rajbari District"
        },
        {
            "label": "54",
            "value": "Rajshahi District"
        },
        {
            "label": "E",
            "value": "Rajshahi Division"
        },
        {
            "label": "56",
            "value": "Rangamati Hill District"
        },
        {
            "label": "55",
            "value": "Rangpur District"
        },
        {
            "label": "F",
            "value": "Rangpur Division"
        },
        {
            "label": "58",
            "value": "Satkhira District"
        },
        {
            "label": "62",
            "value": "Shariatpur District"
        },
        {
            "label": "57",
            "value": "Sherpur District"
        },
        {
            "label": "59",
            "value": "Sirajganj District"
        },
        {
            "label": "61",
            "value": "Sunamganj District"
        },
        {
            "label": "60",
            "value": "Sylhet District"
        },
        {
            "label": "G",
            "value": "Sylhet Division"
        },
        {
            "label": "63",
            "value": "Tangail District"
        },
        {
            "label": "64",
            "value": "Thakurgaon District"
        }
    ],
    "Barbados": [
        {
            "label": "01",
            "value": "Christ Church"
        },
        {
            "label": "02",
            "value": "Saint Andrew"
        },
        {
            "label": "03",
            "value": "Saint George"
        },
        {
            "label": "04",
            "value": "Saint James"
        },
        {
            "label": "05",
            "value": "Saint John"
        },
        {
            "label": "06",
            "value": "Saint Joseph"
        },
        {
            "label": "07",
            "value": "Saint Lucy"
        },
        {
            "label": "08",
            "value": "Saint Michael"
        },
        {
            "label": "09",
            "value": "Saint Peter"
        },
        {
            "label": "10",
            "value": "Saint Philip"
        },
        {
            "label": "11",
            "value": "Saint Thomas"
        }
    ],
    "Belarus": [
        {
            "label": "BR",
            "value": "Brest Region"
        },
        {
            "label": "HO",
            "value": "Gomel Region"
        },
        {
            "label": "HR",
            "value": "Grodno Region"
        },
        {
            "label": "HM",
            "value": "Minsk"
        },
        {
            "label": "MI",
            "value": "Minsk Region"
        },
        {
            "label": "MA",
            "value": "Mogilev Region"
        },
        {
            "label": "VI",
            "value": "Vitebsk Region"
        }
    ],
    "Belgium": [
        {
            "label": "VAN",
            "value": "Antwerp"
        },
        {
            "label": "BRU",
            "value": "Brussels-Capital Region"
        },
        {
            "label": "VOV",
            "value": "East Flanders"
        },
        {
            "label": "VLG",
            "value": "Flanders"
        },
        {
            "label": "VBR",
            "value": "Flemish Brabant"
        },
        {
            "label": "WHT",
            "value": "Hainaut"
        },
        {
            "label": "WLG",
            "value": "Liège"
        },
        {
            "label": "VLI",
            "value": "Limburg"
        },
        {
            "label": "WLX",
            "value": "Luxembourg"
        },
        {
            "label": "WNA",
            "value": "Namur"
        },
        {
            "label": "WAL",
            "value": "Wallonia"
        },
        {
            "label": "WBR",
            "value": "Walloon Brabant"
        },
        {
            "label": "VWV",
            "value": "West Flanders"
        }
    ],
    "Belize": [
        {
            "label": "BZ",
            "value": "Belize District"
        },
        {
            "label": "CY",
            "value": "Cayo District"
        },
        {
            "label": "CZL",
            "value": "Corozal District"
        },
        {
            "label": "OW",
            "value": "Orange Walk District"
        },
        {
            "label": "SC",
            "value": "Stann Creek District"
        },
        {
            "label": "TOL",
            "value": "Toledo District"
        }
    ],
    "Benin": [
        {
            "label": "AL",
            "value": "Alibori Department"
        },
        {
            "label": "AK",
            "value": "Atakora Department"
        },
        {
            "label": "AQ",
            "value": "Atlantique Department"
        },
        {
            "label": "BO",
            "value": "Borgou Department"
        },
        {
            "label": "CO",
            "value": "Collines Department"
        },
        {
            "label": "DO",
            "value": "Donga Department"
        },
        {
            "label": "KO",
            "value": "Kouffo Department"
        },
        {
            "label": "LI",
            "value": "Littoral Department"
        },
        {
            "label": "MO",
            "value": "Mono Department"
        },
        {
            "label": "OU",
            "value": "Ouémé Department"
        },
        {
            "label": "PL",
            "value": "Plateau Department"
        },
        {
            "label": "ZO",
            "value": "Zou Department"
        }
    ],
    "Bermuda": [
        {
            "label": "DEV",
            "value": "Devonshire Parish"
        },
        {
            "label": "HAM",
            "value": "Hamilton Municipality"
        },
        {
            "label": "HA",
            "value": "Hamilton Parish"
        },
        {
            "label": "PAG",
            "value": "Paget Parish"
        },
        {
            "label": "PEM",
            "value": "Pembroke Parish"
        },
        {
            "label": "SG",
            "value": "Saint George's Municipality"
        },
        {
            "label": "SGE",
            "value": "Saint George's Parish"
        },
        {
            "label": "SAN",
            "value": "Sandys Parish"
        },
        {
            "label": "SMI",
            "value": "Smith's Parish,"
        },
        {
            "label": "SOU",
            "value": "Southampton Parish"
        },
        {
            "label": "WAR",
            "value": "Warwick Parish"
        }
    ],
    "Bhutan": [
        {
            "label": "33",
            "value": "Bumthang District"
        },
        {
            "label": "12",
            "value": "Chukha District"
        },
        {
            "label": "22",
            "value": "Dagana District"
        },
        {
            "label": "GA",
            "value": "Gasa District"
        },
        {
            "label": "13",
            "value": "Haa District"
        },
        {
            "label": "44",
            "value": "Lhuntse District"
        },
        {
            "label": "42",
            "value": "Mongar District"
        },
        {
            "label": "11",
            "value": "Paro District"
        },
        {
            "label": "43",
            "value": "Pemagatshel District"
        },
        {
            "label": "23",
            "value": "Punakha District"
        },
        {
            "label": "45",
            "value": "Samdrup Jongkhar District"
        },
        {
            "label": "14",
            "value": "Samtse District"
        },
        {
            "label": "31",
            "value": "Sarpang District"
        },
        {
            "label": "15",
            "value": "Thimphu District"
        },
        {
            "label": "41",
            "value": "Trashigang District"
        },
        {
            "label": "32",
            "value": "Trongsa District"
        },
        {
            "label": "21",
            "value": "Tsirang District"
        },
        {
            "label": "24",
            "value": "Wangdue Phodrang District"
        },
        {
            "label": "34",
            "value": "Zhemgang District"
        }
    ],
    "Bolivia": [
        {
            "label": "B",
            "value": "Beni Department"
        },
        {
            "label": "H",
            "value": "Chuquisaca Department"
        },
        {
            "label": "C",
            "value": "Cochabamba Department"
        },
        {
            "label": "L",
            "value": "La Paz Department"
        },
        {
            "label": "O",
            "value": "Oruro Department"
        },
        {
            "label": "N",
            "value": "Pando Department"
        },
        {
            "label": "P",
            "value": "Potosí Department"
        },
        {
            "label": "S",
            "value": "Santa Cruz Department"
        },
        {
            "label": "T",
            "value": "Tarija Department"
        }
    ],
    "Bosnia and Herzegovina": [
        {
            "label": "05",
            "value": "Bosnian Podrinje Canton"
        },
        {
            "label": "BRC",
            "value": "Brčko District"
        },
        {
            "label": "10",
            "value": "Canton 10"
        },
        {
            "label": "06",
            "value": "Central Bosnia Canton"
        },
        {
            "label": "BIH",
            "value": "Federation of Bosnia and Herzegovina"
        },
        {
            "label": "07",
            "value": "Herzegovina-Neretva Canton"
        },
        {
            "label": "02",
            "value": "Posavina Canton"
        },
        {
            "label": "SRP",
            "value": "Republika Srpska"
        },
        {
            "label": "09",
            "value": "Sarajevo Canton"
        },
        {
            "label": "03",
            "value": "Tuzla Canton"
        },
        {
            "label": "01",
            "value": "Una-Sana Canton"
        },
        {
            "label": "08",
            "value": "West Herzegovina Canton"
        },
        {
            "label": "04",
            "value": "Zenica-Doboj Canton"
        }
    ],
    "Botswana": [
        {
            "label": "CE",
            "value": "Central District"
        },
        {
            "label": "GH",
            "value": "Ghanzi District"
        },
        {
            "label": "KG",
            "value": "Kgalagadi District"
        },
        {
            "label": "KL",
            "value": "Kgatleng District"
        },
        {
            "label": "KW",
            "value": "Kweneng District"
        },
        {
            "label": "NG",
            "value": "Ngamiland"
        },
        {
            "label": "NE",
            "value": "North-East District"
        },
        {
            "label": "NW",
            "value": "North-West District"
        },
        {
            "label": "SE",
            "value": "South-East District"
        },
        {
            "label": "SO",
            "value": "Southern District"
        }
    ],
    "Bouvet Island": [

    ],
    "Brazil": [
        {
            "label": "AC",
            "value": "Acre"
        },
        {
            "label": "AL",
            "value": "Alagoas"
        },
        {
            "label": "AP",
            "value": "Amapá"
        },
        {
            "label": "AM",
            "value": "Amazonas"
        },
        {
            "label": "BA",
            "value": "Bahia"
        },
        {
            "label": "CE",
            "value": "Ceará"
        },
        {
            "label": "ES",
            "value": "Espírito Santo"
        },
        {
            "label": "DF",
            "value": "Federal District"
        },
        {
            "label": "GO",
            "value": "Goiás"
        },
        {
            "label": "MA",
            "value": "Maranhão"
        },
        {
            "label": "MT",
            "value": "Mato Grosso"
        },
        {
            "label": "MS",
            "value": "Mato Grosso do Sul"
        },
        {
            "label": "MG",
            "value": "Minas Gerais"
        },
        {
            "label": "PA",
            "value": "Pará"
        },
        {
            "label": "PB",
            "value": "Paraíba"
        },
        {
            "label": "PR",
            "value": "Paraná"
        },
        {
            "label": "PE",
            "value": "Pernambuco"
        },
        {
            "label": "PI",
            "value": "Piauí"
        },
        {
            "label": "RJ",
            "value": "Rio de Janeiro"
        },
        {
            "label": "RN",
            "value": "Rio Grande do Norte"
        },
        {
            "label": "RS",
            "value": "Rio Grande do Sul"
        },
        {
            "label": "RO",
            "value": "Rondônia"
        },
        {
            "label": "RR",
            "value": "Roraima"
        },
        {
            "label": "SC",
            "value": "Santa Catarina"
        },
        {
            "label": "SP",
            "value": "São Paulo"
        },
        {
            "label": "SE",
            "value": "Sergipe"
        },
        {
            "label": "TO",
            "value": "Tocantins"
        }
    ],
    "British Indian Ocean Territory": [

    ],
    "Brunei": [
        {
            "label": "BE",
            "value": "Belait District"
        },
        {
            "label": "BM",
            "value": "Brunei-Muara District"
        },
        {
            "label": "TE",
            "value": "Temburong District"
        },
        {
            "label": "TU",
            "value": "Tutong District"
        }
    ],
    "Bulgaria": [
        {
            "label": "01",
            "value": "Blagoevgrad Province"
        },
        {
            "label": "02",
            "value": "Burgas Province"
        },
        {
            "label": "08",
            "value": "Dobrich Province"
        },
        {
            "label": "07",
            "value": "Gabrovo Province"
        },
        {
            "label": "26",
            "value": "Haskovo Province"
        },
        {
            "label": "09",
            "value": "Kardzhali Province"
        },
        {
            "label": "10",
            "value": "Kyustendil Province"
        },
        {
            "label": "11",
            "value": "Lovech Province"
        },
        {
            "label": "12",
            "value": "Montana Province"
        },
        {
            "label": "13",
            "value": "Pazardzhik Province"
        },
        {
            "label": "14",
            "value": "Pernik Province"
        },
        {
            "label": "15",
            "value": "Pleven Province"
        },
        {
            "label": "16",
            "value": "Plovdiv Province"
        },
        {
            "label": "17",
            "value": "Razgrad Province"
        },
        {
            "label": "18",
            "value": "Ruse Province"
        },
        {
            "label": "19",
            "value": "Silistra Province"
        },
        {
            "label": "20",
            "value": "Sliven Province"
        },
        {
            "label": "21",
            "value": "Smolyan Province"
        },
        {
            "label": "22",
            "value": "Sofia City Province"
        },
        {
            "label": "23",
            "value": "Sofia Province"
        },
        {
            "label": "24",
            "value": "Stara Zagora Province"
        },
        {
            "label": "25",
            "value": "Targovishte Province"
        },
        {
            "label": "03",
            "value": "Varna Province"
        },
        {
            "label": "04",
            "value": "Veliko Tarnovo Province"
        },
        {
            "label": "05",
            "value": "Vidin Province"
        },
        {
            "label": "06",
            "value": "Vratsa Province"
        },
        {
            "label": "28",
            "value": "Yambol Province"
        }
    ],
    "Burkina Faso": [
        {
            "label": "BAL",
            "value": "Balé Province"
        },
        {
            "label": "BAM",
            "value": "Bam Province"
        },
        {
            "label": "BAN",
            "value": "Banwa Province"
        },
        {
            "label": "BAZ",
            "value": "Bazèga Province"
        },
        {
            "label": "01",
            "value": "Boucle du Mouhoun Region"
        },
        {
            "label": "BGR",
            "value": "Bougouriba Province"
        },
        {
            "label": "BLG",
            "value": "Boulgou"
        },
        {
            "label": "02",
            "value": "Cascades Region"
        },
        {
            "label": "03",
            "value": "Centre"
        },
        {
            "label": "04",
            "value": "Centre-Est Region"
        },
        {
            "label": "05",
            "value": "Centre-Nord Region"
        },
        {
            "label": "06",
            "value": "Centre-Ouest Region"
        },
        {
            "label": "07",
            "value": "Centre-Sud Region"
        },
        {
            "label": "COM",
            "value": "Comoé Province"
        },
        {
            "label": "08",
            "value": "Est Region"
        },
        {
            "label": "GAN",
            "value": "Ganzourgou Province"
        },
        {
            "label": "GNA",
            "value": "Gnagna Province"
        },
        {
            "label": "GOU",
            "value": "Gourma Province"
        },
        {
            "label": "09",
            "value": "Hauts-Bassins Region"
        },
        {
            "label": "HOU",
            "value": "Houet Province"
        },
        {
            "label": "IOB",
            "value": "Ioba Province"
        },
        {
            "label": "KAD",
            "value": "Kadiogo Province"
        },
        {
            "label": "KEN",
            "value": "Kénédougou Province"
        },
        {
            "label": "KMD",
            "value": "Komondjari Province"
        },
        {
            "label": "KMP",
            "value": "Kompienga Province"
        },
        {
            "label": "KOS",
            "value": "Kossi Province"
        },
        {
            "label": "KOP",
            "value": "Koulpélogo Province"
        },
        {
            "label": "KOT",
            "value": "Kouritenga Province"
        },
        {
            "label": "KOW",
            "value": "Kourwéogo Province"
        },
        {
            "label": "LER",
            "value": "Léraba Province"
        },
        {
            "label": "LOR",
            "value": "Loroum Province"
        },
        {
            "label": "MOU",
            "value": "Mouhoun"
        },
        {
            "label": "NAO",
            "value": "Nahouri Province"
        },
        {
            "label": "NAM",
            "value": "Namentenga Province"
        },
        {
            "label": "NAY",
            "value": "Nayala Province"
        },
        {
            "label": "10",
            "value": "Nord Region, Burkina Faso"
        },
        {
            "label": "NOU",
            "value": "Noumbiel Province"
        },
        {
            "label": "OUB",
            "value": "Oubritenga Province"
        },
        {
            "label": "OUD",
            "value": "Oudalan Province"
        },
        {
            "label": "PAS",
            "value": "Passoré Province"
        },
        {
            "label": "11",
            "value": "Plateau-Central Region"
        },
        {
            "label": "PON",
            "value": "Poni Province"
        },
        {
            "label": "12",
            "value": "Sahel Region"
        },
        {
            "label": "SNG",
            "value": "Sanguié Province"
        },
        {
            "label": "SMT",
            "value": "Sanmatenga Province"
        },
        {
            "label": "SEN",
            "value": "Séno Province"
        },
        {
            "label": "SIS",
            "value": "Sissili Province"
        },
        {
            "label": "SOM",
            "value": "Soum Province"
        },
        {
            "label": "SOR",
            "value": "Sourou Province"
        },
        {
            "label": "13",
            "value": "Sud-Ouest Region"
        },
        {
            "label": "TAP",
            "value": "Tapoa Province"
        },
        {
            "label": "TUI",
            "value": "Tuy Province"
        },
        {
            "label": "YAG",
            "value": "Yagha Province"
        },
        {
            "label": "YAT",
            "value": "Yatenga Province"
        },
        {
            "label": "ZIR",
            "value": "Ziro Province"
        },
        {
            "label": "ZON",
            "value": "Zondoma Province"
        },
        {
            "label": "ZOU",
            "value": "Zoundwéogo Province"
        }
    ],
    "Burundi": [
        {
            "label": "BB",
            "value": "Bubanza Province"
        },
        {
            "label": "BM",
            "value": "Bujumbura Mairie Province"
        },
        {
            "label": "BL",
            "value": "Bujumbura Rural Province"
        },
        {
            "label": "BR",
            "value": "Bururi Province"
        },
        {
            "label": "CA",
            "value": "Cankuzo Province"
        },
        {
            "label": "CI",
            "value": "Cibitoke Province"
        },
        {
            "label": "GI",
            "value": "Gitega Province"
        },
        {
            "label": "KR",
            "value": "Karuzi Province"
        },
        {
            "label": "KY",
            "value": "Kayanza Province"
        },
        {
            "label": "KI",
            "value": "Kirundo Province"
        },
        {
            "label": "MA",
            "value": "Makamba Province"
        },
        {
            "label": "MU",
            "value": "Muramvya Province"
        },
        {
            "label": "MY",
            "value": "Muyinga Province"
        },
        {
            "label": "MW",
            "value": "Mwaro Province"
        },
        {
            "label": "NG",
            "value": "Ngozi Province"
        },
        {
            "label": "RM",
            "value": "Rumonge Province"
        },
        {
            "label": "RT",
            "value": "Rutana Province"
        },
        {
            "label": "RY",
            "value": "Ruyigi Province"
        }
    ],
    "Cambodia": [
        {
            "label": "1",
            "value": "Banteay Meanchey Province"
        },
        {
            "label": "2",
            "value": "Battambang Province"
        },
        {
            "label": "3",
            "value": "Kampong Cham Province"
        },
        {
            "label": "4",
            "value": "Kampong Chhnang Province"
        },
        {
            "label": "5",
            "value": "Kampong Speu Province"
        },
        {
            "label": "7",
            "value": "Kampot Province"
        },
        {
            "label": "8",
            "value": "Kandal Province"
        },
        {
            "label": "23",
            "value": "Kep Province"
        },
        {
            "label": "9",
            "value": "Koh Kong Province"
        },
        {
            "label": "10",
            "value": "Kratié Province"
        },
        {
            "label": "11",
            "value": "Mondulkiri Province"
        },
        {
            "label": "22",
            "value": "Oddar Meanchey Province"
        },
        {
            "label": "24",
            "value": "Pailin Province"
        },
        {
            "label": "12",
            "value": "Phnom Penh"
        },
        {
            "label": "13",
            "value": "Preah Vihear Province"
        },
        {
            "label": "14",
            "value": "Prey Veng Province"
        },
        {
            "label": "15",
            "value": "Pursat Province"
        },
        {
            "label": "16",
            "value": "Ratanakiri Province"
        },
        {
            "label": "17",
            "value": "Siem Reap Province"
        },
        {
            "label": "18",
            "value": "Sihanoukville Province"
        },
        {
            "label": "19",
            "value": "Stung Treng Province"
        },
        {
            "label": "20",
            "value": "Svay Rieng Province"
        },
        {
            "label": "21",
            "value": "Takéo Province"
        }
    ],
    "Cameroon": [
        {
            "label": "AD",
            "value": "Adamawa"
        },
        {
            "label": "CE",
            "value": "Centre"
        },
        {
            "label": "ES",
            "value": "East"
        },
        {
            "label": "EN",
            "value": "Far North"
        },
        {
            "label": "LT",
            "value": "Littoral"
        },
        {
            "label": "NO",
            "value": "North"
        },
        {
            "label": "NW",
            "value": "Northwest"
        },
        {
            "label": "SU",
            "value": "South"
        },
        {
            "label": "SW",
            "value": "Southwest"
        },
        {
            "label": "OU",
            "value": "West"
        }
    ],
    "Canada": [
        {
            "label": "AB",
            "value": "Alberta"
        },
        {
            "label": "BC",
            "value": "British Columbia"
        },
        {
            "label": "MB",
            "value": "Manitoba"
        },
        {
            "label": "NB",
            "value": "New Brunswick"
        },
        {
            "label": "NL",
            "value": "Newfoundland and Labrador"
        },
        {
            "label": "NT",
            "value": "Northwest Territories"
        },
        {
            "label": "NS",
            "value": "Nova Scotia"
        },
        {
            "label": "NU",
            "value": "Nunavut"
        },
        {
            "label": "ON",
            "value": "Ontario"
        },
        {
            "label": "PE",
            "value": "Prince Edward Island"
        },
        {
            "label": "QC",
            "value": "Quebec"
        },
        {
            "label": "SK",
            "value": "Saskatchewan"
        },
        {
            "label": "YT",
            "value": "Yukon"
        }
    ],
    "Cape Verde": [
        {
            "label": "B",
            "value": "Barlavento Islands"
        },
        {
            "label": "BV",
            "value": "Boa Vista"
        },
        {
            "label": "BR",
            "value": "Brava"
        },
        {
            "label": "MA",
            "value": "Maio Municipality"
        },
        {
            "label": "MO",
            "value": "Mosteiros"
        },
        {
            "label": "PA",
            "value": "Paul"
        },
        {
            "label": "PN",
            "value": "Porto Novo"
        },
        {
            "label": "PR",
            "value": "Praia"
        },
        {
            "label": "RB",
            "value": "Ribeira Brava Municipality"
        },
        {
            "label": "RG",
            "value": "Ribeira Grande"
        },
        {
            "label": "RS",
            "value": "Ribeira Grande de Santiago"
        },
        {
            "label": "SL",
            "value": "Sal"
        },
        {
            "label": "CA",
            "value": "Santa Catarina"
        },
        {
            "label": "CF",
            "value": "Santa Catarina do Fogo"
        },
        {
            "label": "CR",
            "value": "Santa Cruz"
        },
        {
            "label": "SD",
            "value": "São Domingos"
        },
        {
            "label": "SF",
            "value": "São Filipe"
        },
        {
            "label": "SO",
            "value": "São Lourenço dos Órgãos"
        },
        {
            "label": "SM",
            "value": "São Miguel"
        },
        {
            "label": "SV",
            "value": "São Vicente"
        },
        {
            "label": "S",
            "value": "Sotavento Islands"
        },
        {
            "label": "TA",
            "value": "Tarrafal"
        },
        {
            "label": "TS",
            "value": "Tarrafal de São Nicolau"
        }
    ],
    "Cayman Islands": [

    ],
    "Central African Republic": [
        {
            "label": "BB",
            "value": "Bamingui-Bangoran Prefecture"
        },
        {
            "label": "BGF",
            "value": "Bangui"
        },
        {
            "label": "BK",
            "value": "Basse-Kotto Prefecture"
        },
        {
            "label": "HM",
            "value": "Haut-Mbomou Prefecture"
        },
        {
            "label": "HK",
            "value": "Haute-Kotto Prefecture"
        },
        {
            "label": "KG",
            "value": "Kémo Prefecture"
        },
        {
            "label": "LB",
            "value": "Lobaye Prefecture"
        },
        {
            "label": "HS",
            "value": "Mambéré-Kadéï"
        },
        {
            "label": "MB",
            "value": "Mbomou Prefecture"
        },
        {
            "label": "KB",
            "value": "Nana-Grébizi Economic Prefecture"
        },
        {
            "label": "NM",
            "value": "Nana-Mambéré Prefecture"
        },
        {
            "label": "MP",
            "value": "Ombella-M'Poko Prefecture"
        },
        {
            "label": "UK",
            "value": "Ouaka Prefecture"
        },
        {
            "label": "AC",
            "value": "Ouham Prefecture"
        },
        {
            "label": "OP",
            "value": "Ouham-Pendé Prefecture"
        },
        {
            "label": "SE",
            "value": "Sangha-Mbaéré"
        },
        {
            "label": "VK",
            "value": "Vakaga Prefecture"
        }
    ],
    "Chad": [
        {
            "label": "BG",
            "value": "Bahr el Gazel"
        },
        {
            "label": "BA",
            "value": "Batha Region"
        },
        {
            "label": "BO",
            "value": "Borkou"
        },
        {
            "label": "EN",
            "value": "Ennedi Region"
        },
        {
            "label": "EE",
            "value": "Ennedi-Est"
        },
        {
            "label": "EO",
            "value": "Ennedi-Ouest"
        },
        {
            "label": "GR",
            "value": "Guéra Region"
        },
        {
            "label": "HL",
            "value": "Hadjer-Lamis"
        },
        {
            "label": "KA",
            "value": "Kanem Region"
        },
        {
            "label": "LC",
            "value": "Lac Region"
        },
        {
            "label": "LO",
            "value": "Logone Occidental Region"
        },
        {
            "label": "LR",
            "value": "Logone Oriental Region"
        },
        {
            "label": "MA",
            "value": "Mandoul Region"
        },
        {
            "label": "ME",
            "value": "Mayo-Kebbi Est Region"
        },
        {
            "label": "MO",
            "value": "Mayo-Kebbi Ouest Region"
        },
        {
            "label": "MC",
            "value": "Moyen-Chari Region"
        },
        {
            "label": "ND",
            "value": "N'Djamena"
        },
        {
            "label": "OD",
            "value": "Ouaddaï Region"
        },
        {
            "label": "SA",
            "value": "Salamat Region"
        },
        {
            "label": "SI",
            "value": "Sila Region"
        },
        {
            "label": "TA",
            "value": "Tandjilé Region"
        },
        {
            "label": "TI",
            "value": "Tibesti Region"
        },
        {
            "label": "WF",
            "value": "Wadi Fira Region"
        }
    ],
    "Chile": [
        {
            "label": "AN",
            "value": "Antofagasta Region"
        },
        {
            "label": "AR",
            "value": "Araucanía Region"
        },
        {
            "label": "AP",
            "value": "Arica y Parinacota Region"
        },
        {
            "label": "AT",
            "value": "Atacama Region"
        },
        {
            "label": "AI",
            "value": "Aysén Region"
        },
        {
            "label": "BI",
            "value": "Bío Bío Region"
        },
        {
            "label": "CO",
            "value": "Coquimbo Region"
        },
        {
            "label": "LL",
            "value": "Los Lagos Region"
        },
        {
            "label": "LR",
            "value": "Los Ríos Region"
        },
        {
            "label": "MA",
            "value": "Magellan and the Chilean Antarctic Region"
        },
        {
            "label": "ML",
            "value": "Maule Region"
        },
        {
            "label": "NB",
            "value": "Ñuble Region"
        },
        {
            "label": "LI",
            "value": "O'Higgins"
        },
        {
            "label": "RM",
            "value": "Santiago Metropolitan Region"
        },
        {
            "label": "TA",
            "value": "Tarapacá Region"
        },
        {
            "label": "VS",
            "value": "Valparaíso"
        }
    ],
    "China": [
        {
            "label": "AH",
            "value": "Anhui"
        },
        {
            "label": "BJ",
            "value": "Beijing"
        },
        {
            "label": "CQ",
            "value": "Chongqing"
        },
        {
            "label": "FJ",
            "value": "Fujian"
        },
        {
            "label": "GS",
            "value": "Gansu"
        },
        {
            "label": "GD",
            "value": "Guangdong"
        },
        {
            "label": "GX",
            "value": "Guangxi Zhuang Autonomous Region"
        },
        {
            "label": "GZ",
            "value": "Guizhou"
        },
        {
            "label": "HI",
            "value": "Hainan"
        },
        {
            "label": "HE",
            "value": "Hebei"
        },
        {
            "label": "HL",
            "value": "Heilongjiang"
        },
        {
            "label": "HA",
            "value": "Henan"
        },
        {
            "label": "HK",
            "value": "Hong Kong"
        },
        {
            "label": "HB",
            "value": "Hubei"
        },
        {
            "label": "HN",
            "value": "Hunan"
        },
        {
            "label": "NM",
            "value": "Inner Mongolia"
        },
        {
            "label": "JS",
            "value": "Jiangsu"
        },
        {
            "label": "JX",
            "value": "Jiangxi"
        },
        {
            "label": "JL",
            "value": "Jilin"
        },
        {
            "label": "TW-KEE",
            "value": "Keelung"
        },
        {
            "label": "LN",
            "value": "Liaoning"
        },
        {
            "label": "MO",
            "value": "Macau"
        },
        {
            "label": "NX",
            "value": "Ningxia Hui Autonomous Region"
        },
        {
            "label": "QH",
            "value": "Qinghai"
        },
        {
            "label": "SN",
            "value": "Shaanxi"
        },
        {
            "label": "SD",
            "value": "Shandong"
        },
        {
            "label": "SH",
            "value": "Shanghai"
        },
        {
            "label": "SX",
            "value": "Shanxi"
        },
        {
            "label": "SC",
            "value": "Sichuan"
        },
        {
            "label": "TW",
            "value": "Taiwan Province, People's Republic of China"
        },
        {
            "label": "XZ",
            "value": "Tibet Autonomous Region"
        },
        {
            "label": "XJ",
            "value": "Xinjiang"
        },
        {
            "label": "YN",
            "value": "Yunnan"
        },
        {
            "label": "ZJ",
            "value": "Zhejiang"
        }
    ],
    "Christmas Island": [

    ],
    "Cocos (Keeling) Islands": [

    ],
    "Colombia": [
        {
            "label": "AMA",
            "value": "Amazonas Department"
        },
        {
            "label": "ANT",
            "value": "Antioquia Department"
        },
        {
            "label": "ARA",
            "value": "Arauca Department"
        },
        {
            "label": "SAP",
            "value": "Archipelago of Saint Andréws, Providence and Saint Catalina"
        },
        {
            "label": "ATL",
            "value": "Atlántico Department"
        },
        {
            "label": "BOL",
            "value": "Bolívar Department"
        },
        {
            "label": "BOY",
            "value": "Boyacá Department"
        },
        {
            "label": "CAL",
            "value": "Caldas Department"
        },
        {
            "label": "CAQ",
            "value": "Caquetá Department"
        },
        {
            "label": "CAS",
            "value": "Casanare Department"
        },
        {
            "label": "CAU",
            "value": "Cauca Department"
        },
        {
            "label": "CES",
            "value": "Cesar Department"
        },
        {
            "label": "CHO",
            "value": "Chocó Department"
        },
        {
            "label": "COR",
            "value": "Córdoba Department"
        },
        {
            "label": "CUN",
            "value": "Cundinamarca Department"
        },
        {
            "label": "GUA",
            "value": "Guainía Department"
        },
        {
            "label": "GUV",
            "value": "Guaviare Department"
        },
        {
            "label": "HUI",
            "value": "Huila Department"
        },
        {
            "label": "LAG",
            "value": "La Guajira Department"
        },
        {
            "label": "MAG",
            "value": "Magdalena Department"
        },
        {
            "label": "MET",
            "value": "Meta"
        },
        {
            "label": "NAR",
            "value": "Nariño Department"
        },
        {
            "label": "NSA",
            "value": "Norte de Santander Department"
        },
        {
            "label": "PUT",
            "value": "Putumayo Department"
        },
        {
            "label": "QUI",
            "value": "Quindío Department"
        },
        {
            "label": "RIS",
            "value": "Risaralda Department"
        },
        {
            "label": "SAN",
            "value": "Santander Department"
        },
        {
            "label": "SUC",
            "value": "Sucre Department"
        },
        {
            "label": "TOL",
            "value": "Tolima Department"
        },
        {
            "label": "VAC",
            "value": "Valle del Cauca Department"
        },
        {
            "label": "VAU",
            "value": "Vaupés Department"
        },
        {
            "label": "VID",
            "value": "Vichada Department"
        }
    ],
    "Comoros": [
        {
            "label": "A",
            "value": "Anjouan"
        },
        {
            "label": "G",
            "value": "Grande Comore"
        },
        {
            "label": "M",
            "value": "Mohéli"
        }
    ],
    "Congo": [
        {
            "label": "11",
            "value": "Bouenza Department"
        },
        {
            "label": "BZV",
            "value": "Brazzaville"
        },
        {
            "label": "8",
            "value": "Cuvette Department"
        },
        {
            "label": "15",
            "value": "Cuvette-Ouest Department"
        },
        {
            "label": "5",
            "value": "Kouilou Department"
        },
        {
            "label": "2",
            "value": "Lékoumou Department"
        },
        {
            "label": "7",
            "value": "Likouala Department"
        },
        {
            "label": "9",
            "value": "Niari Department"
        },
        {
            "label": "14",
            "value": "Plateaux Department"
        },
        {
            "label": "16",
            "value": "Pointe-Noire"
        },
        {
            "label": "12",
            "value": "Pool Department"
        },
        {
            "label": "13",
            "value": "Sangha Department"
        }
    ],
    "Congo The Democratic Republic Of The": [
        {
            "label": "BN",
            "value": "Bandundu Province"
        },
        {
            "label": "BC",
            "value": "Bas-Congo province"
        },
        {
            "label": "BU",
            "value": "Bas-Uele"
        },
        {
            "label": "EQ",
            "value": "Équateur"
        },
        {
            "label": "HK",
            "value": "Haut-Katanga Province"
        },
        {
            "label": "HL",
            "value": "Haut-Lomami District"
        },
        {
            "label": "HU",
            "value": "Haut-Uele"
        },
        {
            "label": "IT",
            "value": "Ituri Interim Administration"
        },
        {
            "label": "KS",
            "value": "Kasaï District"
        },
        {
            "label": "KW",
            "value": "Kasaï-Occidental"
        },
        {
            "label": "KE",
            "value": "Kasaï-Oriental"
        },
        {
            "label": "KA",
            "value": "Katanga Province"
        },
        {
            "label": "KN",
            "value": "Kinshasa"
        },
        {
            "label": "KG",
            "value": "Kwango District"
        },
        {
            "label": "KL",
            "value": "Kwilu District"
        },
        {
            "label": "LO",
            "value": "Lomami Province"
        },
        {
            "label": "MN",
            "value": "Mai-Ndombe Province"
        },
        {
            "label": "MA",
            "value": "Maniema"
        },
        {
            "label": "MO",
            "value": "Mongala District"
        },
        {
            "label": "NU",
            "value": "Nord-Ubangi District"
        },
        {
            "label": "NK",
            "value": "North Kivu"
        },
        {
            "label": "OR",
            "value": "Orientale Province"
        },
        {
            "label": "SA",
            "value": "Sankuru District"
        },
        {
            "label": "SK",
            "value": "South Kivu"
        },
        {
            "label": "SU",
            "value": "Sud-Ubangi"
        },
        {
            "label": "TA",
            "value": "Tanganyika Province"
        },
        {
            "label": "TO",
            "value": "Tshopo District"
        },
        {
            "label": "TU",
            "value": "Tshuapa District"
        }
    ],
    "Cook Islands": [

    ],
    "Costa Rica": [
        {
            "label": "A",
            "value": "Alajuela Province"
        },
        {
            "label": "G",
            "value": "Guanacaste Province"
        },
        {
            "label": "H",
            "value": "Heredia Province"
        },
        {
            "label": "L",
            "value": "Limón Province"
        },
        {
            "label": "C",
            "value": "Provincia de Cartago"
        },
        {
            "label": "P",
            "value": "Puntarenas Province"
        },
        {
            "label": "SJ",
            "value": "San José Province"
        }
    ],
    "Cote D'Ivoire (Ivory Coast)": [
        {
            "label": "AB",
            "value": "Abidjan"
        },
        {
            "label": "16",
            "value": "Agnéby"
        },
        {
            "label": "17",
            "value": "Bafing Region"
        },
        {
            "label": "BS",
            "value": "Bas-Sassandra District"
        },
        {
            "label": "09",
            "value": "Bas-Sassandra Region"
        },
        {
            "label": "CM",
            "value": "Comoé District"
        },
        {
            "label": "DN",
            "value": "Denguélé District"
        },
        {
            "label": "10",
            "value": "Denguélé Region"
        },
        {
            "label": "06",
            "value": "Dix-Huit Montagnes"
        },
        {
            "label": "18",
            "value": "Fromager"
        },
        {
            "label": "GD",
            "value": "Gôh-Djiboua District"
        },
        {
            "label": "02",
            "value": "Haut-Sassandra"
        },
        {
            "label": "LC",
            "value": "Lacs District"
        },
        {
            "label": "07",
            "value": "Lacs Region"
        },
        {
            "label": "LG",
            "value": "Lagunes District"
        },
        {
            "label": "01",
            "value": "Lagunes region"
        },
        {
            "label": "12",
            "value": "Marahoué Region"
        },
        {
            "label": "MG",
            "value": "Montagnes District"
        },
        {
            "label": "19",
            "value": "Moyen-Cavally"
        },
        {
            "label": "05",
            "value": "Moyen-Comoé"
        },
        {
            "label": "11",
            "value": "N'zi-Comoé"
        },
        {
            "label": "SM",
            "value": "Sassandra-Marahoué District"
        },
        {
            "label": "03",
            "value": "Savanes Region"
        },
        {
            "label": "15",
            "value": "Sud-Bandama"
        },
        {
            "label": "13",
            "value": "Sud-Comoé"
        },
        {
            "label": "VB",
            "value": "Vallée du Bandama District"
        },
        {
            "label": "04",
            "value": "Vallée du Bandama Region"
        },
        {
            "label": "WR",
            "value": "Woroba District"
        },
        {
            "label": "14",
            "value": "Worodougou"
        },
        {
            "label": "YM",
            "value": "Yamoussoukro"
        },
        {
            "label": "ZZ",
            "value": "Zanzan Region"
        }
    ],
    "Croatia (Hrvatska)": [
        {
            "label": "07",
            "value": "Bjelovar-Bilogora County"
        },
        {
            "label": "12",
            "value": "Brod-Posavina County"
        },
        {
            "label": "19",
            "value": "Dubrovnik-Neretva County"
        },
        {
            "label": "18",
            "value": "Istria County"
        },
        {
            "label": "06",
            "value": "Koprivnica-Križevci County"
        },
        {
            "label": "02",
            "value": "Krapina-Zagorje County"
        },
        {
            "label": "09",
            "value": "Lika-Senj County"
        },
        {
            "label": "20",
            "value": "Međimurje County"
        },
        {
            "label": "14",
            "value": "Osijek-Baranja County"
        },
        {
            "label": "11",
            "value": "Požega-Slavonia County"
        },
        {
            "label": "08",
            "value": "Primorje-Gorski Kotar County"
        },
        {
            "label": "15",
            "value": "Šibenik-Knin County"
        },
        {
            "label": "03",
            "value": "Sisak-Moslavina County"
        },
        {
            "label": "17",
            "value": "Split-Dalmatia County"
        },
        {
            "label": "05",
            "value": "Varaždin County"
        },
        {
            "label": "10",
            "value": "Virovitica-Podravina County"
        },
        {
            "label": "16",
            "value": "Vukovar-Syrmia County"
        },
        {
            "label": "13",
            "value": "Zadar County"
        },
        {
            "label": "21",
            "value": "Zagreb"
        },
        {
            "label": "01",
            "value": "Zagreb County"
        }
    ],
    "Cuba": [
        {
            "label": "15",
            "value": "Artemisa Province"
        },
        {
            "label": "09",
            "value": "Camagüey Province"
        },
        {
            "label": "08",
            "value": "Ciego de Ávila Province"
        },
        {
            "label": "06",
            "value": "Cienfuegos Province"
        },
        {
            "label": "12",
            "value": "Granma Province"
        },
        {
            "label": "14",
            "value": "Guantánamo Province"
        },
        {
            "label": "03",
            "value": "Havana Province"
        },
        {
            "label": "11",
            "value": "Holguín Province"
        },
        {
            "label": "99",
            "value": "Isla de la Juventud"
        },
        {
            "label": "10",
            "value": "Las Tunas Province"
        },
        {
            "label": "04",
            "value": "Matanzas Province"
        },
        {
            "label": "16",
            "value": "Mayabeque Province"
        },
        {
            "label": "01",
            "value": "Pinar del Río Province"
        },
        {
            "label": "07",
            "value": "Sancti Spíritus Province"
        },
        {
            "label": "13",
            "value": "Santiago de Cuba Province"
        },
        {
            "label": "05",
            "value": "Villa Clara Province"
        }
    ],
    "Cyprus": [
        {
            "label": "04",
            "value": "Famagusta District"
        },
        {
            "label": "06",
            "value": "Kyrenia District"
        },
        {
            "label": "03",
            "value": "Larnaca District"
        },
        {
            "label": "02",
            "value": "Limassol District"
        },
        {
            "label": "01",
            "value": "Nicosia District"
        },
        {
            "label": "05",
            "value": "Paphos District"
        }
    ],
    "Czech Republic": [
        {
            "label": "201",
            "value": "Benešov District"
        },
        {
            "label": "202",
            "value": "Beroun District"
        },
        {
            "label": "641",
            "value": "Blansko District"
        },
        {
            "label": "644",
            "value": "Břeclav District"
        },
        {
            "label": "642",
            "value": "Brno-City District"
        },
        {
            "label": "643",
            "value": "Brno-Country District"
        },
        {
            "label": "801",
            "value": "Bruntál District"
        },
        {
            "label": "20",
            "value": "Central Bohemian Region"
        },
        {
            "label": "511",
            "value": "Česká Lípa District"
        },
        {
            "label": "311",
            "value": "České Budějovice District"
        },
        {
            "label": "312",
            "value": "Český Krumlov District"
        },
        {
            "label": "411",
            "value": "Cheb District"
        },
        {
            "label": "422",
            "value": "Chomutov District"
        },
        {
            "label": "531",
            "value": "Chrudim District"
        },
        {
            "label": "421",
            "value": "Děčín District"
        },
        {
            "label": "321",
            "value": "Domažlice District"
        },
        {
            "label": "802",
            "value": "Frýdek-Místek District"
        },
        {
            "label": "631",
            "value": "Havlíčkův Brod District"
        },
        {
            "label": "645",
            "value": "Hodonín District"
        },
        {
            "label": "120",
            "value": "Horní Počernice"
        },
        {
            "label": "521",
            "value": "Hradec Králové District"
        },
        {
            "label": "52",
            "value": "Hradec Králové Region"
        },
        {
            "label": "512",
            "value": "Jablonec nad Nisou District"
        },
        {
            "label": "711",
            "value": "Jeseník District"
        },
        {
            "label": "522",
            "value": "Jičín District"
        },
        {
            "label": "632",
            "value": "Jihlava District"
        },
        {
            "label": "313",
            "value": "Jindřichův Hradec District"
        },
        {
            "label": "412",
            "value": "Karlovy Vary District"
        },
        {
            "label": "41",
            "value": "Karlovy Vary Region"
        },
        {
            "label": "803",
            "value": "Karviná District"
        },
        {
            "label": "203",
            "value": "Kladno District"
        },
        {
            "label": "322",
            "value": "Klatovy District"
        },
        {
            "label": "204",
            "value": "Kolín District"
        },
        {
            "label": "721",
            "value": "Kroměříž District"
        },
        {
            "label": "513",
            "value": "Liberec District"
        },
        {
            "label": "51",
            "value": "Liberec Region"
        },
        {
            "label": "423",
            "value": "Litoměřice District"
        },
        {
            "label": "424",
            "value": "Louny District"
        },
        {
            "label": "206",
            "value": "Mělník District"
        },
        {
            "label": "207",
            "value": "Mladá Boleslav District"
        },
        {
            "label": "80",
            "value": "Moravian-Silesian Region"
        },
        {
            "label": "425",
            "value": "Most District"
        },
        {
            "label": "523",
            "value": "Náchod District"
        },
        {
            "label": "804",
            "value": "Nový Jičín District"
        },
        {
            "label": "208",
            "value": "Nymburk District"
        },
        {
            "label": "712",
            "value": "Olomouc District"
        },
        {
            "label": "71",
            "value": "Olomouc Region"
        },
        {
            "label": "805",
            "value": "Opava District"
        },
        {
            "label": "806",
            "value": "Ostrava-City District"
        },
        {
            "label": "532",
            "value": "Pardubice District"
        },
        {
            "label": "53",
            "value": "Pardubice Region"
        },
        {
            "label": "633",
            "value": "Pelhřimov District"
        },
        {
            "label": "314",
            "value": "Písek District"
        },
        {
            "label": "32",
            "value": "Plzeň Region"
        },
        {
            "label": "323",
            "value": "Plzeň-City District"
        },
        {
            "label": "325",
            "value": "Plzeň-North District"
        },
        {
            "label": "324",
            "value": "Plzeň-South District"
        },
        {
            "label": "315",
            "value": "Prachatice District"
        },
        {
            "label": "10",
            "value": "Prague"
        },
        {
            "label": "101",
            "value": "Prague 1"
        },
        {
            "label": "110",
            "value": "Prague 10"
        },
        {
            "label": "111",
            "value": "Prague 11"
        },
        {
            "label": "112",
            "value": "Prague 12"
        },
        {
            "label": "113",
            "value": "Prague 13"
        },
        {
            "label": "114",
            "value": "Prague 14"
        },
        {
            "label": "115",
            "value": "Prague 15"
        },
        {
            "label": "116",
            "value": "Prague 16"
        },
        {
            "label": "102",
            "value": "Prague 2"
        },
        {
            "label": "121",
            "value": "Prague 21"
        },
        {
            "label": "103",
            "value": "Prague 3"
        },
        {
            "label": "104",
            "value": "Prague 4"
        },
        {
            "label": "105",
            "value": "Prague 5"
        },
        {
            "label": "106",
            "value": "Prague 6"
        },
        {
            "label": "107",
            "value": "Prague 7"
        },
        {
            "label": "108",
            "value": "Prague 8"
        },
        {
            "label": "109",
            "value": "Prague 9"
        },
        {
            "label": "209",
            "value": "Prague-East District"
        },
        {
            "label": "20A",
            "value": "Prague-West District"
        },
        {
            "label": "714",
            "value": "Přerov District"
        },
        {
            "label": "20B",
            "value": "Příbram District"
        },
        {
            "label": "713",
            "value": "Prostějov District"
        },
        {
            "label": "20C",
            "value": "Rakovník District"
        },
        {
            "label": "326",
            "value": "Rokycany District"
        },
        {
            "label": "524",
            "value": "Rychnov nad Kněžnou District"
        },
        {
            "label": "514",
            "value": "Semily District"
        },
        {
            "label": "413",
            "value": "Sokolov District"
        },
        {
            "label": "31",
            "value": "South Bohemian Region"
        },
        {
            "label": "64",
            "value": "South Moravian Region"
        },
        {
            "label": "316",
            "value": "Strakonice District"
        },
        {
            "label": "715",
            "value": "Šumperk District"
        },
        {
            "label": "533",
            "value": "Svitavy District"
        },
        {
            "label": "317",
            "value": "Tábor District"
        },
        {
            "label": "327",
            "value": "Tachov District"
        },
        {
            "label": "426",
            "value": "Teplice District"
        },
        {
            "label": "634",
            "value": "Třebíč District"
        },
        {
            "label": "525",
            "value": "Trutnov District"
        },
        {
            "label": "722",
            "value": "Uherské Hradiště District"
        },
        {
            "label": "427",
            "value": "Ústí nad Labem District"
        },
        {
            "label": "42",
            "value": "Ústí nad Labem Region"
        },
        {
            "label": "534",
            "value": "Ústí nad Orlicí District"
        },
        {
            "label": "723",
            "value": "Vsetín District"
        },
        {
            "label": "646",
            "value": "Vyškov District"
        },
        {
            "label": "63",
            "value": "Vysočina Region"
        },
        {
            "label": "635",
            "value": "Žďár nad Sázavou District"
        },
        {
            "label": "724",
            "value": "Zlín District"
        },
        {
            "label": "72",
            "value": "Zlín Region"
        },
        {
            "label": "647",
            "value": "Znojmo District"
        }
    ],
    "Denmark": [
        {
            "label": "84",
            "value": "Capital Region of Denmark"
        },
        {
            "label": "82",
            "value": "Central Denmark Region"
        },
        {
            "label": "81",
            "value": "North Denmark Region"
        },
        {
            "label": "83",
            "value": "Region of Southern Denmark"
        },
        {
            "label": "85",
            "value": "Region Zealand"
        }
    ],
    "Djibouti": [
        {
            "label": "AS",
            "value": "Ali Sabieh Region"
        },
        {
            "label": "AR",
            "value": "Arta Region"
        },
        {
            "label": "DI",
            "value": "Dikhil Region"
        },
        {
            "label": "DJ",
            "value": "Djibouti"
        },
        {
            "label": "OB",
            "value": "Obock Region"
        },
        {
            "label": "TA",
            "value": "Tadjourah Region"
        }
    ],
    "Dominica": [
        {
            "label": "02",
            "value": "Saint Andrew Parish"
        },
        {
            "label": "03",
            "value": "Saint David Parish"
        },
        {
            "label": "04",
            "value": "Saint George Parish"
        },
        {
            "label": "05",
            "value": "Saint John Parish"
        },
        {
            "label": "06",
            "value": "Saint Joseph Parish"
        },
        {
            "label": "07",
            "value": "Saint Luke Parish"
        },
        {
            "label": "08",
            "value": "Saint Mark Parish"
        },
        {
            "label": "09",
            "value": "Saint Patrick Parish"
        },
        {
            "label": "10",
            "value": "Saint Paul Parish"
        },
        {
            "label": "11",
            "value": "Saint Peter Parish"
        }
    ],
    "Dominican Republic": [
        {
            "label": "02",
            "value": "Azua Province"
        },
        {
            "label": "03",
            "value": "Baoruco Province"
        },
        {
            "label": "04",
            "value": "Barahona Province"
        },
        {
            "label": "05",
            "value": "Dajabón Province"
        },
        {
            "label": "01",
            "value": "Distrito Nacional"
        },
        {
            "label": "06",
            "value": "Duarte Province"
        },
        {
            "label": "08",
            "value": "El Seibo Province"
        },
        {
            "label": "09",
            "value": "Espaillat Province"
        },
        {
            "label": "30",
            "value": "Hato Mayor Province"
        },
        {
            "label": "19",
            "value": "Hermanas Mirabal Province"
        },
        {
            "label": "10",
            "value": "Independencia"
        },
        {
            "label": "11",
            "value": "La Altagracia Province"
        },
        {
            "label": "12",
            "value": "La Romana Province"
        },
        {
            "label": "13",
            "value": "La Vega Province"
        },
        {
            "label": "14",
            "value": "María Trinidad Sánchez Province"
        },
        {
            "label": "28",
            "value": "Monseñor Nouel Province"
        },
        {
            "label": "15",
            "value": "Monte Cristi Province"
        },
        {
            "label": "29",
            "value": "Monte Plata Province"
        },
        {
            "label": "16",
            "value": "Pedernales Province"
        },
        {
            "label": "17",
            "value": "Peravia Province"
        },
        {
            "label": "18",
            "value": "Puerto Plata Province"
        },
        {
            "label": "20",
            "value": "Samaná Province"
        },
        {
            "label": "21",
            "value": "San Cristóbal Province"
        },
        {
            "label": "31",
            "value": "San José de Ocoa Province"
        },
        {
            "label": "22",
            "value": "San Juan Province"
        },
        {
            "label": "23",
            "value": "San Pedro de Macorís"
        },
        {
            "label": "24",
            "value": "Sánchez Ramírez Province"
        },
        {
            "label": "25",
            "value": "Santiago Province"
        },
        {
            "label": "26",
            "value": "Santiago Rodríguez Province"
        },
        {
            "label": "32",
            "value": "Santo Domingo Province"
        },
        {
            "label": "27",
            "value": "Valverde Province"
        }
    ],
    "East Timor": [
        {
            "label": "AL",
            "value": "Aileu municipality"
        },
        {
            "label": "AN",
            "value": "Ainaro Municipality"
        },
        {
            "label": "BA",
            "value": "Baucau Municipality"
        },
        {
            "label": "BO",
            "value": "Bobonaro Municipality"
        },
        {
            "label": "CO",
            "value": "Cova Lima Municipality"
        },
        {
            "label": "DI",
            "value": "Dili municipality"
        },
        {
            "label": "ER",
            "value": "Ermera District"
        },
        {
            "label": "LA",
            "value": "Lautém Municipality"
        },
        {
            "label": "LI",
            "value": "Liquiçá Municipality"
        },
        {
            "label": "MT",
            "value": "Manatuto District"
        },
        {
            "label": "MF",
            "value": "Manufahi Municipality"
        },
        {
            "label": "VI",
            "value": "Viqueque Municipality"
        }
    ],
    "Ecuador": [
        {
            "label": "A",
            "value": "Azuay Province"
        },
        {
            "label": "B",
            "value": "Bolívar Province"
        },
        {
            "label": "F",
            "value": "Cañar Province"
        },
        {
            "label": "C",
            "value": "Carchi Province"
        },
        {
            "label": "H",
            "value": "Chimborazo Province"
        },
        {
            "label": "X",
            "value": "Cotopaxi Province"
        },
        {
            "label": "O",
            "value": "El Oro Province"
        },
        {
            "label": "E",
            "value": "Esmeraldas"
        },
        {
            "label": "W",
            "value": "Galápagos Province"
        },
        {
            "label": "G",
            "value": "Guayas Province"
        },
        {
            "label": "I",
            "value": "Imbabura Province"
        },
        {
            "label": "R",
            "value": "Los Ríos Province"
        },
        {
            "label": "M",
            "value": "Manabí Province"
        },
        {
            "label": "S",
            "value": "Morona-Santiago Province"
        },
        {
            "label": "N",
            "value": "Napo Province"
        },
        {
            "label": "D",
            "value": "Orellana Province"
        },
        {
            "label": "Y",
            "value": "Pastaza Province"
        },
        {
            "label": "P",
            "value": "Pichincha Province"
        },
        {
            "label": "SE",
            "value": "Santa Elena Province"
        },
        {
            "label": "SD",
            "value": "Santo Domingo de los Tsáchilas Province"
        },
        {
            "label": "U",
            "value": "Sucumbíos Province"
        },
        {
            "label": "T",
            "value": "Tungurahua Province"
        },
        {
            "label": "Z",
            "value": "Zamora-Chinchipe Province"
        }
    ],
    "Egypt": [
        {
            "label": "ALX",
            "value": "Alexandria Governorate"
        },
        {
            "label": "ASN",
            "value": "Aswan Governorate"
        },
        {
            "label": "AST",
            "value": "Asyut Governorate"
        },
        {
            "label": "BH",
            "value": "Beheira Governorate"
        },
        {
            "label": "BNS",
            "value": "Beni Suef Governorate"
        },
        {
            "label": "C",
            "value": "Cairo Governorate"
        },
        {
            "label": "DK",
            "value": "Dakahlia Governorate"
        },
        {
            "label": "DT",
            "value": "Damietta Governorate"
        },
        {
            "label": "FYM",
            "value": "Faiyum Governorate"
        },
        {
            "label": "GH",
            "value": "Gharbia Governorate"
        },
        {
            "label": "GZ",
            "value": "Giza Governorate"
        },
        {
            "label": "IS",
            "value": "Ismailia Governorate"
        },
        {
            "label": "KFS",
            "value": "Kafr el-Sheikh Governorate"
        },
        {
            "label": "LX",
            "value": "Luxor Governorate"
        },
        {
            "label": "MT",
            "value": "Matrouh Governorate"
        },
        {
            "label": "MN",
            "value": "Minya Governorate"
        },
        {
            "label": "MNF",
            "value": "Monufia Governorate"
        },
        {
            "label": "WAD",
            "value": "New Valley Governorate"
        },
        {
            "label": "SIN",
            "value": "North Sinai Governorate"
        },
        {
            "label": "PTS",
            "value": "Port Said Governorate"
        },
        {
            "label": "KB",
            "value": "Qalyubia Governorate"
        },
        {
            "label": "KN",
            "value": "Qena Governorate"
        },
        {
            "label": "BA",
            "value": "Red Sea Governorate"
        },
        {
            "label": "SHG",
            "value": "Sohag Governorate"
        },
        {
            "label": "JS",
            "value": "South Sinai Governorate"
        },
        {
            "label": "SUZ",
            "value": "Suez Governorate"
        }
    ],
    "El Salvador": [
        {
            "label": "AH",
            "value": "Ahuachapán Department"
        },
        {
            "label": "CA",
            "value": "Cabañas Department"
        },
        {
            "label": "CH",
            "value": "Chalatenango Department"
        },
        {
            "label": "CU",
            "value": "Cuscatlán Department"
        },
        {
            "label": "LI",
            "value": "La Libertad Department"
        },
        {
            "label": "PA",
            "value": "La Paz Department"
        },
        {
            "label": "UN",
            "value": "La Unión Department"
        },
        {
            "label": "MO",
            "value": "Morazán Department"
        },
        {
            "label": "SM",
            "value": "San Miguel Department"
        },
        {
            "label": "SS",
            "value": "San Salvador Department"
        },
        {
            "label": "SV",
            "value": "San Vicente Department"
        },
        {
            "label": "SA",
            "value": "Santa Ana Department"
        },
        {
            "label": "SO",
            "value": "Sonsonate Department"
        },
        {
            "label": "US",
            "value": "Usulután Department"
        }
    ],
    "Equatorial Guinea": [
        {
            "label": "AN",
            "value": "Annobón Province"
        },
        {
            "label": "BN",
            "value": "Bioko Norte Province"
        },
        {
            "label": "BS",
            "value": "Bioko Sur Province"
        },
        {
            "label": "CS",
            "value": "Centro Sur Province"
        },
        {
            "label": "I",
            "value": "Insular Region"
        },
        {
            "label": "KN",
            "value": "Kié-Ntem Province"
        },
        {
            "label": "LI",
            "value": "Litoral Province"
        },
        {
            "label": "C",
            "value": "Río Muni"
        },
        {
            "label": "WN",
            "value": "Wele-Nzas Province"
        }
    ],
    "Eritrea": [
        {
            "label": "AN",
            "value": "Anseba Region"
        },
        {
            "label": "DU",
            "value": "Debub Region"
        },
        {
            "label": "GB",
            "value": "Gash-Barka Region"
        },
        {
            "label": "MA",
            "value": "Maekel Region"
        },
        {
            "label": "SK",
            "value": "Northern Red Sea Region"
        },
        {
            "label": "DK",
            "value": "Southern Red Sea Region"
        }
    ],
    "Estonia": [
        {
            "label": "37",
            "value": "Harju County"
        },
        {
            "label": "39",
            "value": "Hiiu County"
        },
        {
            "label": "44",
            "value": "Ida-Viru County"
        },
        {
            "label": "51",
            "value": "Järva County"
        },
        {
            "label": "49",
            "value": "Jõgeva County"
        },
        {
            "label": "57",
            "value": "Lääne County"
        },
        {
            "label": "59",
            "value": "Lääne-Viru County"
        },
        {
            "label": "67",
            "value": "Pärnu County"
        },
        {
            "label": "65",
            "value": "Põlva County"
        },
        {
            "label": "70",
            "value": "Rapla County"
        },
        {
            "label": "74",
            "value": "Saare County"
        },
        {
            "label": "78",
            "value": "Tartu County"
        },
        {
            "label": "82",
            "value": "Valga County"
        },
        {
            "label": "84",
            "value": "Viljandi County"
        },
        {
            "label": "86",
            "value": "Võru County"
        }
    ],
    "Ethiopia": [
        {
            "label": "AA",
            "value": "Addis Ababa"
        },
        {
            "label": "AF",
            "value": "Afar Region"
        },
        {
            "label": "AM",
            "value": "Amhara Region"
        },
        {
            "label": "BE",
            "value": "Benishangul-Gumuz Region"
        },
        {
            "label": "DD",
            "value": "Dire Dawa"
        },
        {
            "label": "GA",
            "value": "Gambela Region"
        },
        {
            "label": "HA",
            "value": "Harari Region"
        },
        {
            "label": "OR",
            "value": "Oromia Region"
        },
        {
            "label": "SO",
            "value": "Somali Region"
        },
        {
            "label": "SN",
            "value": "Southern Nations, Nationalities, and Peoples' Region"
        },
        {
            "label": "TI",
            "value": "Tigray Region"
        }
    ],
    "Falkland Islands": [

    ],
    "Faroe Islands": [

    ],
    "Fiji Islands": [
        {
            "label": "01",
            "value": "Ba"
        },
        {
            "label": "02",
            "value": "Bua"
        },
        {
            "label": "03",
            "value": "Cakaudrove"
        },
        {
            "label": "C",
            "value": "Central Division"
        },
        {
            "label": "E",
            "value": "Eastern Division"
        },
        {
            "label": "04",
            "value": "Kadavu"
        },
        {
            "label": "05",
            "value": "Lau"
        },
        {
            "label": "06",
            "value": "Lomaiviti"
        },
        {
            "label": "07",
            "value": "Macuata"
        },
        {
            "label": "08",
            "value": "Nadroga-Navosa"
        },
        {
            "label": "09",
            "value": "Naitasiri"
        },
        {
            "label": "10",
            "value": "Namosi"
        },
        {
            "label": "N",
            "value": "Northern Division"
        },
        {
            "label": "11",
            "value": "Ra"
        },
        {
            "label": "12",
            "value": "Rewa"
        },
        {
            "label": "R",
            "value": "Rotuma"
        },
        {
            "label": "13",
            "value": "Serua"
        },
        {
            "label": "14",
            "value": "Tailevu"
        },
        {
            "label": "W",
            "value": "Western Division"
        }
    ],
    "Finland": [
        {
            "label": "01",
            "value": "Åland Islands"
        },
        {
            "label": "08",
            "value": "Central Finland"
        },
        {
            "label": "07",
            "value": "Central Ostrobothnia"
        },
        {
            "label": "IS",
            "value": "Eastern Finland Province"
        },
        {
            "label": "19",
            "value": "Finland Proper"
        },
        {
            "label": "05",
            "value": "Kainuu"
        },
        {
            "label": "09",
            "value": "Kymenlaakso"
        },
        {
            "label": "LL",
            "value": "Lapland"
        },
        {
            "label": "13",
            "value": "North Karelia"
        },
        {
            "label": "14",
            "value": "Northern Ostrobothnia"
        },
        {
            "label": "15",
            "value": "Northern Savonia"
        },
        {
            "label": "12",
            "value": "Ostrobothnia"
        },
        {
            "label": "OL",
            "value": "Oulu Province"
        },
        {
            "label": "16",
            "value": "Päijänne Tavastia"
        },
        {
            "label": "11",
            "value": "Pirkanmaa"
        },
        {
            "label": "17",
            "value": "Satakunta"
        },
        {
            "label": "02",
            "value": "South Karelia"
        },
        {
            "label": "03",
            "value": "Southern Ostrobothnia"
        },
        {
            "label": "04",
            "value": "Southern Savonia"
        },
        {
            "label": "06",
            "value": "Tavastia Proper"
        },
        {
            "label": "18",
            "value": "Uusimaa"
        }
    ],
    "France": [
        {
            "label": "WF-AL",
            "value": "Alo"
        },
        {
            "label": "A",
            "value": "Alsace"
        },
        {
            "label": "B",
            "value": "Aquitaine"
        },
        {
            "label": "C",
            "value": "Auvergne"
        },
        {
            "label": "ARA",
            "value": "Auvergne-Rhône-Alpes"
        },
        {
            "label": "BFC",
            "value": "Bourgogne-Franche-Comté"
        },
        {
            "label": "BRE",
            "value": "Brittany"
        },
        {
            "label": "D",
            "value": "Burgundy"
        },
        {
            "label": "CVL",
            "value": "Centre-Val de Loire"
        },
        {
            "label": "G",
            "value": "Champagne-Ardenne"
        },
        {
            "label": "COR",
            "value": "Corsica"
        },
        {
            "label": "I",
            "value": "Franche-Comté"
        },
        {
            "label": "GF",
            "value": "French Guiana"
        },
        {
            "label": "PF",
            "value": "French Polynesia"
        },
        {
            "label": "GES",
            "value": "Grand Est"
        },
        {
            "label": "GP",
            "value": "Guadeloupe"
        },
        {
            "label": "HDF",
            "value": "Hauts-de-France"
        },
        {
            "label": "IDF",
            "value": "Île-de-France"
        },
        {
            "label": "K",
            "value": "Languedoc-Roussillon"
        },
        {
            "label": "L",
            "value": "Limousin"
        },
        {
            "label": "M",
            "value": "Lorraine"
        },
        {
            "label": "P",
            "value": "Lower Normandy"
        },
        {
            "label": "MQ",
            "value": "Martinique"
        },
        {
            "label": "YT",
            "value": "Mayotte"
        },
        {
            "label": "O",
            "value": "Nord-Pas-de-Calais"
        },
        {
            "label": "NOR",
            "value": "Normandy"
        },
        {
            "label": "NAQ",
            "value": "Nouvelle-Aquitaine"
        },
        {
            "label": "OCC",
            "value": "Occitania"
        },
        {
            "label": "75",
            "value": "Paris"
        },
        {
            "label": "PDL",
            "value": "Pays de la Loire"
        },
        {
            "label": "S",
            "value": "Picardy"
        },
        {
            "label": "T",
            "value": "Poitou-Charentes"
        },
        {
            "label": "PAC",
            "value": "Provence-Alpes-Côte d'Azur"
        },
        {
            "label": "RE",
            "value": "Réunion"
        },
        {
            "label": "V",
            "value": "Rhône-Alpes"
        },
        {
            "label": "BL",
            "value": "Saint Barthélemy"
        },
        {
            "label": "MF",
            "value": "Saint Martin"
        },
        {
            "label": "PM",
            "value": "Saint Pierre and Miquelon"
        },
        {
            "label": "WF-SG",
            "value": "Sigave"
        },
        {
            "label": "Q",
            "value": "Upper Normandy"
        },
        {
            "label": "WF-UV",
            "value": "Uvea"
        },
        {
            "label": "WF",
            "value": "Wallis and Futuna"
        }
    ],
    "French Guiana": [

    ],
    "French Polynesia": [

    ],
    "French Southern Territories": [

    ],
    "Gabon": [
        {
            "label": "1",
            "value": "Estuaire Province"
        },
        {
            "label": "2",
            "value": "Haut-Ogooué Province"
        },
        {
            "label": "3",
            "value": "Moyen-Ogooué Province"
        },
        {
            "label": "4",
            "value": "Ngounié Province"
        },
        {
            "label": "5",
            "value": "Nyanga Province"
        },
        {
            "label": "6",
            "value": "Ogooué-Ivindo Province"
        },
        {
            "label": "7",
            "value": "Ogooué-Lolo Province"
        },
        {
            "label": "8",
            "value": "Ogooué-Maritime Province"
        },
        {
            "label": "9",
            "value": "Woleu-Ntem Province"
        }
    ],
    "Gambia The": [
        {
            "label": "B",
            "value": "Banjul"
        },
        {
            "label": "M",
            "value": "Central River Division"
        },
        {
            "label": "L",
            "value": "Lower River Division"
        },
        {
            "label": "N",
            "value": "North Bank Division"
        },
        {
            "label": "U",
            "value": "Upper River Division"
        },
        {
            "label": "W",
            "value": "West Coast Division"
        }
    ],
    "Georgia": [
        {
            "label": "AJ",
            "value": "Adjara"
        },
        {
            "label": "AB",
            "value": "Autonomous Republic of Abkhazia"
        },
        {
            "label": "GU",
            "value": "Guria"
        },
        {
            "label": "IM",
            "value": "Imereti"
        },
        {
            "label": "KA",
            "value": "Kakheti"
        },
        {
            "label": "29",
            "value": "Khelvachauri Municipality"
        },
        {
            "label": "KK",
            "value": "Kvemo Kartli"
        },
        {
            "label": "MM",
            "value": "Mtskheta-Mtianeti"
        },
        {
            "label": "RL",
            "value": "Racha-Lechkhumi and Kvemo Svaneti"
        },
        {
            "label": "SZ",
            "value": "Samegrelo-Zemo Svaneti"
        },
        {
            "label": "SJ",
            "value": "Samtskhe-Javakheti"
        },
        {
            "label": "50",
            "value": "Senaki Municipality"
        },
        {
            "label": "SK",
            "value": "Shida Kartli"
        },
        {
            "label": "TB",
            "value": "Tbilisi"
        }
    ],
    "Germany": [
        {
            "label": "BW",
            "value": "Baden-Württemberg"
        },
        {
            "label": "BY",
            "value": "Bavaria"
        },
        {
            "label": "BE",
            "value": "Berlin"
        },
        {
            "label": "BB",
            "value": "Brandenburg"
        },
        {
            "label": "HB",
            "value": "Bremen"
        },
        {
            "label": "HH",
            "value": "Hamburg"
        },
        {
            "label": "HE",
            "value": "Hesse"
        },
        {
            "label": "NI",
            "value": "Lower Saxony"
        },
        {
            "label": "MV",
            "value": "Mecklenburg-Vorpommern"
        },
        {
            "label": "NW",
            "value": "North Rhine-Westphalia"
        },
        {
            "label": "RP",
            "value": "Rhineland-Palatinate"
        },
        {
            "label": "SL",
            "value": "Saarland"
        },
        {
            "label": "SN",
            "value": "Saxony"
        },
        {
            "label": "ST",
            "value": "Saxony-Anhalt"
        },
        {
            "label": "SH",
            "value": "Schleswig-Holstein"
        },
        {
            "label": "TH",
            "value": "Thuringia"
        }
    ],
    "Ghana": [
        {
            "label": "AH",
            "value": "Ashanti Region"
        },
        {
            "label": "BA",
            "value": "Brong-Ahafo Region"
        },
        {
            "label": "CP",
            "value": "Central Region"
        },
        {
            "label": "EP",
            "value": "Eastern Region"
        },
        {
            "label": "AA",
            "value": "Greater Accra Region"
        },
        {
            "label": "NP",
            "value": "Northern Region"
        },
        {
            "label": "UE",
            "value": "Upper East Region"
        },
        {
            "label": "UW",
            "value": "Upper West Region"
        },
        {
            "label": "TV",
            "value": "Volta Region"
        },
        {
            "label": "WP",
            "value": "Western Region"
        }
    ],
    "Gibraltar": [

    ],
    "Greece": [
        {
            "label": "13",
            "value": "Achaea Regional Unit"
        },
        {
            "label": "01",
            "value": "Aetolia-Acarnania Regional Unit"
        },
        {
            "label": "12",
            "value": "Arcadia Prefecture"
        },
        {
            "label": "11",
            "value": "Argolis Regional Unit"
        },
        {
            "label": "I",
            "value": "Attica Region"
        },
        {
            "label": "03",
            "value": "Boeotia Regional Unit"
        },
        {
            "label": "H",
            "value": "Central Greece Region"
        },
        {
            "label": "B",
            "value": "Central Macedonia"
        },
        {
            "label": "94",
            "value": "Chania Regional Unit"
        },
        {
            "label": "22",
            "value": "Corfu Prefecture"
        },
        {
            "label": "15",
            "value": "Corinthia Regional Unit"
        },
        {
            "label": "M",
            "value": "Crete Region"
        },
        {
            "label": "52",
            "value": "Drama Regional Unit"
        },
        {
            "label": "A2",
            "value": "East Attica Regional Unit"
        },
        {
            "label": "A",
            "value": "East Macedonia and Thrace"
        },
        {
            "label": "D",
            "value": "Epirus Region"
        },
        {
            "label": "04",
            "value": "Euboea"
        },
        {
            "label": "51",
            "value": "Grevena Prefecture"
        },
        {
            "label": "53",
            "value": "Imathia Regional Unit"
        },
        {
            "label": "33",
            "value": "Ioannina Regional Unit"
        },
        {
            "label": "F",
            "value": "Ionian Islands Region"
        },
        {
            "label": "41",
            "value": "Karditsa Regional Unit"
        },
        {
            "label": "56",
            "value": "Kastoria Regional Unit"
        },
        {
            "label": "23",
            "value": "Kefalonia Prefecture"
        },
        {
            "label": "57",
            "value": "Kilkis Regional Unit"
        },
        {
            "label": "58",
            "value": "Kozani Prefecture"
        },
        {
            "label": "16",
            "value": "Laconia"
        },
        {
            "label": "42",
            "value": "Larissa Prefecture"
        },
        {
            "label": "24",
            "value": "Lefkada Regional Unit"
        },
        {
            "label": "59",
            "value": "Pella Regional Unit"
        },
        {
            "label": "J",
            "value": "Peloponnese Region"
        },
        {
            "label": "06",
            "value": "Phthiotis Prefecture"
        },
        {
            "label": "34",
            "value": "Preveza Prefecture"
        },
        {
            "label": "62",
            "value": "Serres Prefecture"
        },
        {
            "label": "L",
            "value": "South Aegean"
        },
        {
            "label": "54",
            "value": "Thessaloniki Regional Unit"
        },
        {
            "label": "G",
            "value": "West Greece Region"
        },
        {
            "label": "C",
            "value": "West Macedonia Region"
        }
    ],
    "Greenland": [

    ],
    "Grenada": [
        {
            "label": "10",
            "value": "Carriacou and Petite Martinique"
        },
        {
            "label": "01",
            "value": "Saint Andrew Parish"
        },
        {
            "label": "02",
            "value": "Saint David Parish"
        },
        {
            "label": "03",
            "value": "Saint George Parish"
        },
        {
            "label": "04",
            "value": "Saint John Parish"
        },
        {
            "label": "05",
            "value": "Saint Mark Parish"
        },
        {
            "label": "06",
            "value": "Saint Patrick Parish"
        }
    ],
    "Guadeloupe": [

    ],
    "Guam": [

    ],
    "Guatemala": [
        {
            "label": "AV",
            "value": "Alta Verapaz Department"
        },
        {
            "label": "BV",
            "value": "Baja Verapaz Department"
        },
        {
            "label": "CM",
            "value": "Chimaltenango Department"
        },
        {
            "label": "CQ",
            "value": "Chiquimula Department"
        },
        {
            "label": "PR",
            "value": "El Progreso Department"
        },
        {
            "label": "ES",
            "value": "Escuintla Department"
        },
        {
            "label": "GU",
            "value": "Guatemala Department"
        },
        {
            "label": "HU",
            "value": "Huehuetenango Department"
        },
        {
            "label": "IZ",
            "value": "Izabal Department"
        },
        {
            "label": "JA",
            "value": "Jalapa Department"
        },
        {
            "label": "JU",
            "value": "Jutiapa Department"
        },
        {
            "label": "PE",
            "value": "Petén Department"
        },
        {
            "label": "QZ",
            "value": "Quetzaltenango Department"
        },
        {
            "label": "QC",
            "value": "Quiché Department"
        },
        {
            "label": "RE",
            "value": "Retalhuleu Department"
        },
        {
            "label": "SA",
            "value": "Sacatepéquez Department"
        },
        {
            "label": "SM",
            "value": "San Marcos Department"
        },
        {
            "label": "SR",
            "value": "Santa Rosa Department"
        },
        {
            "label": "SO",
            "value": "Sololá Department"
        },
        {
            "label": "SU",
            "value": "Suchitepéquez Department"
        },
        {
            "label": "TO",
            "value": "Totonicapán Department"
        }
    ],
    "Guernsey and Alderney": [

    ],
    "Guinea": [
        {
            "label": "BE",
            "value": "Beyla Prefecture"
        },
        {
            "label": "BF",
            "value": "Boffa Prefecture"
        },
        {
            "label": "BK",
            "value": "Boké Prefecture"
        },
        {
            "label": "B",
            "value": "Boké Region"
        },
        {
            "label": "C",
            "value": "Conakry"
        },
        {
            "label": "CO",
            "value": "Coyah Prefecture"
        },
        {
            "label": "DB",
            "value": "Dabola Prefecture"
        },
        {
            "label": "DL",
            "value": "Dalaba Prefecture"
        },
        {
            "label": "DI",
            "value": "Dinguiraye Prefecture"
        },
        {
            "label": "DU",
            "value": "Dubréka Prefecture"
        },
        {
            "label": "FA",
            "value": "Faranah Prefecture"
        },
        {
            "label": "FO",
            "value": "Forécariah Prefecture"
        },
        {
            "label": "FR",
            "value": "Fria Prefecture"
        },
        {
            "label": "GA",
            "value": "Gaoual Prefecture"
        },
        {
            "label": "GU",
            "value": "Guéckédou Prefecture"
        },
        {
            "label": "KA",
            "value": "Kankan Prefecture"
        },
        {
            "label": "K",
            "value": "Kankan Region"
        },
        {
            "label": "KE",
            "value": "Kérouané Prefecture"
        },
        {
            "label": "KD",
            "value": "Kindia Prefecture"
        },
        {
            "label": "D",
            "value": "Kindia Region"
        },
        {
            "label": "KS",
            "value": "Kissidougou Prefecture"
        },
        {
            "label": "KB",
            "value": "Koubia Prefecture"
        },
        {
            "label": "KN",
            "value": "Koundara Prefecture"
        },
        {
            "label": "KO",
            "value": "Kouroussa Prefecture"
        },
        {
            "label": "LA",
            "value": "Labé Prefecture"
        },
        {
            "label": "L",
            "value": "Labé Region"
        },
        {
            "label": "LE",
            "value": "Lélouma Prefecture"
        },
        {
            "label": "LO",
            "value": "Lola Prefecture"
        },
        {
            "label": "MC",
            "value": "Macenta Prefecture"
        },
        {
            "label": "ML",
            "value": "Mali Prefecture"
        },
        {
            "label": "MM",
            "value": "Mamou Prefecture"
        },
        {
            "label": "M",
            "value": "Mamou Region"
        },
        {
            "label": "MD",
            "value": "Mandiana Prefecture"
        },
        {
            "label": "NZ",
            "value": "Nzérékoré Prefecture"
        },
        {
            "label": "N",
            "value": "Nzérékoré Region"
        },
        {
            "label": "PI",
            "value": "Pita Prefecture"
        },
        {
            "label": "SI",
            "value": "Siguiri Prefecture"
        },
        {
            "label": "TE",
            "value": "Télimélé Prefecture"
        },
        {
            "label": "TO",
            "value": "Tougué Prefecture"
        },
        {
            "label": "YO",
            "value": "Yomou Prefecture"
        }
    ],
    "Guinea-Bissau": [
        {
            "label": "BA",
            "value": "Bafatá"
        },
        {
            "label": "BM",
            "value": "Biombo Region"
        },
        {
            "label": "BL",
            "value": "Bolama Region"
        },
        {
            "label": "CA",
            "value": "Cacheu Region"
        },
        {
            "label": "GA",
            "value": "Gabú Region"
        },
        {
            "label": "L",
            "value": "Leste Province"
        },
        {
            "label": "N",
            "value": "Norte Province"
        },
        {
            "label": "OI",
            "value": "Oio Region"
        },
        {
            "label": "QU",
            "value": "Quinara Region"
        },
        {
            "label": "S",
            "value": "Sul Province"
        },
        {
            "label": "TO",
            "value": "Tombali Region"
        }
    ],
    "Guyana": [
        {
            "label": "BA",
            "value": "Barima-Waini"
        },
        {
            "label": "CU",
            "value": "Cuyuni-Mazaruni"
        },
        {
            "label": "DE",
            "value": "Demerara-Mahaica"
        },
        {
            "label": "EB",
            "value": "East Berbice-Corentyne"
        },
        {
            "label": "ES",
            "value": "Essequibo Islands-West Demerara"
        },
        {
            "label": "MA",
            "value": "Mahaica-Berbice"
        },
        {
            "label": "PM",
            "value": "Pomeroon-Supenaam"
        },
        {
            "label": "PT",
            "value": "Potaro-Siparuni"
        },
        {
            "label": "UD",
            "value": "Upper Demerara-Berbice"
        },
        {
            "label": "UT",
            "value": "Upper Takutu-Upper Essequibo"
        }
    ],
    "Haiti": [
        {
            "label": "AR",
            "value": "Artibonite"
        },
        {
            "label": "CE",
            "value": "Centre"
        },
        {
            "label": "GA",
            "value": "Grand'Anse"
        },
        {
            "label": "NI",
            "value": "Nippes"
        },
        {
            "label": "ND",
            "value": "Nord"
        },
        {
            "label": "NE",
            "value": "Nord-Est"
        },
        {
            "label": "NO",
            "value": "Nord-Ouest"
        },
        {
            "label": "OU",
            "value": "Ouest"
        },
        {
            "label": "SD",
            "value": "Sud"
        },
        {
            "label": "SE",
            "value": "Sud-Est"
        }
    ],
    "Heard and McDonald Islands": [

    ],
    "Honduras": [
        {
            "label": "AT",
            "value": "Atlántida Department"
        },
        {
            "label": "IB",
            "value": "Bay Islands Department"
        },
        {
            "label": "CH",
            "value": "Choluteca Department"
        },
        {
            "label": "CL",
            "value": "Colón Department"
        },
        {
            "label": "CM",
            "value": "Comayagua Department"
        },
        {
            "label": "CP",
            "value": "Copán Department"
        },
        {
            "label": "CR",
            "value": "Cortés Department"
        },
        {
            "label": "EP",
            "value": "El Paraíso Department"
        },
        {
            "label": "FM",
            "value": "Francisco Morazán Department"
        },
        {
            "label": "GD",
            "value": "Gracias a Dios Department"
        },
        {
            "label": "IN",
            "value": "Intibucá Department"
        },
        {
            "label": "LP",
            "value": "La Paz Department"
        },
        {
            "label": "LE",
            "value": "Lempira Department"
        },
        {
            "label": "OC",
            "value": "Ocotepeque Department"
        },
        {
            "label": "OL",
            "value": "Olancho Department"
        },
        {
            "label": "SB",
            "value": "Santa Bárbara Department"
        },
        {
            "label": "VA",
            "value": "Valle Department"
        },
        {
            "label": "YO",
            "value": "Yoro Department"
        }
    ],
    "Hong Kong S.A.R.": [

    ],
    "Hungary": [
        {
            "label": "BK",
            "value": "Bács-Kiskun County"
        },
        {
            "label": "BA",
            "value": "Baranya County"
        },
        {
            "label": "BE",
            "value": "Békés County"
        },
        {
            "label": "BC",
            "value": "Békéscsaba"
        },
        {
            "label": "BZ",
            "value": "Borsod-Abaúj-Zemplén County"
        },
        {
            "label": "BU",
            "value": "Budapest"
        },
        {
            "label": "CS",
            "value": "Csongrád County"
        },
        {
            "label": "DE",
            "value": "Debrecen"
        },
        {
            "label": "DU",
            "value": "Dunaújváros"
        },
        {
            "label": "EG",
            "value": "Eger"
        },
        {
            "label": "ER",
            "value": "Érd"
        },
        {
            "label": "FE",
            "value": "Fejér County"
        },
        {
            "label": "GY",
            "value": "Győr"
        },
        {
            "label": "GS",
            "value": "Győr-Moson-Sopron County"
        },
        {
            "label": "HB",
            "value": "Hajdú-Bihar County"
        },
        {
            "label": "HE",
            "value": "Heves County"
        },
        {
            "label": "HV",
            "value": "Hódmezővásárhely"
        },
        {
            "label": "JN",
            "value": "Jász-Nagykun-Szolnok County"
        },
        {
            "label": "KV",
            "value": "Kaposvár"
        },
        {
            "label": "KM",
            "value": "Kecskemét"
        },
        {
            "label": "MI",
            "value": "Miskolc"
        },
        {
            "label": "NK",
            "value": "Nagykanizsa"
        },
        {
            "label": "NO",
            "value": "Nógrád County"
        },
        {
            "label": "NY",
            "value": "Nyíregyháza"
        },
        {
            "label": "PS",
            "value": "Pécs"
        },
        {
            "label": "PE",
            "value": "Pest County"
        },
        {
            "label": "ST",
            "value": "Salgótarján"
        },
        {
            "label": "SO",
            "value": "Somogy County"
        },
        {
            "label": "SN",
            "value": "Sopron"
        },
        {
            "label": "SZ",
            "value": "Szabolcs-Szatmár-Bereg County"
        },
        {
            "label": "SD",
            "value": "Szeged"
        },
        {
            "label": "SF",
            "value": "Székesfehérvár"
        },
        {
            "label": "SS",
            "value": "Szekszárd"
        },
        {
            "label": "SK",
            "value": "Szolnok"
        },
        {
            "label": "SH",
            "value": "Szombathely"
        },
        {
            "label": "TB",
            "value": "Tatabánya"
        },
        {
            "label": "TO",
            "value": "Tolna County"
        },
        {
            "label": "VA",
            "value": "Vas County"
        },
        {
            "label": "VM",
            "value": "Veszprém"
        },
        {
            "label": "VE",
            "value": "Veszprém County"
        },
        {
            "label": "ZA",
            "value": "Zala County"
        },
        {
            "label": "ZE",
            "value": "Zalaegerszeg"
        }
    ],
    "Iceland": [
        {
            "label": "1",
            "value": "Capital Region"
        },
        {
            "label": "7",
            "value": "Eastern Region"
        },
        {
            "label": "6",
            "value": "Northeastern Region"
        },
        {
            "label": "5",
            "value": "Northwestern Region"
        },
        {
            "label": "2",
            "value": "Southern Peninsula Region"
        },
        {
            "label": "8",
            "value": "Southern Region"
        },
        {
            "label": "3",
            "value": "Western Region"
        },
        {
            "label": "4",
            "value": "Westfjords"
        }
    ],
    "India": [
        {
            "label": "AN",
            "value": "Andaman and Nicobar Islands"
        },
        {
            "label": "AP",
            "value": "Andhra Pradesh"
        },
        {
            "label": "AR",
            "value": "Arunachal Pradesh"
        },
        {
            "label": "AS",
            "value": "Assam"
        },
        {
            "label": "BR",
            "value": "Bihar"
        },
        {
            "label": "CH",
            "value": "Chandigarh"
        },
        {
            "label": "CT",
            "value": "Chhattisgarh"
        },
        {
            "label": "DN",
            "value": "Dadra and Nagar Haveli"
        },
        {
            "label": "DD",
            "value": "Daman and Diu"
        },
        {
            "label": "DL",
            "value": "Delhi"
        },
        {
            "label": "GA",
            "value": "Goa"
        },
        {
            "label": "GJ",
            "value": "Gujarat"
        },
        {
            "label": "HR",
            "value": "Haryana"
        },
        {
            "label": "HP",
            "value": "Himachal Pradesh"
        },
        {
            "label": "JK",
            "value": "Jammu and Kashmir"
        },
        {
            "label": "JH",
            "value": "Jharkhand"
        },
        {
            "label": "KA",
            "value": "Karnataka"
        },
        {
            "label": "KL",
            "value": "Kerala"
        },
        {
            "label": "LA",
            "value": "Ladakh"
        },
        {
            "label": "LD",
            "value": "Lakshadweep"
        },
        {
            "label": "MP",
            "value": "Madhya Pradesh"
        },
        {
            "label": "MH",
            "value": "Maharashtra"
        },
        {
            "label": "MN",
            "value": "Manipur"
        },
        {
            "label": "ML",
            "value": "Meghalaya"
        },
        {
            "label": "MZ",
            "value": "Mizoram"
        },
        {
            "label": "NL",
            "value": "Nagaland"
        },
        {
            "label": "OR",
            "value": "Odisha"
        },
        {
            "label": "PY",
            "value": "Puducherry"
        },
        {
            "label": "PB",
            "value": "Punjab"
        },
        {
            "label": "RJ",
            "value": "Rajasthan"
        },
        {
            "label": "SK",
            "value": "Sikkim"
        },
        {
            "label": "TN",
            "value": "Tamil Nadu"
        },
        {
            "label": "TG",
            "value": "Telangana"
        },
        {
            "label": "TR",
            "value": "Tripura"
        },
        {
            "label": "UP",
            "value": "Uttar Pradesh"
        },
        {
            "label": "UT",
            "value": "Uttarakhand"
        },
        {
            "label": "WB",
            "value": "West Bengal"
        }
    ],
    "Indonesia": [
        {
            "label": "AC",
            "value": "Aceh"
        },
        {
            "label": "BA",
            "value": "Bali"
        },
        {
            "label": "BB",
            "value": "Bangka Belitung Islands"
        },
        {
            "label": "BT",
            "value": "Banten"
        },
        {
            "label": "BE",
            "value": "Bengkulu"
        },
        {
            "label": "JT",
            "value": "Central Java"
        },
        {
            "label": "KT",
            "value": "Central Kalimantan"
        },
        {
            "label": "ST",
            "value": "Central Sulawesi"
        },
        {
            "label": "JI",
            "value": "East Java"
        },
        {
            "label": "KI",
            "value": "East Kalimantan"
        },
        {
            "label": "NT",
            "value": "East Nusa Tenggara"
        },
        {
            "label": "GO",
            "value": "Gorontalo"
        },
        {
            "label": "JK",
            "value": "Jakarta"
        },
        {
            "label": "JA",
            "value": "Jambi"
        },
        {
            "label": "KA",
            "value": "Kalimantan"
        },
        {
            "label": "LA",
            "value": "Lampung"
        },
        {
            "label": "NU",
            "value": "Lesser Sunda Islands"
        },
        {
            "label": "MA",
            "value": "Maluku"
        },
        {
            "label": "ML",
            "value": "Maluku Islands"
        },
        {
            "label": "KU",
            "value": "North Kalimantan"
        },
        {
            "label": "MU",
            "value": "North Maluku"
        },
        {
            "label": "SA",
            "value": "North Sulawesi"
        },
        {
            "label": "SU",
            "value": "North Sumatra"
        },
        {
            "label": "PA",
            "value": "Papua"
        },
        {
            "label": "RI",
            "value": "Riau"
        },
        {
            "label": "KR",
            "value": "Riau Islands"
        },
        {
            "label": "KS",
            "value": "South Kalimantan"
        },
        {
            "label": "SN",
            "value": "South Sulawesi"
        },
        {
            "label": "SS",
            "value": "South Sumatra"
        },
        {
            "label": "SG",
            "value": "Southeast Sulawesi"
        },
        {
            "label": "YO",
            "value": "Special Region of Yogyakarta"
        },
        {
            "label": "SL",
            "value": "Sulawesi"
        },
        {
            "label": "SM",
            "value": "Sumatra"
        },
        {
            "label": "JB",
            "value": "West Java"
        },
        {
            "label": "NB",
            "value": "West Nusa Tenggara"
        },
        {
            "label": "PB",
            "value": "West Papua"
        },
        {
            "label": "SR",
            "value": "West Sulawesi"
        },
        {
            "label": "SB",
            "value": "West Sumatra"
        }
    ],
    "Iran": [
        {
            "label": "32",
            "value": "Alborz Province"
        },
        {
            "label": "03",
            "value": "Ardabil Province"
        },
        {
            "label": "06",
            "value": "Bushehr Province"
        },
        {
            "label": "08",
            "value": "Chaharmahal and Bakhtiari Province"
        },
        {
            "label": "01",
            "value": "East Azerbaijan Province"
        },
        {
            "label": "14",
            "value": "Fars Province"
        },
        {
            "label": "19",
            "value": "Gilan Province"
        },
        {
            "label": "27",
            "value": "Golestan Province"
        },
        {
            "label": "23",
            "value": "Hormozgan Province"
        },
        {
            "label": "05",
            "value": "Ilam Province"
        },
        {
            "label": "04",
            "value": "Isfahan Province"
        },
        {
            "label": "15",
            "value": "Kerman Province"
        },
        {
            "label": "17",
            "value": "Kermanshah Province"
        },
        {
            "label": "10",
            "value": "Khuzestan Province"
        },
        {
            "label": "18",
            "value": "Kohgiluyeh and Boyer-Ahmad Province"
        },
        {
            "label": "16",
            "value": "Kurdistan Province"
        },
        {
            "label": "20",
            "value": "Lorestan Province"
        },
        {
            "label": "22",
            "value": "Markazi Province"
        },
        {
            "label": "21",
            "value": "Mazandaran Province"
        },
        {
            "label": "31",
            "value": "North Khorasan Province"
        },
        {
            "label": "28",
            "value": "Qazvin Province"
        },
        {
            "label": "26",
            "value": "Qom Province"
        },
        {
            "label": "30",
            "value": "Razavi Khorasan Province"
        },
        {
            "label": "12",
            "value": "Semnan Province"
        },
        {
            "label": "13",
            "value": "Sistan and Baluchestan"
        },
        {
            "label": "29",
            "value": "South Khorasan Province"
        },
        {
            "label": "07",
            "value": "Tehran Province"
        },
        {
            "label": "02",
            "value": "West Azarbaijan Province"
        },
        {
            "label": "25",
            "value": "Yazd Province"
        },
        {
            "label": "11",
            "value": "Zanjan Province"
        }
    ],
    "Iraq": [
        {
            "label": "AN",
            "value": "Al Anbar Governorate"
        },
        {
            "label": "MU",
            "value": "Al Muthanna Governorate"
        },
        {
            "label": "QA",
            "value": "Al-Qādisiyyah Governorate"
        },
        {
            "label": "BB",
            "value": "Babylon Governorate"
        },
        {
            "label": "BG",
            "value": "Baghdad Governorate"
        },
        {
            "label": "BA",
            "value": "Basra Governorate"
        },
        {
            "label": "DQ",
            "value": "Dhi Qar Governorate"
        },
        {
            "label": "DI",
            "value": "Diyala Governorate"
        },
        {
            "label": "DA",
            "value": "Dohuk Governorate"
        },
        {
            "label": "AR",
            "value": "Erbil Governorate"
        },
        {
            "label": "KA",
            "value": "Karbala Governorate"
        },
        {
            "label": "KI",
            "value": "Kirkuk Governorate"
        },
        {
            "label": "MA",
            "value": "Maysan Governorate"
        },
        {
            "label": "NA",
            "value": "Najaf Governorate"
        },
        {
            "label": "NI",
            "value": "Nineveh Governorate"
        },
        {
            "label": "SD",
            "value": "Saladin Governorate"
        },
        {
            "label": "SU",
            "value": "Sulaymaniyah Governorate"
        },
        {
            "label": "WA",
            "value": "Wasit Governorate"
        }
    ],
    "Ireland": [
        {
            "label": "C",
            "value": "Connacht"
        },
        {
            "label": "CW",
            "value": "County Carlow"
        },
        {
            "label": "CN",
            "value": "County Cavan"
        },
        {
            "label": "CE",
            "value": "County Clare"
        },
        {
            "label": "CO",
            "value": "County Cork"
        },
        {
            "label": "DL",
            "value": "County Donegal"
        },
        {
            "label": "D",
            "value": "County Dublin"
        },
        {
            "label": "G",
            "value": "County Galway"
        },
        {
            "label": "KY",
            "value": "County Kerry"
        },
        {
            "label": "KE",
            "value": "County Kildare"
        },
        {
            "label": "KK",
            "value": "County Kilkenny"
        },
        {
            "label": "LS",
            "value": "County Laois"
        },
        {
            "label": "LK",
            "value": "County Limerick"
        },
        {
            "label": "LD",
            "value": "County Longford"
        },
        {
            "label": "LH",
            "value": "County Louth"
        },
        {
            "label": "MO",
            "value": "County Mayo"
        },
        {
            "label": "MH",
            "value": "County Meath"
        },
        {
            "label": "MN",
            "value": "County Monaghan"
        },
        {
            "label": "OY",
            "value": "County Offaly"
        },
        {
            "label": "RN",
            "value": "County Roscommon"
        },
        {
            "label": "SO",
            "value": "County Sligo"
        },
        {
            "label": "TA",
            "value": "County Tipperary"
        },
        {
            "label": "WD",
            "value": "County Waterford"
        },
        {
            "label": "WH",
            "value": "County Westmeath"
        },
        {
            "label": "WX",
            "value": "County Wexford"
        },
        {
            "label": "WW",
            "value": "County Wicklow"
        },
        {
            "label": "L",
            "value": "Leinster"
        },
        {
            "label": "M",
            "value": "Munster"
        },
        {
            "label": "U",
            "value": "Ulster"
        }
    ],
    "Israel": [
        {
            "label": "M",
            "value": "Central District"
        },
        {
            "label": "HA",
            "value": "Haifa District"
        },
        {
            "label": "JM",
            "value": "Jerusalem District"
        },
        {
            "label": "Z",
            "value": "Northern District"
        },
        {
            "label": "D",
            "value": "Southern District"
        },
        {
            "label": "TA",
            "value": "Tel Aviv District"
        }
    ],
    "Italy": [
        {
            "label": "65",
            "value": "Abruzzo"
        },
        {
            "label": "23",
            "value": "Aosta Valley"
        },
        {
            "label": "75",
            "value": "Apulia"
        },
        {
            "label": "77",
            "value": "Basilicata"
        },
        {
            "label": "BN",
            "value": "Benevento Province"
        },
        {
            "label": "78",
            "value": "Calabria"
        },
        {
            "label": "72",
            "value": "Campania"
        },
        {
            "label": "45",
            "value": "Emilia-Romagna"
        },
        {
            "label": "36",
            "value": "Friuli–Venezia Giulia"
        },
        {
            "label": "62",
            "value": "Lazio"
        },
        {
            "label": "AG",
            "value": "Libero consorzio comunale di Agrigento"
        },
        {
            "label": "CL",
            "value": "Libero consorzio comunale di Caltanissetta"
        },
        {
            "label": "EN",
            "value": "Libero consorzio comunale di Enna"
        },
        {
            "label": "RG",
            "value": "Libero consorzio comunale di Ragusa"
        },
        {
            "label": "SR",
            "value": "Libero consorzio comunale di Siracusa"
        },
        {
            "label": "TP",
            "value": "Libero consorzio comunale di Trapani"
        },
        {
            "label": "42",
            "value": "Liguria"
        },
        {
            "label": "25",
            "value": "Lombardy"
        },
        {
            "label": "57",
            "value": "Marche"
        },
        {
            "label": "BA",
            "value": "Metropolitan City of Bari"
        },
        {
            "label": "BO",
            "value": "Metropolitan City of Bologna"
        },
        {
            "label": "CA",
            "value": "Metropolitan City of Cagliari"
        },
        {
            "label": "CT",
            "value": "Metropolitan City of Catania"
        },
        {
            "label": "FI",
            "value": "Metropolitan City of Florence"
        },
        {
            "label": "GE",
            "value": "Metropolitan City of Genoa"
        },
        {
            "label": "ME",
            "value": "Metropolitan City of Messina"
        },
        {
            "label": "MI",
            "value": "Metropolitan City of Milan"
        },
        {
            "label": "NA",
            "value": "Metropolitan City of Naples"
        },
        {
            "label": "PA",
            "value": "Metropolitan City of Palermo"
        },
        {
            "label": "RC",
            "value": "Metropolitan City of Reggio Calabria"
        },
        {
            "label": "RM",
            "value": "Metropolitan City of Rome"
        },
        {
            "label": "TO",
            "value": "Metropolitan City of Turin"
        },
        {
            "label": "VE",
            "value": "Metropolitan City of Venice"
        },
        {
            "label": "67",
            "value": "Molise"
        },
        {
            "label": "PU",
            "value": "Pesaro and Urbino Province"
        },
        {
            "label": "21",
            "value": "Piedmont"
        },
        {
            "label": "AL",
            "value": "Province of Alessandria"
        },
        {
            "label": "AN",
            "value": "Province of Ancona"
        },
        {
            "label": "AP",
            "value": "Province of Ascoli Piceno"
        },
        {
            "label": "AT",
            "value": "Province of Asti"
        },
        {
            "label": "AV",
            "value": "Province of Avellino"
        },
        {
            "label": "BT",
            "value": "Province of Barletta-Andria-Trani"
        },
        {
            "label": "BL",
            "value": "Province of Belluno"
        },
        {
            "label": "BG",
            "value": "Province of Bergamo"
        },
        {
            "label": "BI",
            "value": "Province of Biella"
        },
        {
            "label": "BS",
            "value": "Province of Brescia"
        },
        {
            "label": "BR",
            "value": "Province of Brindisi"
        },
        {
            "label": "CB",
            "value": "Province of Campobasso"
        },
        {
            "label": "CI",
            "value": "Province of Carbonia-Iglesias"
        },
        {
            "label": "CE",
            "value": "Province of Caserta"
        },
        {
            "label": "CZ",
            "value": "Province of Catanzaro"
        },
        {
            "label": "CH",
            "value": "Province of Chieti"
        },
        {
            "label": "CO",
            "value": "Province of Como"
        },
        {
            "label": "CS",
            "value": "Province of Cosenza"
        },
        {
            "label": "CR",
            "value": "Province of Cremona"
        },
        {
            "label": "KR",
            "value": "Province of Crotone"
        },
        {
            "label": "CN",
            "value": "Province of Cuneo"
        },
        {
            "label": "FM",
            "value": "Province of Fermo"
        },
        {
            "label": "FE",
            "value": "Province of Ferrara"
        },
        {
            "label": "FG",
            "value": "Province of Foggia"
        },
        {
            "label": "FC",
            "value": "Province of Forlì-Cesena"
        },
        {
            "label": "FR",
            "value": "Province of Frosinone"
        },
        {
            "label": "GO",
            "value": "Province of Gorizia"
        },
        {
            "label": "GR",
            "value": "Province of Grosseto"
        },
        {
            "label": "IM",
            "value": "Province of Imperia"
        },
        {
            "label": "IS",
            "value": "Province of Isernia"
        },
        {
            "label": "AQ",
            "value": "Province of L'Aquila"
        },
        {
            "label": "SP",
            "value": "Province of La Spezia"
        },
        {
            "label": "LT",
            "value": "Province of Latina"
        },
        {
            "label": "LE",
            "value": "Province of Lecce"
        },
        {
            "label": "LC",
            "value": "Province of Lecco"
        },
        {
            "label": "LI",
            "value": "Province of Livorno"
        },
        {
            "label": "LO",
            "value": "Province of Lodi"
        },
        {
            "label": "LU",
            "value": "Province of Lucca"
        },
        {
            "label": "MC",
            "value": "Province of Macerata"
        },
        {
            "label": "MN",
            "value": "Province of Mantua"
        },
        {
            "label": "MS",
            "value": "Province of Massa and Carrara"
        },
        {
            "label": "MT",
            "value": "Province of Matera"
        },
        {
            "label": "VS",
            "value": "Province of Medio Campidano"
        },
        {
            "label": "MO",
            "value": "Province of Modena"
        },
        {
            "label": "MB",
            "value": "Province of Monza and Brianza"
        },
        {
            "label": "NO",
            "value": "Province of Novara"
        },
        {
            "label": "NU",
            "value": "Province of Nuoro"
        },
        {
            "label": "OG",
            "value": "Province of Ogliastra"
        },
        {
            "label": "OT",
            "value": "Province of Olbia-Tempio"
        },
        {
            "label": "OR",
            "value": "Province of Oristano"
        },
        {
            "label": "PD",
            "value": "Province of Padua"
        },
        {
            "label": "PR",
            "value": "Province of Parma"
        },
        {
            "label": "PV",
            "value": "Province of Pavia"
        },
        {
            "label": "PG",
            "value": "Province of Perugia"
        },
        {
            "label": "PE",
            "value": "Province of Pescara"
        },
        {
            "label": "PC",
            "value": "Province of Piacenza"
        },
        {
            "label": "PI",
            "value": "Province of Pisa"
        },
        {
            "label": "PT",
            "value": "Province of Pistoia"
        },
        {
            "label": "PN",
            "value": "Province of Pordenone"
        },
        {
            "label": "PZ",
            "value": "Province of Potenza"
        },
        {
            "label": "PO",
            "value": "Province of Prato"
        },
        {
            "label": "RA",
            "value": "Province of Ravenna"
        },
        {
            "label": "RE",
            "value": "Province of Reggio Emilia"
        },
        {
            "label": "RI",
            "value": "Province of Rieti"
        },
        {
            "label": "RN",
            "value": "Province of Rimini"
        },
        {
            "label": "RO",
            "value": "Province of Rovigo"
        },
        {
            "label": "SA",
            "value": "Province of Salerno"
        },
        {
            "label": "SS",
            "value": "Province of Sassari"
        },
        {
            "label": "SV",
            "value": "Province of Savona"
        },
        {
            "label": "SI",
            "value": "Province of Siena"
        },
        {
            "label": "SO",
            "value": "Province of Sondrio"
        },
        {
            "label": "TA",
            "value": "Province of Taranto"
        },
        {
            "label": "TE",
            "value": "Province of Teramo"
        },
        {
            "label": "TR",
            "value": "Province of Terni"
        },
        {
            "label": "TV",
            "value": "Province of Treviso"
        },
        {
            "label": "TS",
            "value": "Province of Trieste"
        },
        {
            "label": "UD",
            "value": "Province of Udine"
        },
        {
            "label": "VA",
            "value": "Province of Varese"
        },
        {
            "label": "VB",
            "value": "Province of Verbano-Cusio-Ossola"
        },
        {
            "label": "VC",
            "value": "Province of Vercelli"
        },
        {
            "label": "VR",
            "value": "Province of Verona"
        },
        {
            "label": "VV",
            "value": "Province of Vibo Valentia"
        },
        {
            "label": "VI",
            "value": "Province of Vicenza"
        },
        {
            "label": "VT",
            "value": "Province of Viterbo"
        },
        {
            "label": "88",
            "value": "Sardinia"
        },
        {
            "label": "82",
            "value": "Sicily"
        },
        {
            "label": "BZ",
            "value": "South Tyrol"
        },
        {
            "label": "TN",
            "value": "Trentino"
        },
        {
            "label": "32",
            "value": "Trentino-South Tyrol"
        },
        {
            "label": "52",
            "value": "Tuscany"
        },
        {
            "label": "55",
            "value": "Umbria"
        },
        {
            "label": "34",
            "value": "Veneto"
        }
    ],
    "Jamaica": [
        {
            "label": "13",
            "value": "Clarendon Parish"
        },
        {
            "label": "09",
            "value": "Hanover Parish"
        },
        {
            "label": "01",
            "value": "Kingston Parish"
        },
        {
            "label": "12",
            "value": "Manchester Parish"
        },
        {
            "label": "04",
            "value": "Portland Parish"
        },
        {
            "label": "02",
            "value": "Saint Andrew"
        },
        {
            "label": "06",
            "value": "Saint Ann Parish"
        },
        {
            "label": "14",
            "value": "Saint Catherine Parish"
        },
        {
            "label": "11",
            "value": "Saint Elizabeth Parish"
        },
        {
            "label": "08",
            "value": "Saint James Parish"
        },
        {
            "label": "05",
            "value": "Saint Mary Parish"
        },
        {
            "label": "03",
            "value": "Saint Thomas Parish"
        },
        {
            "label": "07",
            "value": "Trelawny Parish"
        },
        {
            "label": "10",
            "value": "Westmoreland Parish"
        }
    ],
    "Japan": [
        {
            "label": "23",
            "value": "Aichi Prefecture"
        },
        {
            "label": "05",
            "value": "Akita Prefecture"
        },
        {
            "label": "02",
            "value": "Aomori Prefecture"
        },
        {
            "label": "12",
            "value": "Chiba Prefecture"
        },
        {
            "label": "38",
            "value": "Ehime Prefecture"
        },
        {
            "label": "18",
            "value": "Fukui Prefecture"
        },
        {
            "label": "40",
            "value": "Fukuoka Prefecture"
        },
        {
            "label": "07",
            "value": "Fukushima Prefecture"
        },
        {
            "label": "21",
            "value": "Gifu Prefecture"
        },
        {
            "label": "10",
            "value": "Gunma Prefecture"
        },
        {
            "label": "34",
            "value": "Hiroshima Prefecture"
        },
        {
            "label": "01",
            "value": "Hokkaidō Prefecture"
        },
        {
            "label": "28",
            "value": "Hyōgo Prefecture"
        },
        {
            "label": "08",
            "value": "Ibaraki Prefecture"
        },
        {
            "label": "17",
            "value": "Ishikawa Prefecture"
        },
        {
            "label": "03",
            "value": "Iwate Prefecture"
        },
        {
            "label": "37",
            "value": "Kagawa Prefecture"
        },
        {
            "label": "46",
            "value": "Kagoshima Prefecture"
        },
        {
            "label": "14",
            "value": "Kanagawa Prefecture"
        },
        {
            "label": "43",
            "value": "Kumamoto Prefecture"
        },
        {
            "label": "26",
            "value": "Kyōto Prefecture"
        },
        {
            "label": "24",
            "value": "Mie Prefecture"
        },
        {
            "label": "04",
            "value": "Miyagi Prefecture"
        },
        {
            "label": "45",
            "value": "Miyazaki Prefecture"
        },
        {
            "label": "20",
            "value": "Nagano Prefecture"
        },
        {
            "label": "42",
            "value": "Nagasaki Prefecture"
        },
        {
            "label": "29",
            "value": "Nara Prefecture"
        },
        {
            "label": "15",
            "value": "Niigata Prefecture"
        },
        {
            "label": "44",
            "value": "Ōita Prefecture"
        },
        {
            "label": "33",
            "value": "Okayama Prefecture"
        },
        {
            "label": "47",
            "value": "Okinawa Prefecture"
        },
        {
            "label": "27",
            "value": "Ōsaka Prefecture"
        },
        {
            "label": "41",
            "value": "Saga Prefecture"
        },
        {
            "label": "11",
            "value": "Saitama Prefecture"
        },
        {
            "label": "25",
            "value": "Shiga Prefecture"
        },
        {
            "label": "32",
            "value": "Shimane Prefecture"
        },
        {
            "label": "22",
            "value": "Shizuoka Prefecture"
        },
        {
            "label": "09",
            "value": "Tochigi Prefecture"
        },
        {
            "label": "36",
            "value": "Tokushima Prefecture"
        },
        {
            "label": "13",
            "value": "Tokyo"
        },
        {
            "label": "31",
            "value": "Tottori Prefecture"
        },
        {
            "label": "16",
            "value": "Toyama Prefecture"
        },
        {
            "label": "30",
            "value": "Wakayama Prefecture"
        },
        {
            "label": "06",
            "value": "Yamagata Prefecture"
        },
        {
            "label": "35",
            "value": "Yamaguchi Prefecture"
        },
        {
            "label": "19",
            "value": "Yamanashi Prefecture"
        }
    ],
    "Jersey": [

    ],
    "Jordan": [
        {
            "label": "AJ",
            "value": "Ajloun Governorate"
        },
        {
            "label": "AM",
            "value": "Amman Governorate"
        },
        {
            "label": "AQ",
            "value": "Aqaba Governorate"
        },
        {
            "label": "BA",
            "value": "Balqa Governorate"
        },
        {
            "label": "IR",
            "value": "Irbid Governorate"
        },
        {
            "label": "JA",
            "value": "Jerash Governorate"
        },
        {
            "label": "KA",
            "value": "Karak Governorate"
        },
        {
            "label": "MN",
            "value": "Ma'an Governorate"
        },
        {
            "label": "MD",
            "value": "Madaba Governorate"
        },
        {
            "label": "MA",
            "value": "Mafraq Governorate"
        },
        {
            "label": "AT",
            "value": "Tafilah Governorate"
        },
        {
            "label": "AZ",
            "value": "Zarqa Governorate"
        }
    ],
    "Kazakhstan": [
        {
            "label": "AKM",
            "value": "Akmola Region"
        },
        {
            "label": "AKT",
            "value": "Aktobe Region"
        },
        {
            "label": "ALA",
            "value": "Almaty"
        },
        {
            "label": "ALM",
            "value": "Almaty Region"
        },
        {
            "label": "ATY",
            "value": "Atyrau Region"
        },
        {
            "label": "BAY",
            "value": "Baikonur"
        },
        {
            "label": "VOS",
            "value": "East Kazakhstan Region"
        },
        {
            "label": "ZHA",
            "value": "Jambyl Region"
        },
        {
            "label": "KAR",
            "value": "Karaganda Region"
        },
        {
            "label": "KUS",
            "value": "Kostanay Region"
        },
        {
            "label": "KZY",
            "value": "Kyzylorda Region"
        },
        {
            "label": "MAN",
            "value": "Mangystau Region"
        },
        {
            "label": "SEV",
            "value": "North Kazakhstan Region"
        },
        {
            "label": "AST",
            "value": "Nur-Sultan"
        },
        {
            "label": "PAV",
            "value": "Pavlodar Region"
        },
        {
            "label": "YUZ",
            "value": "Turkestan Region"
        },
        {
            "label": "ZAP",
            "value": "West Kazakhstan Province"
        }
    ],
    "Kenya": [
        {
            "label": "01",
            "value": "Baringo County"
        },
        {
            "label": "02",
            "value": "Bomet County"
        },
        {
            "label": "03",
            "value": "Bungoma County"
        },
        {
            "label": "04",
            "value": "Busia County"
        },
        {
            "label": "200",
            "value": "Central Province"
        },
        {
            "label": "300",
            "value": "Coast Province"
        },
        {
            "label": "400",
            "value": "Eastern Province"
        },
        {
            "label": "05",
            "value": "Elgeyo-Marakwet County"
        },
        {
            "label": "06",
            "value": "Embu County"
        },
        {
            "label": "07",
            "value": "Garissa County"
        },
        {
            "label": "08",
            "value": "Homa Bay County"
        },
        {
            "label": "09",
            "value": "Isiolo County"
        },
        {
            "label": "10",
            "value": "Kajiado County"
        },
        {
            "label": "11",
            "value": "Kakamega County"
        },
        {
            "label": "12",
            "value": "Kericho County"
        },
        {
            "label": "13",
            "value": "Kiambu County"
        },
        {
            "label": "14",
            "value": "Kilifi County"
        },
        {
            "label": "15",
            "value": "Kirinyaga County"
        },
        {
            "label": "16",
            "value": "Kisii County"
        },
        {
            "label": "17",
            "value": "Kisumu County"
        },
        {
            "label": "18",
            "value": "Kitui County"
        },
        {
            "label": "19",
            "value": "Kwale County"
        },
        {
            "label": "20",
            "value": "Laikipia County"
        },
        {
            "label": "21",
            "value": "Lamu County"
        },
        {
            "label": "22",
            "value": "Machakos County"
        },
        {
            "label": "23",
            "value": "Makueni County"
        },
        {
            "label": "24",
            "value": "Mandera County"
        },
        {
            "label": "25",
            "value": "Marsabit County"
        },
        {
            "label": "26",
            "value": "Meru County"
        },
        {
            "label": "27",
            "value": "Migori County"
        },
        {
            "label": "28",
            "value": "Mombasa County"
        },
        {
            "label": "29",
            "value": "Muranga County"
        },
        {
            "label": "110",
            "value": "Nairobi"
        },
        {
            "label": "31",
            "value": "Nakuru District"
        },
        {
            "label": "32",
            "value": "Nandi District"
        },
        {
            "label": "33",
            "value": "Narok County"
        },
        {
            "label": "500",
            "value": "North Eastern Province"
        },
        {
            "label": "34",
            "value": "Nyamira District"
        },
        {
            "label": "35",
            "value": "Nyandarua County"
        },
        {
            "label": "600",
            "value": "Nyanza Province"
        },
        {
            "label": "36",
            "value": "Nyeri County"
        },
        {
            "label": "700",
            "value": "Rift Valley Province"
        },
        {
            "label": "37",
            "value": "Samburu County"
        },
        {
            "label": "38",
            "value": "Siaya County"
        },
        {
            "label": "39",
            "value": "Taita–Taveta County"
        },
        {
            "label": "40",
            "value": "Tana River County"
        },
        {
            "label": "41",
            "value": "Tharaka Nithi County"
        },
        {
            "label": "42",
            "value": "Trans-Nzoia District"
        },
        {
            "label": "43",
            "value": "Turkana County"
        },
        {
            "label": "44",
            "value": "Uasin Gishu District"
        },
        {
            "label": "45",
            "value": "Vihiga District"
        },
        {
            "label": "46",
            "value": "Wajir County"
        },
        {
            "label": "47",
            "value": "West Pokot County"
        },
        {
            "label": "800",
            "value": "Western Province"
        }
    ],
    "Kiribati": [
        {
            "label": "G",
            "value": "Gilbert Islands"
        },
        {
            "label": "L",
            "value": "Line Islands"
        },
        {
            "label": "P",
            "value": "Phoenix Islands"
        }
    ],
    "Korea North": [
        {
            "label": "04",
            "value": "Chagang Province"
        },
        {
            "label": "07",
            "value": "Kangwon Province"
        },
        {
            "label": "09",
            "value": "North Hamgyong Province"
        },
        {
            "label": "06",
            "value": "North Hwanghae Province"
        },
        {
            "label": "03",
            "value": "North Pyongan Province"
        },
        {
            "label": "01",
            "value": "Pyongyang"
        },
        {
            "label": "13",
            "value": "Rason"
        },
        {
            "label": "10",
            "value": "Ryanggang Province"
        },
        {
            "label": "08",
            "value": "South Hamgyong Province"
        },
        {
            "label": "05",
            "value": "South Hwanghae Province"
        },
        {
            "label": "02",
            "value": "South Pyongan Province"
        }
    ],
    "Korea South": [
        {
            "label": "26",
            "value": "Busan"
        },
        {
            "label": "27",
            "value": "Daegu"
        },
        {
            "label": "30",
            "value": "Daejeon"
        },
        {
            "label": "42",
            "value": "Gangwon Province"
        },
        {
            "label": "29",
            "value": "Gwangju"
        },
        {
            "label": "41",
            "value": "Gyeonggi Province"
        },
        {
            "label": "28",
            "value": "Incheon"
        },
        {
            "label": "49",
            "value": "Jeju"
        },
        {
            "label": "43",
            "value": "North Chungcheong Province"
        },
        {
            "label": "47",
            "value": "North Gyeongsang Province"
        },
        {
            "label": "45",
            "value": "North Jeolla Province"
        },
        {
            "label": "50",
            "value": "Sejong City"
        },
        {
            "label": "11",
            "value": "Seoul"
        },
        {
            "label": "44",
            "value": "South Chungcheong Province"
        },
        {
            "label": "48",
            "value": "South Gyeongsang Province"
        },
        {
            "label": "46",
            "value": "South Jeolla Province"
        },
        {
            "label": "31",
            "value": "Ulsan"
        }
    ],
    "Kosovo": [
        {
            "label": null,
            "value": "Đakovica District (Gjakove)"
        },
        {
            "label": null,
            "value": "Gjilan District"
        },
        {
            "label": null,
            "value": "Kosovska Mitrovica District"
        },
        {
            "label": null,
            "value": "Peć District"
        },
        {
            "label": null,
            "value": "Pristina (Priştine)"
        },
        {
            "label": null,
            "value": "Prizren District"
        },
        {
            "label": null,
            "value": "Uroševac District (Ferizaj)"
        }
    ],
    "Kuwait": [
        {
            "label": "AH",
            "value": "Al Ahmadi Governorate"
        },
        {
            "label": "FA",
            "value": "Al Farwaniyah Governorate"
        },
        {
            "label": "JA",
            "value": "Al Jahra Governorate"
        },
        {
            "label": "KU",
            "value": "Capital Governorate"
        },
        {
            "label": "HA",
            "value": "Hawalli Governorate"
        },
        {
            "label": "MU",
            "value": "Mubarak Al-Kabeer Governorate"
        }
    ],
    "Kyrgyzstan": [
        {
            "label": "B",
            "value": "Batken Region"
        },
        {
            "label": "GB",
            "value": "Bishkek"
        },
        {
            "label": "C",
            "value": "Chuy Region"
        },
        {
            "label": "Y",
            "value": "Issyk-Kul Region"
        },
        {
            "label": "J",
            "value": "Jalal-Abad Region"
        },
        {
            "label": "N",
            "value": "Naryn Region"
        },
        {
            "label": "GO",
            "value": "Osh"
        },
        {
            "label": "O",
            "value": "Osh Region"
        },
        {
            "label": "T",
            "value": "Talas Region"
        }
    ],
    "Laos": [
        {
            "label": "AT",
            "value": "Attapeu Province"
        },
        {
            "label": "BK",
            "value": "Bokeo Province"
        },
        {
            "label": "BL",
            "value": "Bolikhamsai Province"
        },
        {
            "label": "CH",
            "value": "Champasak Province"
        },
        {
            "label": "HO",
            "value": "Houaphanh Province"
        },
        {
            "label": "KH",
            "value": "Khammouane Province"
        },
        {
            "label": "LM",
            "value": "Luang Namtha Province"
        },
        {
            "label": "LP",
            "value": "Luang Prabang Province"
        },
        {
            "label": "OU",
            "value": "Oudomxay Province"
        },
        {
            "label": "PH",
            "value": "Phongsaly Province"
        },
        {
            "label": "XA",
            "value": "Sainyabuli Province"
        },
        {
            "label": "SL",
            "value": "Salavan Province"
        },
        {
            "label": "SV",
            "value": "Savannakhet Province"
        },
        {
            "label": "XE",
            "value": "Sekong Province"
        },
        {
            "label": "VT",
            "value": "Vientiane Prefecture"
        },
        {
            "label": "VI",
            "value": "Vientiane Province"
        },
        {
            "label": "XN",
            "value": "Xaisomboun"
        },
        {
            "label": "XS",
            "value": "Xaisomboun Province"
        },
        {
            "label": "XI",
            "value": "Xiangkhouang Province"
        }
    ],
    "Latvia": [
        {
            "label": "001",
            "value": "Aglona Municipality"
        },
        {
            "label": "002",
            "value": "Aizkraukle Municipality"
        },
        {
            "label": "003",
            "value": "Aizpute Municipality"
        },
        {
            "label": "004",
            "value": "Aknīste Municipality"
        },
        {
            "label": "005",
            "value": "Aloja Municipality"
        },
        {
            "label": "006",
            "value": "Alsunga Municipality"
        },
        {
            "label": "007",
            "value": "Alūksne Municipality"
        },
        {
            "label": "008",
            "value": "Amata Municipality"
        },
        {
            "label": "009",
            "value": "Ape Municipality"
        },
        {
            "label": "010",
            "value": "Auce Municipality"
        },
        {
            "label": "012",
            "value": "Babīte Municipality"
        },
        {
            "label": "013",
            "value": "Baldone Municipality"
        },
        {
            "label": "014",
            "value": "Baltinava Municipality"
        },
        {
            "label": "015",
            "value": "Balvi Municipality"
        },
        {
            "label": "016",
            "value": "Bauska Municipality"
        },
        {
            "label": "017",
            "value": "Beverīna Municipality"
        },
        {
            "label": "018",
            "value": "Brocēni Municipality"
        },
        {
            "label": "019",
            "value": "Burtnieki Municipality"
        },
        {
            "label": "020",
            "value": "Carnikava Municipality"
        },
        {
            "label": "022",
            "value": "Cēsis Municipality"
        },
        {
            "label": "021",
            "value": "Cesvaine Municipality"
        },
        {
            "label": "023",
            "value": "Cibla Municipality"
        },
        {
            "label": "024",
            "value": "Dagda Municipality"
        },
        {
            "label": "DGV",
            "value": "Daugavpils"
        },
        {
            "label": "025",
            "value": "Daugavpils Municipality"
        },
        {
            "label": "026",
            "value": "Dobele Municipality"
        },
        {
            "label": "027",
            "value": "Dundaga Municipality"
        },
        {
            "label": "028",
            "value": "Durbe Municipality"
        },
        {
            "label": "029",
            "value": "Engure Municipality"
        },
        {
            "label": "030",
            "value": "Ērgļi Municipality"
        },
        {
            "label": "031",
            "value": "Garkalne Municipality"
        },
        {
            "label": "032",
            "value": "Grobiņa Municipality"
        },
        {
            "label": "033",
            "value": "Gulbene Municipality"
        },
        {
            "label": "034",
            "value": "Iecava Municipality"
        },
        {
            "label": "035",
            "value": "Ikšķile Municipality"
        },
        {
            "label": "036",
            "value": "Ilūkste Municipality"
        },
        {
            "label": "037",
            "value": "Inčukalns Municipality"
        },
        {
            "label": "038",
            "value": "Jaunjelgava Municipality"
        },
        {
            "label": "039",
            "value": "Jaunpiebalga Municipality"
        },
        {
            "label": "040",
            "value": "Jaunpils Municipality"
        },
        {
            "label": "JKB",
            "value": "Jēkabpils"
        },
        {
            "label": "042",
            "value": "Jēkabpils Municipality"
        },
        {
            "label": "JEL",
            "value": "Jelgava"
        },
        {
            "label": "041",
            "value": "Jelgava Municipality"
        },
        {
            "label": "JUR",
            "value": "Jūrmala"
        },
        {
            "label": "043",
            "value": "Kandava Municipality"
        },
        {
            "label": "044",
            "value": "Kārsava Municipality"
        },
        {
            "label": "051",
            "value": "Ķegums Municipality"
        },
        {
            "label": "052",
            "value": "Ķekava Municipality"
        },
        {
            "label": "045",
            "value": "Kocēni Municipality"
        },
        {
            "label": "046",
            "value": "Koknese Municipality"
        },
        {
            "label": "047",
            "value": "Krāslava Municipality"
        },
        {
            "label": "048",
            "value": "Krimulda Municipality"
        },
        {
            "label": "049",
            "value": "Krustpils Municipality"
        },
        {
            "label": "050",
            "value": "Kuldīga Municipality"
        },
        {
            "label": "053",
            "value": "Lielvārde Municipality"
        },
        {
            "label": "LPX",
            "value": "Liepāja"
        },
        {
            "label": "055",
            "value": "Līgatne Municipality"
        },
        {
            "label": "054",
            "value": "Limbaži Municipality"
        },
        {
            "label": "056",
            "value": "Līvāni Municipality"
        },
        {
            "label": "057",
            "value": "Lubāna Municipality"
        },
        {
            "label": "058",
            "value": "Ludza Municipality"
        },
        {
            "label": "059",
            "value": "Madona Municipality"
        },
        {
            "label": "061",
            "value": "Mālpils Municipality"
        },
        {
            "label": "062",
            "value": "Mārupe Municipality"
        },
        {
            "label": "060",
            "value": "Mazsalaca Municipality"
        },
        {
            "label": "063",
            "value": "Mērsrags Municipality"
        },
        {
            "label": "064",
            "value": "Naukšēni Municipality"
        },
        {
            "label": "065",
            "value": "Nereta Municipality"
        },
        {
            "label": "066",
            "value": "Nīca Municipality"
        },
        {
            "label": "067",
            "value": "Ogre Municipality"
        },
        {
            "label": "068",
            "value": "Olaine Municipality"
        },
        {
            "label": "069",
            "value": "Ozolnieki Municipality"
        },
        {
            "label": "070",
            "value": "Pārgauja Municipality"
        },
        {
            "label": "071",
            "value": "Pāvilosta Municipality"
        },
        {
            "label": "072",
            "value": "Pļaviņas Municipality"
        },
        {
            "label": "073",
            "value": "Preiļi Municipality"
        },
        {
            "label": "074",
            "value": "Priekule Municipality"
        },
        {
            "label": "075",
            "value": "Priekuļi Municipality"
        },
        {
            "label": "076",
            "value": "Rauna Municipality"
        },
        {
            "label": "REZ",
            "value": "Rēzekne"
        },
        {
            "label": "077",
            "value": "Rēzekne Municipality"
        },
        {
            "label": "078",
            "value": "Riebiņi Municipality"
        },
        {
            "label": "RIX",
            "value": "Riga"
        },
        {
            "label": "079",
            "value": "Roja Municipality"
        },
        {
            "label": "080",
            "value": "Ropaži Municipality"
        },
        {
            "label": "081",
            "value": "Rucava Municipality"
        },
        {
            "label": "082",
            "value": "Rugāji Municipality"
        },
        {
            "label": "084",
            "value": "Rūjiena Municipality"
        },
        {
            "label": "083",
            "value": "Rundāle Municipality"
        },
        {
            "label": "085",
            "value": "Sala Municipality"
        },
        {
            "label": "086",
            "value": "Salacgrīva Municipality"
        },
        {
            "label": "087",
            "value": "Salaspils Municipality"
        },
        {
            "label": "088",
            "value": "Saldus Municipality"
        },
        {
            "label": "089",
            "value": "Saulkrasti Municipality"
        },
        {
            "label": "090",
            "value": "Sēja Municipality"
        },
        {
            "label": "091",
            "value": "Sigulda Municipality"
        },
        {
            "label": "092",
            "value": "Skrīveri Municipality"
        },
        {
            "label": "093",
            "value": "Skrunda Municipality"
        },
        {
            "label": "094",
            "value": "Smiltene Municipality"
        },
        {
            "label": "095",
            "value": "Stopiņi Municipality"
        },
        {
            "label": "096",
            "value": "Strenči Municipality"
        },
        {
            "label": "097",
            "value": "Talsi Municipality"
        },
        {
            "label": "098",
            "value": "Tērvete Municipality"
        },
        {
            "label": "099",
            "value": "Tukums Municipality"
        },
        {
            "label": "100",
            "value": "Vaiņode Municipality"
        },
        {
            "label": "101",
            "value": "Valka Municipality"
        },
        {
            "label": "VMR",
            "value": "Valmiera"
        },
        {
            "label": "102",
            "value": "Varakļāni Municipality"
        },
        {
            "label": "103",
            "value": "Vārkava Municipality"
        },
        {
            "label": "104",
            "value": "Vecpiebalga Municipality"
        },
        {
            "label": "105",
            "value": "Vecumnieki Municipality"
        },
        {
            "label": "VEN",
            "value": "Ventspils"
        },
        {
            "label": "106",
            "value": "Ventspils Municipality"
        },
        {
            "label": "107",
            "value": "Viesīte Municipality"
        },
        {
            "label": "108",
            "value": "Viļaka Municipality"
        },
        {
            "label": "109",
            "value": "Viļāni Municipality"
        },
        {
            "label": "110",
            "value": "Zilupe Municipality"
        }
    ],
    "Lebanon": [
        {
            "label": "AK",
            "value": "Akkar Governorate"
        },
        {
            "label": "BH",
            "value": "Baalbek-Hermel Governorate"
        },
        {
            "label": "BA",
            "value": "Beirut Governorate"
        },
        {
            "label": "BI",
            "value": "Beqaa Governorate"
        },
        {
            "label": "JL",
            "value": "Mount Lebanon Governorate"
        },
        {
            "label": "NA",
            "value": "Nabatieh Governorate"
        },
        {
            "label": "AS",
            "value": "North Governorate"
        },
        {
            "label": "JA",
            "value": "South Governorate"
        }
    ],
    "Lesotho": [
        {
            "label": "D",
            "value": "Berea District"
        },
        {
            "label": "B",
            "value": "Butha-Buthe District"
        },
        {
            "label": "C",
            "value": "Leribe District"
        },
        {
            "label": "E",
            "value": "Mafeteng District"
        },
        {
            "label": "A",
            "value": "Maseru District"
        },
        {
            "label": "F",
            "value": "Mohale's Hoek District"
        },
        {
            "label": "J",
            "value": "Mokhotlong District"
        },
        {
            "label": "H",
            "value": "Qacha's Nek District"
        },
        {
            "label": "G",
            "value": "Quthing District"
        },
        {
            "label": "K",
            "value": "Thaba-Tseka District"
        }
    ],
    "Liberia": [
        {
            "label": "BM",
            "value": "Bomi County"
        },
        {
            "label": "BG",
            "value": "Bong County"
        },
        {
            "label": "GP",
            "value": "Gbarpolu County"
        },
        {
            "label": "GB",
            "value": "Grand Bassa County"
        },
        {
            "label": "CM",
            "value": "Grand Cape Mount County"
        },
        {
            "label": "GG",
            "value": "Grand Gedeh County"
        },
        {
            "label": "GK",
            "value": "Grand Kru County"
        },
        {
            "label": "LO",
            "value": "Lofa County"
        },
        {
            "label": "MG",
            "value": "Margibi County"
        },
        {
            "label": "MY",
            "value": "Maryland County"
        },
        {
            "label": "MO",
            "value": "Montserrado County"
        },
        {
            "label": "NI",
            "value": "Nimba"
        },
        {
            "label": "RI",
            "value": "River Cess County"
        },
        {
            "label": "RG",
            "value": "River Gee County"
        },
        {
            "label": "SI",
            "value": "Sinoe County"
        }
    ],
    "Libya": [
        {
            "label": "WA",
            "value": "Al Wahat District"
        },
        {
            "label": "BA",
            "value": "Benghazi"
        },
        {
            "label": "DR",
            "value": "Derna District"
        },
        {
            "label": "GT",
            "value": "Ghat District"
        },
        {
            "label": "JA",
            "value": "Jabal al Akhdar"
        },
        {
            "label": "JG",
            "value": "Jabal al Gharbi District"
        },
        {
            "label": "JI",
            "value": "Jafara"
        },
        {
            "label": "JU",
            "value": "Jufra"
        },
        {
            "label": "KF",
            "value": "Kufra District"
        },
        {
            "label": "MJ",
            "value": "Marj District"
        },
        {
            "label": "MI",
            "value": "Misrata District"
        },
        {
            "label": "MB",
            "value": "Murqub"
        },
        {
            "label": "MQ",
            "value": "Murzuq District"
        },
        {
            "label": "NL",
            "value": "Nalut District"
        },
        {
            "label": "NQ",
            "value": "Nuqat al Khams"
        },
        {
            "label": "SB",
            "value": "Sabha District"
        },
        {
            "label": "SR",
            "value": "Sirte District"
        },
        {
            "label": "TB",
            "value": "Tripoli District"
        },
        {
            "label": "WD",
            "value": "Wadi al Hayaa District"
        },
        {
            "label": "WS",
            "value": "Wadi al Shatii District"
        },
        {
            "label": "ZA",
            "value": "Zawiya District"
        }
    ],
    "Liechtenstein": [
        {
            "label": "01",
            "value": "Balzers"
        },
        {
            "label": "02",
            "value": "Eschen"
        },
        {
            "label": "03",
            "value": "Gamprin"
        },
        {
            "label": "04",
            "value": "Mauren"
        },
        {
            "label": "05",
            "value": "Planken"
        },
        {
            "label": "06",
            "value": "Ruggell"
        },
        {
            "label": "07",
            "value": "Schaan"
        },
        {
            "label": "08",
            "value": "Schellenberg"
        },
        {
            "label": "09",
            "value": "Triesen"
        },
        {
            "label": "10",
            "value": "Triesenberg"
        },
        {
            "label": "11",
            "value": "Vaduz"
        }
    ],
    "Lithuania": [
        {
            "label": "01",
            "value": "Akmenė District Municipality"
        },
        {
            "label": "02",
            "value": "Alytus City Municipality"
        },
        {
            "label": "AL",
            "value": "Alytus County"
        },
        {
            "label": "03",
            "value": "Alytus District Municipality"
        },
        {
            "label": "05",
            "value": "Birštonas Municipality"
        },
        {
            "label": "06",
            "value": "Biržai District Municipality"
        },
        {
            "label": "07",
            "value": "Druskininkai municipality"
        },
        {
            "label": "08",
            "value": "Elektrėnai municipality"
        },
        {
            "label": "09",
            "value": "Ignalina District Municipality"
        },
        {
            "label": "10",
            "value": "Jonava District Municipality"
        },
        {
            "label": "11",
            "value": "Joniškis District Municipality"
        },
        {
            "label": "12",
            "value": "Jurbarkas District Municipality"
        },
        {
            "label": "13",
            "value": "Kaišiadorys District Municipality"
        },
        {
            "label": "14",
            "value": "Kalvarija municipality"
        },
        {
            "label": "15",
            "value": "Kaunas City Municipality"
        },
        {
            "label": "KU",
            "value": "Kaunas County"
        },
        {
            "label": "16",
            "value": "Kaunas District Municipality"
        },
        {
            "label": "17",
            "value": "Kazlų Rūda municipality"
        },
        {
            "label": "18",
            "value": "Kėdainiai District Municipality"
        },
        {
            "label": "19",
            "value": "Kelmė District Municipality"
        },
        {
            "label": "20",
            "value": "Klaipeda City Municipality"
        },
        {
            "label": "KL",
            "value": "Klaipėda County"
        },
        {
            "label": "21",
            "value": "Klaipėda District Municipality"
        },
        {
            "label": "22",
            "value": "Kretinga District Municipality"
        },
        {
            "label": "23",
            "value": "Kupiškis District Municipality"
        },
        {
            "label": "24",
            "value": "Lazdijai District Municipality"
        },
        {
            "label": "MR",
            "value": "Marijampolė County"
        },
        {
            "label": "25",
            "value": "Marijampolė Municipality"
        },
        {
            "label": "26",
            "value": "Mažeikiai District Municipality"
        },
        {
            "label": "27",
            "value": "Molėtai District Municipality"
        },
        {
            "label": "28",
            "value": "Neringa Municipality"
        },
        {
            "label": "29",
            "value": "Pagėgiai municipality"
        },
        {
            "label": "30",
            "value": "Pakruojis District Municipality"
        },
        {
            "label": "31",
            "value": "Palanga City Municipality"
        },
        {
            "label": "32",
            "value": "Panevėžys City Municipality"
        },
        {
            "label": "PN",
            "value": "Panevėžys County"
        },
        {
            "label": "33",
            "value": "Panevėžys District Municipality"
        },
        {
            "label": "34",
            "value": "Pasvalys District Municipality"
        },
        {
            "label": "35",
            "value": "Plungė District Municipality"
        },
        {
            "label": "36",
            "value": "Prienai District Municipality"
        },
        {
            "label": "37",
            "value": "Radviliškis District Municipality"
        },
        {
            "label": "38",
            "value": "Raseiniai District Municipality"
        },
        {
            "label": "39",
            "value": "Rietavas municipality"
        },
        {
            "label": "40",
            "value": "Rokiškis District Municipality"
        },
        {
            "label": "41",
            "value": "Šakiai District Municipality"
        },
        {
            "label": "42",
            "value": "Šalčininkai District Municipality"
        },
        {
            "label": "43",
            "value": "Šiauliai City Municipality"
        },
        {
            "label": "SA",
            "value": "Šiauliai County"
        },
        {
            "label": "44",
            "value": "Šiauliai District Municipality"
        },
        {
            "label": "45",
            "value": "Šilalė District Municipality"
        },
        {
            "label": "46",
            "value": "Šilutė District Municipality"
        },
        {
            "label": "47",
            "value": "Širvintos District Municipality"
        },
        {
            "label": "48",
            "value": "Skuodas District Municipality"
        },
        {
            "label": "49",
            "value": "Švenčionys District Municipality"
        },
        {
            "label": "TA",
            "value": "Tauragė County"
        },
        {
            "label": "50",
            "value": "Tauragė District Municipality"
        },
        {
            "label": "TE",
            "value": "Telšiai County"
        },
        {
            "label": "51",
            "value": "Telšiai District Municipality"
        },
        {
            "label": "52",
            "value": "Trakai District Municipality"
        },
        {
            "label": "53",
            "value": "Ukmergė District Municipality"
        },
        {
            "label": "UT",
            "value": "Utena County"
        },
        {
            "label": "54",
            "value": "Utena District Municipality"
        },
        {
            "label": "55",
            "value": "Varėna District Municipality"
        },
        {
            "label": "56",
            "value": "Vilkaviškis District Municipality"
        },
        {
            "label": "57",
            "value": "Vilnius City Municipality"
        },
        {
            "label": "VL",
            "value": "Vilnius County"
        },
        {
            "label": "58",
            "value": "Vilnius District Municipality"
        },
        {
            "label": "59",
            "value": "Visaginas Municipality"
        },
        {
            "label": "60",
            "value": "Zarasai District Municipality"
        }
    ],
    "Luxembourg": [
        {
            "label": "CA",
            "value": "Canton of Capellen"
        },
        {
            "label": "CL",
            "value": "Canton of Clervaux"
        },
        {
            "label": "DI",
            "value": "Canton of Diekirch"
        },
        {
            "label": "EC",
            "value": "Canton of Echternach"
        },
        {
            "label": "ES",
            "value": "Canton of Esch-sur-Alzette"
        },
        {
            "label": "GR",
            "value": "Canton of Grevenmacher"
        },
        {
            "label": "LU",
            "value": "Canton of Luxembourg"
        },
        {
            "label": "ME",
            "value": "Canton of Mersch"
        },
        {
            "label": "RD",
            "value": "Canton of Redange"
        },
        {
            "label": "RM",
            "value": "Canton of Remich"
        },
        {
            "label": "VD",
            "value": "Canton of Vianden"
        },
        {
            "label": "WI",
            "value": "Canton of Wiltz"
        },
        {
            "label": "D",
            "value": "Diekirch District"
        },
        {
            "label": "G",
            "value": "Grevenmacher District"
        },
        {
            "label": "L",
            "value": "Luxembourg District"
        }
    ],
    "Macau S.A.R.": [

    ],
    "Macedonia": [
        {
            "label": "01",
            "value": "Aerodrom Municipality"
        },
        {
            "label": "02",
            "value": "Aračinovo Municipality"
        },
        {
            "label": "03",
            "value": "Berovo Municipality"
        },
        {
            "label": "04",
            "value": "Bitola Municipality"
        },
        {
            "label": "05",
            "value": "Bogdanci Municipality"
        },
        {
            "label": "06",
            "value": "Bogovinje Municipality"
        },
        {
            "label": "07",
            "value": "Bosilovo Municipality"
        },
        {
            "label": "08",
            "value": "Brvenica Municipality"
        },
        {
            "label": "09",
            "value": "Butel Municipality"
        },
        {
            "label": "79",
            "value": "Čair Municipality"
        },
        {
            "label": "80",
            "value": "Čaška Municipality"
        },
        {
            "label": "77",
            "value": "Centar Municipality"
        },
        {
            "label": "78",
            "value": "Centar Župa Municipality"
        },
        {
            "label": "81",
            "value": "Češinovo-Obleševo Municipality"
        },
        {
            "label": "82",
            "value": "Čučer-Sandevo Municipality"
        },
        {
            "label": "22",
            "value": "Debarca Municipality"
        },
        {
            "label": "23",
            "value": "Delčevo Municipality"
        },
        {
            "label": "25",
            "value": "Demir Hisar Municipality"
        },
        {
            "label": "24",
            "value": "Demir Kapija Municipality"
        },
        {
            "label": "26",
            "value": "Dojran Municipality"
        },
        {
            "label": "27",
            "value": "Dolneni Municipality"
        },
        {
            "label": "28",
            "value": "Drugovo Municipality"
        },
        {
            "label": "17",
            "value": "Gazi Baba Municipality"
        },
        {
            "label": "18",
            "value": "Gevgelija Municipality"
        },
        {
            "label": "29",
            "value": "Gjorče Petrov Municipality"
        },
        {
            "label": "19",
            "value": "Gostivar Municipality"
        },
        {
            "label": "20",
            "value": "Gradsko Municipality"
        },
        {
            "label": "85",
            "value": "Greater Skopje"
        },
        {
            "label": "34",
            "value": "Ilinden Municipality"
        },
        {
            "label": "35",
            "value": "Jegunovce Municipality"
        },
        {
            "label": "37",
            "value": "Karbinci"
        },
        {
            "label": "38",
            "value": "Karpoš Municipality"
        },
        {
            "label": "36",
            "value": "Kavadarci Municipality"
        },
        {
            "label": "40",
            "value": "Kičevo Municipality"
        },
        {
            "label": "39",
            "value": "Kisela Voda Municipality"
        },
        {
            "label": "42",
            "value": "Kočani Municipality"
        },
        {
            "label": "41",
            "value": "Konče Municipality"
        },
        {
            "label": "43",
            "value": "Kratovo Municipality"
        },
        {
            "label": "44",
            "value": "Kriva Palanka Municipality"
        },
        {
            "label": "45",
            "value": "Krivogaštani Municipality"
        },
        {
            "label": "46",
            "value": "Kruševo Municipality"
        },
        {
            "label": "47",
            "value": "Kumanovo Municipality"
        },
        {
            "label": "48",
            "value": "Lipkovo Municipality"
        },
        {
            "label": "49",
            "value": "Lozovo Municipality"
        },
        {
            "label": "51",
            "value": "Makedonska Kamenica Municipality"
        },
        {
            "label": "52",
            "value": "Makedonski Brod Municipality"
        },
        {
            "label": "50",
            "value": "Mavrovo and Rostuša Municipality"
        },
        {
            "label": "53",
            "value": "Mogila Municipality"
        },
        {
            "label": "54",
            "value": "Negotino Municipality"
        },
        {
            "label": "55",
            "value": "Novaci Municipality"
        },
        {
            "label": "56",
            "value": "Novo Selo Municipality"
        },
        {
            "label": "58",
            "value": "Ohrid Municipality"
        },
        {
            "label": "57",
            "value": "Oslomej Municipality"
        },
        {
            "label": "60",
            "value": "Pehčevo Municipality"
        },
        {
            "label": "59",
            "value": "Petrovec Municipality"
        },
        {
            "label": "61",
            "value": "Plasnica Municipality"
        },
        {
            "label": "62",
            "value": "Prilep Municipality"
        },
        {
            "label": "63",
            "value": "Probištip Municipality"
        },
        {
            "label": "64",
            "value": "Radoviš Municipality"
        },
        {
            "label": "65",
            "value": "Rankovce Municipality"
        },
        {
            "label": "66",
            "value": "Resen Municipality"
        },
        {
            "label": "67",
            "value": "Rosoman Municipality"
        },
        {
            "label": "68",
            "value": "Saraj Municipality"
        },
        {
            "label": "70",
            "value": "Sopište Municipality"
        },
        {
            "label": "71",
            "value": "Staro Nagoričane Municipality"
        },
        {
            "label": "83",
            "value": "Štip Municipality"
        },
        {
            "label": "72",
            "value": "Struga Municipality"
        },
        {
            "label": "73",
            "value": "Strumica Municipality"
        },
        {
            "label": "74",
            "value": "Studeničani Municipality"
        },
        {
            "label": "84",
            "value": "Šuto Orizari Municipality"
        },
        {
            "label": "69",
            "value": "Sveti Nikole Municipality"
        },
        {
            "label": "75",
            "value": "Tearce Municipality"
        },
        {
            "label": "76",
            "value": "Tetovo Municipality"
        },
        {
            "label": "10",
            "value": "Valandovo Municipality"
        },
        {
            "label": "11",
            "value": "Vasilevo Municipality"
        },
        {
            "label": "13",
            "value": "Veles Municipality"
        },
        {
            "label": "12",
            "value": "Vevčani Municipality"
        },
        {
            "label": "14",
            "value": "Vinica Municipality"
        },
        {
            "label": "15",
            "value": "Vraneštica Municipality"
        },
        {
            "label": "16",
            "value": "Vrapčište Municipality"
        },
        {
            "label": "31",
            "value": "Zajas Municipality"
        },
        {
            "label": "32",
            "value": "Zelenikovo Municipality"
        },
        {
            "label": "30",
            "value": "Želino Municipality"
        },
        {
            "label": "33",
            "value": "Zrnovci Municipality"
        }
    ],
    "Madagascar": [
        {
            "label": "T",
            "value": "Antananarivo Province"
        },
        {
            "label": "D",
            "value": "Antsiranana Province"
        },
        {
            "label": "F",
            "value": "Fianarantsoa Province"
        },
        {
            "label": "M",
            "value": "Mahajanga Province"
        },
        {
            "label": "A",
            "value": "Toamasina Province"
        },
        {
            "label": "U",
            "value": "Toliara Province"
        }
    ],
    "Malawi": [
        {
            "label": "BA",
            "value": "Balaka District"
        },
        {
            "label": "BL",
            "value": "Blantyre District"
        },
        {
            "label": "C",
            "value": "Central Region"
        },
        {
            "label": "CK",
            "value": "Chikwawa District"
        },
        {
            "label": "CR",
            "value": "Chiradzulu District"
        },
        {
            "label": "CT",
            "value": "Chitipa district"
        },
        {
            "label": "DE",
            "value": "Dedza District"
        },
        {
            "label": "DO",
            "value": "Dowa District"
        },
        {
            "label": "KR",
            "value": "Karonga District"
        },
        {
            "label": "KS",
            "value": "Kasungu District"
        },
        {
            "label": "LK",
            "value": "Likoma District"
        },
        {
            "label": "LI",
            "value": "Lilongwe District"
        },
        {
            "label": "MH",
            "value": "Machinga District"
        },
        {
            "label": "MG",
            "value": "Mangochi District"
        },
        {
            "label": "MC",
            "value": "Mchinji District"
        },
        {
            "label": "MU",
            "value": "Mulanje District"
        },
        {
            "label": "MW",
            "value": "Mwanza District"
        },
        {
            "label": "MZ",
            "value": "Mzimba District"
        },
        {
            "label": "NB",
            "value": "Nkhata Bay District"
        },
        {
            "label": "NK",
            "value": "Nkhotakota District"
        },
        {
            "label": "N",
            "value": "Northern Region"
        },
        {
            "label": "NS",
            "value": "Nsanje District"
        },
        {
            "label": "NU",
            "value": "Ntcheu District"
        },
        {
            "label": "NI",
            "value": "Ntchisi District"
        },
        {
            "label": "PH",
            "value": "Phalombe District"
        },
        {
            "label": "RU",
            "value": "Rumphi District"
        },
        {
            "label": "SA",
            "value": "Salima District"
        },
        {
            "label": "S",
            "value": "Southern Region"
        },
        {
            "label": "TH",
            "value": "Thyolo District"
        },
        {
            "label": "ZO",
            "value": "Zomba District"
        }
    ],
    "Malaysia": [
        {
            "label": "01",
            "value": "Johor"
        },
        {
            "label": "02",
            "value": "Kedah"
        },
        {
            "label": "03",
            "value": "Kelantan"
        },
        {
            "label": "14",
            "value": "Kuala Lumpur"
        },
        {
            "label": "15",
            "value": "Labuan"
        },
        {
            "label": "04",
            "value": "Melaka"
        },
        {
            "label": "05",
            "value": "Negeri Sembilan"
        },
        {
            "label": "06",
            "value": "Pahang"
        },
        {
            "label": "07",
            "value": "Penang"
        },
        {
            "label": "08",
            "value": "Perak"
        },
        {
            "label": "09",
            "value": "Perlis"
        },
        {
            "label": "16",
            "value": "Putrajaya"
        },
        {
            "label": "12",
            "value": "Sabah"
        },
        {
            "label": "13",
            "value": "Sarawak"
        },
        {
            "label": "10",
            "value": "Selangor"
        },
        {
            "label": "11",
            "value": "Terengganu"
        }
    ],
    "Maldives": [
        {
            "label": "01",
            "value": "Addu Atoll"
        },
        {
            "label": "02",
            "value": "Alif Alif Atoll"
        },
        {
            "label": "00",
            "value": "Alif Dhaal Atoll"
        },
        {
            "label": "CE",
            "value": "Central Province"
        },
        {
            "label": "17",
            "value": "Dhaalu Atoll"
        },
        {
            "label": "14",
            "value": "Faafu Atoll"
        },
        {
            "label": "27",
            "value": "Gaafu Alif Atoll"
        },
        {
            "label": "28",
            "value": "Gaafu Dhaalu Atoll"
        },
        {
            "label": "29",
            "value": "Gnaviyani Atoll"
        },
        {
            "label": "07",
            "value": "Haa Alif Atoll"
        },
        {
            "label": "23",
            "value": "Haa Dhaalu Atoll"
        },
        {
            "label": "26",
            "value": "Kaafu Atoll"
        },
        {
            "label": "05",
            "value": "Laamu Atoll"
        },
        {
            "label": "03",
            "value": "Lhaviyani Atoll"
        },
        {
            "label": "MLE",
            "value": "Malé"
        },
        {
            "label": "12",
            "value": "Meemu Atoll"
        },
        {
            "label": "25",
            "value": "Noonu Atoll"
        },
        {
            "label": "NC",
            "value": "North Central Province"
        },
        {
            "label": "NO",
            "value": "North Province"
        },
        {
            "label": "13",
            "value": "Raa Atoll"
        },
        {
            "label": "24",
            "value": "Shaviyani Atoll"
        },
        {
            "label": "SC",
            "value": "South Central Province"
        },
        {
            "label": "SU",
            "value": "South Province"
        },
        {
            "label": "08",
            "value": "Thaa Atoll"
        },
        {
            "label": "US",
            "value": "Upper South Province"
        },
        {
            "label": "04",
            "value": "Vaavu Atoll"
        }
    ],
    "Mali": [
        {
            "label": "BKO",
            "value": "Bamako"
        },
        {
            "label": "7",
            "value": "Gao Region"
        },
        {
            "label": "1",
            "value": "Kayes Region"
        },
        {
            "label": "8",
            "value": "Kidal Region"
        },
        {
            "label": "2",
            "value": "Koulikoro Region"
        },
        {
            "label": "9",
            "value": "Ménaka Region"
        },
        {
            "label": "5",
            "value": "Mopti Region"
        },
        {
            "label": "4",
            "value": "Ségou Region"
        },
        {
            "label": "3",
            "value": "Sikasso Region"
        },
        {
            "label": "10",
            "value": "Taoudénit Region"
        },
        {
            "label": "6",
            "value": "Tombouctou Region"
        }
    ],
    "Malta": [
        {
            "label": "01",
            "value": "Attard"
        },
        {
            "label": "02",
            "value": "Balzan"
        },
        {
            "label": "03",
            "value": "Birgu"
        },
        {
            "label": "04",
            "value": "Birkirkara"
        },
        {
            "label": "05",
            "value": "Birżebbuġa"
        },
        {
            "label": "06",
            "value": "Cospicua"
        },
        {
            "label": "07",
            "value": "Dingli"
        },
        {
            "label": "08",
            "value": "Fgura"
        },
        {
            "label": "09",
            "value": "Floriana"
        },
        {
            "label": "10",
            "value": "Fontana"
        },
        {
            "label": "13",
            "value": "Għajnsielem"
        },
        {
            "label": "14",
            "value": "Għarb"
        },
        {
            "label": "15",
            "value": "Għargħur"
        },
        {
            "label": "16",
            "value": "Għasri"
        },
        {
            "label": "17",
            "value": "Għaxaq"
        },
        {
            "label": "11",
            "value": "Gudja"
        },
        {
            "label": "12",
            "value": "Gżira"
        },
        {
            "label": "18",
            "value": "Ħamrun"
        },
        {
            "label": "19",
            "value": "Iklin"
        },
        {
            "label": "21",
            "value": "Kalkara"
        },
        {
            "label": "22",
            "value": "Kerċem"
        },
        {
            "label": "23",
            "value": "Kirkop"
        },
        {
            "label": "24",
            "value": "Lija"
        },
        {
            "label": "25",
            "value": "Luqa"
        },
        {
            "label": "26",
            "value": "Marsa"
        },
        {
            "label": "27",
            "value": "Marsaskala"
        },
        {
            "label": "28",
            "value": "Marsaxlokk"
        },
        {
            "label": "29",
            "value": "Mdina"
        },
        {
            "label": "30",
            "value": "Mellieħa"
        },
        {
            "label": "31",
            "value": "Mġarr"
        },
        {
            "label": "32",
            "value": "Mosta"
        },
        {
            "label": "33",
            "value": "Mqabba"
        },
        {
            "label": "34",
            "value": "Msida"
        },
        {
            "label": "35",
            "value": "Mtarfa"
        },
        {
            "label": "36",
            "value": "Munxar"
        },
        {
            "label": "37",
            "value": "Nadur"
        },
        {
            "label": "38",
            "value": "Naxxar"
        },
        {
            "label": "39",
            "value": "Paola"
        },
        {
            "label": "40",
            "value": "Pembroke"
        },
        {
            "label": "41",
            "value": "Pietà"
        },
        {
            "label": "42",
            "value": "Qala"
        },
        {
            "label": "43",
            "value": "Qormi"
        },
        {
            "label": "44",
            "value": "Qrendi"
        },
        {
            "label": "46",
            "value": "Rabat"
        },
        {
            "label": "50",
            "value": "Saint Lawrence"
        },
        {
            "label": "49",
            "value": "San Ġwann"
        },
        {
            "label": "52",
            "value": "Sannat"
        },
        {
            "label": "53",
            "value": "Santa Luċija"
        },
        {
            "label": "54",
            "value": "Santa Venera"
        },
        {
            "label": "20",
            "value": "Senglea"
        },
        {
            "label": "55",
            "value": "Siġġiewi"
        },
        {
            "label": "56",
            "value": "Sliema"
        },
        {
            "label": "48",
            "value": "St. Julian's"
        },
        {
            "label": "51",
            "value": "St. Paul's Bay"
        },
        {
            "label": "57",
            "value": "Swieqi"
        },
        {
            "label": "58",
            "value": "Ta' Xbiex"
        },
        {
            "label": "59",
            "value": "Tarxien"
        },
        {
            "label": "60",
            "value": "Valletta"
        },
        {
            "label": "45",
            "value": "Victoria"
        },
        {
            "label": "61",
            "value": "Xagħra"
        },
        {
            "label": "62",
            "value": "Xewkija"
        },
        {
            "label": "63",
            "value": "Xgħajra"
        },
        {
            "label": "64",
            "value": "Żabbar"
        },
        {
            "label": "65",
            "value": "Żebbuġ Gozo"
        },
        {
            "label": "66",
            "value": "Żebbuġ Malta"
        },
        {
            "label": "67",
            "value": "Żejtun"
        },
        {
            "label": "68",
            "value": "Żurrieq"
        }
    ],
    "Man (Isle of)": [

    ],
    "Marshall Islands": [
        {
            "label": "L",
            "value": "Ralik Chain"
        },
        {
            "label": "T",
            "value": "Ratak Chain"
        }
    ],
    "Martinique": [

    ],
    "Mauritania": [
        {
            "label": "07",
            "value": "Adrar Region"
        },
        {
            "label": "03",
            "value": "Assaba Region"
        },
        {
            "label": "05",
            "value": "Brakna Region"
        },
        {
            "label": "08",
            "value": "Dakhlet Nouadhibou"
        },
        {
            "label": "04",
            "value": "Gorgol Region"
        },
        {
            "label": "10",
            "value": "Guidimaka Region"
        },
        {
            "label": "01",
            "value": "Hodh Ech Chargui Region"
        },
        {
            "label": "02",
            "value": "Hodh El Gharbi Region"
        },
        {
            "label": "12",
            "value": "Inchiri Region"
        },
        {
            "label": "14",
            "value": "Nouakchott-Nord Region"
        },
        {
            "label": "13",
            "value": "Nouakchott-Ouest Region"
        },
        {
            "label": "15",
            "value": "Nouakchott-Sud Region"
        },
        {
            "label": "09",
            "value": "Tagant Region"
        },
        {
            "label": "11",
            "value": "Tiris Zemmour Region"
        },
        {
            "label": "06",
            "value": "Trarza Region"
        }
    ],
    "Mauritius": [
        {
            "label": "AG",
            "value": "Agaléga"
        },
        {
            "label": "BR",
            "value": "Beau Bassin-Rose Hill"
        },
        {
            "label": "CC",
            "value": "Cargados Carajos"
        },
        {
            "label": "CU",
            "value": "Curepipe"
        },
        {
            "label": "FL",
            "value": "Flacq District"
        },
        {
            "label": "GP",
            "value": "Grand Port District"
        },
        {
            "label": "MO",
            "value": "Moka District"
        },
        {
            "label": "PA",
            "value": "Pamplemousses District"
        },
        {
            "label": "PW",
            "value": "Plaines Wilhems District"
        },
        {
            "label": "PU",
            "value": "Port Louis"
        },
        {
            "label": "PL",
            "value": "Port Louis District"
        },
        {
            "label": "QB",
            "value": "Quatre Bornes"
        },
        {
            "label": "RR",
            "value": "Rivière du Rempart District"
        },
        {
            "label": "BL",
            "value": "Rivière Noire District"
        },
        {
            "label": "RO",
            "value": "Rodrigues"
        },
        {
            "label": "SA",
            "value": "Savanne District"
        },
        {
            "label": "VP",
            "value": "Vacoas-Phoenix"
        }
    ],
    "Mayotte": [

    ],
    "Mexico": [
        {
            "label": "AGU",
            "value": "Aguascalientes"
        },
        {
            "label": "BCN",
            "value": "Baja California"
        },
        {
            "label": "BCS",
            "value": "Baja California Sur"
        },
        {
            "label": "CAM",
            "value": "Campeche"
        },
        {
            "label": "CHP",
            "value": "Chiapas"
        },
        {
            "label": "CHH",
            "value": "Chihuahua"
        },
        {
            "label": "COA",
            "value": "Coahuila"
        },
        {
            "label": "COL",
            "value": "Colima"
        },
        {
            "label": "DUR",
            "value": "Durango"
        },
        {
            "label": "GUA",
            "value": "Guanajuato"
        },
        {
            "label": "GRO",
            "value": "Guerrero"
        },
        {
            "label": "HID",
            "value": "Hidalgo"
        },
        {
            "label": "JAL",
            "value": "Jalisco"
        },
        {
            "label": "MEX",
            "value": "México"
        },
        {
            "label": "CMX",
            "value": "Mexico City"
        },
        {
            "label": "MIC",
            "value": "Michoacán"
        },
        {
            "label": "MOR",
            "value": "Morelos"
        },
        {
            "label": "NAY",
            "value": "Nayarit"
        },
        {
            "label": "NLE",
            "value": "Nuevo León"
        },
        {
            "label": "OAX",
            "value": "Oaxaca"
        },
        {
            "label": "PUE",
            "value": "Puebla"
        },
        {
            "label": "QUE",
            "value": "Querétaro"
        },
        {
            "label": "ROO",
            "value": "Quintana Roo"
        },
        {
            "label": "SLP",
            "value": "San Luis Potosí"
        },
        {
            "label": "SIN",
            "value": "Sinaloa"
        },
        {
            "label": "SON",
            "value": "Sonora"
        },
        {
            "label": "TAB",
            "value": "Tabasco"
        },
        {
            "label": "TAM",
            "value": "Tamaulipas"
        },
        {
            "label": "TLA",
            "value": "Tlaxcala"
        },
        {
            "label": "VER",
            "value": "Veracruz"
        },
        {
            "label": "YUC",
            "value": "Yucatán"
        },
        {
            "label": "ZAC",
            "value": "Zacatecas"
        }
    ],
    "Micronesia": [
        {
            "label": "TRK",
            "value": "Chuuk State"
        },
        {
            "label": "KSA",
            "value": "Kosrae State"
        },
        {
            "label": "PNI",
            "value": "Pohnpei State"
        },
        {
            "label": "YAP",
            "value": "Yap State"
        }
    ],
    "Moldova": [
        {
            "label": "AN",
            "value": "Anenii Noi District"
        },
        {
            "label": "BA",
            "value": "Bălți Municipality"
        },
        {
            "label": "BS",
            "value": "Basarabeasca District"
        },
        {
            "label": "BD",
            "value": "Bender Municipality"
        },
        {
            "label": "BR",
            "value": "Briceni District"
        },
        {
            "label": "CA",
            "value": "Cahul District"
        },
        {
            "label": "CL",
            "value": "Călărași District"
        },
        {
            "label": "CT",
            "value": "Cantemir District"
        },
        {
            "label": "CS",
            "value": "Căușeni District"
        },
        {
            "label": "CU",
            "value": "Chișinău Municipality"
        },
        {
            "label": "CM",
            "value": "Cimișlia District"
        },
        {
            "label": "CR",
            "value": "Criuleni District"
        },
        {
            "label": "DO",
            "value": "Dondușeni District"
        },
        {
            "label": "DR",
            "value": "Drochia District"
        },
        {
            "label": "DU",
            "value": "Dubăsari District"
        },
        {
            "label": "ED",
            "value": "Edineț District"
        },
        {
            "label": "FA",
            "value": "Fălești District"
        },
        {
            "label": "FL",
            "value": "Florești District"
        },
        {
            "label": "GA",
            "value": "Gagauzia"
        },
        {
            "label": "GL",
            "value": "Glodeni District"
        },
        {
            "label": "HI",
            "value": "Hîncești District"
        },
        {
            "label": "IA",
            "value": "Ialoveni District"
        },
        {
            "label": "NI",
            "value": "Nisporeni District"
        },
        {
            "label": "OC",
            "value": "Ocnița District"
        },
        {
            "label": "OR",
            "value": "Orhei District"
        },
        {
            "label": "RE",
            "value": "Rezina District"
        },
        {
            "label": "RI",
            "value": "Rîșcani District"
        },
        {
            "label": "SI",
            "value": "Sîngerei District"
        },
        {
            "label": "SD",
            "value": "Șoldănești District"
        },
        {
            "label": "SO",
            "value": "Soroca District"
        },
        {
            "label": "SV",
            "value": "Ștefan Vodă District"
        },
        {
            "label": "ST",
            "value": "Strășeni District"
        },
        {
            "label": "TA",
            "value": "Taraclia District"
        },
        {
            "label": "TE",
            "value": "Telenești District"
        },
        {
            "label": "SN",
            "value": "Transnistria autonomous territorial unit"
        },
        {
            "label": "UN",
            "value": "Ungheni District"
        }
    ],
    "Monaco": [

    ],
    "Mongolia": [
        {
            "label": "073",
            "value": "Arkhangai Province"
        },
        {
            "label": "071",
            "value": "Bayan-Ölgii Province"
        },
        {
            "label": "069",
            "value": "Bayankhongor Province"
        },
        {
            "label": "067",
            "value": "Bulgan Province"
        },
        {
            "label": "037",
            "value": "Darkhan-Uul Province"
        },
        {
            "label": "061",
            "value": "Dornod Province"
        },
        {
            "label": "063",
            "value": "Dornogovi Province"
        },
        {
            "label": "059",
            "value": "Dundgovi Province"
        },
        {
            "label": "065",
            "value": "Govi-Altai Province"
        },
        {
            "label": "064",
            "value": "Govisümber Province"
        },
        {
            "label": "039",
            "value": "Khentii Province"
        },
        {
            "label": "043",
            "value": "Khovd Province"
        },
        {
            "label": "041",
            "value": "Khövsgöl Province"
        },
        {
            "label": "053",
            "value": "Ömnögovi Province"
        },
        {
            "label": "035",
            "value": "Orkhon Province"
        },
        {
            "label": "055",
            "value": "Övörkhangai Province"
        },
        {
            "label": "049",
            "value": "Selenge Province"
        },
        {
            "label": "051",
            "value": "Sükhbaatar Province"
        },
        {
            "label": "047",
            "value": "Töv Province"
        },
        {
            "label": "046",
            "value": "Uvs Province"
        },
        {
            "label": "057",
            "value": "Zavkhan Province"
        }
    ],
    "Montenegro": [
        {
            "label": "01",
            "value": "Andrijevica Municipality"
        },
        {
            "label": "02",
            "value": "Bar Municipality"
        },
        {
            "label": "03",
            "value": "Berane Municipality"
        },
        {
            "label": "04",
            "value": "Bijelo Polje Municipality"
        },
        {
            "label": "05",
            "value": "Budva Municipality"
        },
        {
            "label": "07",
            "value": "Danilovgrad Municipality"
        },
        {
            "label": "22",
            "value": "Gusinje Municipality"
        },
        {
            "label": "09",
            "value": "Kolašin Municipality"
        },
        {
            "label": "10",
            "value": "Kotor Municipality"
        },
        {
            "label": "11",
            "value": "Mojkovac Municipality"
        },
        {
            "label": "12",
            "value": "Nikšić Municipality"
        },
        {
            "label": "06",
            "value": "Old Royal Capital Cetinje"
        },
        {
            "label": "23",
            "value": "Petnjica Municipality"
        },
        {
            "label": "13",
            "value": "Plav Municipality"
        },
        {
            "label": "14",
            "value": "Pljevlja Municipality"
        },
        {
            "label": "15",
            "value": "Plužine Municipality"
        },
        {
            "label": "16",
            "value": "Podgorica Municipality"
        },
        {
            "label": "17",
            "value": "Rožaje Municipality"
        },
        {
            "label": "18",
            "value": "Šavnik Municipality"
        },
        {
            "label": "19",
            "value": "Tivat Municipality"
        },
        {
            "label": "20",
            "value": "Ulcinj Municipality"
        },
        {
            "label": "21",
            "value": "Žabljak Municipality"
        }
    ],
    "Montserrat": [

    ],
    "Morocco": [
        {
            "label": "HAO",
            "value": "Al Haouz Province"
        },
        {
            "label": "HOC",
            "value": "Al Hoceïma Province"
        },
        {
            "label": "AOU",
            "value": "Aousserd Province"
        },
        {
            "label": "ASZ",
            "value": "Assa-Zag Province"
        },
        {
            "label": "AZI",
            "value": "Azilal Province"
        },
        {
            "label": "BES",
            "value": "Ben Slimane Province"
        },
        {
            "label": "05",
            "value": "Béni Mellal-Khénifra"
        },
        {
            "label": "BEM",
            "value": "Béni-Mellal Province"
        },
        {
            "label": "BER",
            "value": "Berkane Province"
        },
        {
            "label": "BOD",
            "value": "Boujdour Province"
        },
        {
            "label": "BOM",
            "value": "Boulemane Province"
        },
        {
            "label": "06",
            "value": "Casablanca-Settat"
        },
        {
            "label": "CHE",
            "value": "Chefchaouen Province"
        },
        {
            "label": "CHI",
            "value": "Chichaoua Province"
        },
        {
            "label": "12",
            "value": "Dakhla-Oued Ed-Dahab"
        },
        {
            "label": "08",
            "value": "Drâa-Tafilalet"
        },
        {
            "label": "HAJ",
            "value": "El Hajeb Province"
        },
        {
            "label": "JDI",
            "value": "El Jadida Province"
        },
        {
            "label": "ERR",
            "value": "Errachidia Province"
        },
        {
            "label": "ESM",
            "value": "Es Semara Province"
        },
        {
            "label": "ESI",
            "value": "Essaouira Province"
        },
        {
            "label": "FAH",
            "value": "Fahs Anjra Province"
        },
        {
            "label": "03",
            "value": "Fès-Meknès"
        },
        {
            "label": "FIG",
            "value": "Figuig Province"
        },
        {
            "label": "GUE",
            "value": "Guelmim Province"
        },
        {
            "label": "10",
            "value": "Guelmim-Oued Noun"
        },
        {
            "label": "IFR",
            "value": "Ifrane Province"
        },
        {
            "label": "INE",
            "value": "Inezgane-Aït Melloul Prefecture"
        },
        {
            "label": "JRA",
            "value": "Jerada Province"
        },
        {
            "label": "KES",
            "value": "Kelaat Sraghna Province"
        },
        {
            "label": "KEN",
            "value": "Kénitra Province"
        },
        {
            "label": "KHE",
            "value": "Khémisset Province"
        },
        {
            "label": "KHN",
            "value": "Khénifra Province"
        },
        {
            "label": "KHO",
            "value": "Khouribga Province"
        },
        {
            "label": "LAA",
            "value": "Laâyoune Province"
        },
        {
            "label": "11",
            "value": "Laâyoune-Sakia El Hamra"
        },
        {
            "label": "LAR",
            "value": "Larache Province"
        },
        {
            "label": "07",
            "value": "Marrakesh-Safi"
        },
        {
            "label": "MED",
            "value": "Mediouna Province"
        },
        {
            "label": "MOU",
            "value": "Moulay Yacoub Province"
        },
        {
            "label": "NAD",
            "value": "Nador Province"
        },
        {
            "label": "NOU",
            "value": "Nouaceur Province"
        },
        {
            "label": "02",
            "value": "Oriental"
        },
        {
            "label": "OUA",
            "value": "Ouarzazate Province"
        },
        {
            "label": "OUD",
            "value": "Oued Ed-Dahab Province"
        },
        {
            "label": "SAF",
            "value": "Safi Province"
        },
        {
            "label": "SEF",
            "value": "Sefrou Province"
        },
        {
            "label": "SET",
            "value": "Settat Province"
        },
        {
            "label": "CHT",
            "value": "Shtouka Ait Baha Province"
        },
        {
            "label": "SIK",
            "value": "Sidi Kacem Province"
        },
        {
            "label": "SYB",
            "value": "Sidi Youssef Ben Ali"
        },
        {
            "label": "09",
            "value": "Souss-Massa"
        },
        {
            "label": "TNT",
            "value": "Tan-Tan Province"
        },
        {
            "label": "01",
            "value": "Tanger-Tétouan-Al Hoceïma"
        },
        {
            "label": "TAO",
            "value": "Taounate Province"
        },
        {
            "label": "TAI",
            "value": "Taourirt Province"
        },
        {
            "label": "TAR",
            "value": "Taroudant Province"
        },
        {
            "label": "TAT",
            "value": "Tata Province"
        },
        {
            "label": "TAZ",
            "value": "Taza Province"
        },
        {
            "label": "TET",
            "value": "Tétouan Province"
        },
        {
            "label": "TIZ",
            "value": "Tiznit Province"
        },
        {
            "label": "ZAG",
            "value": "Zagora Province"
        }
    ],
    "Mozambique": [
        {
            "label": "P",
            "value": "Cabo Delgado Province"
        },
        {
            "label": "G",
            "value": "Gaza Province"
        },
        {
            "label": "I",
            "value": "Inhambane Province"
        },
        {
            "label": "B",
            "value": "Manica Province"
        },
        {
            "label": "MPM",
            "value": "Maputo"
        },
        {
            "label": "L",
            "value": "Maputo Province"
        },
        {
            "label": "N",
            "value": "Nampula Province"
        },
        {
            "label": "A",
            "value": "Niassa Province"
        },
        {
            "label": "S",
            "value": "Sofala Province"
        },
        {
            "label": "T",
            "value": "Tete Province"
        },
        {
            "label": "Q",
            "value": "Zambezia Province"
        }
    ],
    "Myanmar": [
        {
            "label": "07",
            "value": "Ayeyarwady Region"
        },
        {
            "label": "02",
            "value": "Bago"
        },
        {
            "label": "14",
            "value": "Chin State"
        },
        {
            "label": "11",
            "value": "Kachin State"
        },
        {
            "label": "12",
            "value": "Kayah State"
        },
        {
            "label": "13",
            "value": "Kayin State"
        },
        {
            "label": "03",
            "value": "Magway Region"
        },
        {
            "label": "04",
            "value": "Mandalay Region"
        },
        {
            "label": "15",
            "value": "Mon State"
        },
        {
            "label": "18",
            "value": "Naypyidaw Union Territory"
        },
        {
            "label": "16",
            "value": "Rakhine State"
        },
        {
            "label": "01",
            "value": "Sagaing Region"
        },
        {
            "label": "17",
            "value": "Shan State"
        },
        {
            "label": "05",
            "value": "Tanintharyi Region"
        },
        {
            "label": "06",
            "value": "Yangon Region"
        }
    ],
    "Namibia": [
        {
            "label": "ER",
            "value": "Erongo Region"
        },
        {
            "label": "HA",
            "value": "Hardap Region"
        },
        {
            "label": "KA",
            "value": "Karas Region"
        },
        {
            "label": "KE",
            "value": "Kavango East Region"
        },
        {
            "label": "KW",
            "value": "Kavango West Region"
        },
        {
            "label": "KH",
            "value": "Khomas Region"
        },
        {
            "label": "KU",
            "value": "Kunene Region"
        },
        {
            "label": "OW",
            "value": "Ohangwena Region"
        },
        {
            "label": "OH",
            "value": "Omaheke Region"
        },
        {
            "label": "OS",
            "value": "Omusati Region"
        },
        {
            "label": "ON",
            "value": "Oshana Region"
        },
        {
            "label": "OT",
            "value": "Oshikoto Region"
        },
        {
            "label": "OD",
            "value": "Otjozondjupa Region"
        },
        {
            "label": "CA",
            "value": "Zambezi Region"
        }
    ],
    "Nauru": [
        {
            "label": "01",
            "value": "Aiwo District"
        },
        {
            "label": "02",
            "value": "Anabar District"
        },
        {
            "label": "03",
            "value": "Anetan District"
        },
        {
            "label": "04",
            "value": "Anibare District"
        },
        {
            "label": "05",
            "value": "Baiti District"
        },
        {
            "label": "06",
            "value": "Boe District"
        },
        {
            "label": "07",
            "value": "Buada District"
        },
        {
            "label": "08",
            "value": "Denigomodu District"
        },
        {
            "label": "09",
            "value": "Ewa District"
        },
        {
            "label": "10",
            "value": "Ijuw District"
        },
        {
            "label": "11",
            "value": "Meneng District"
        },
        {
            "label": "12",
            "value": "Nibok District"
        },
        {
            "label": "13",
            "value": "Uaboe District"
        },
        {
            "label": "14",
            "value": "Yaren District"
        }
    ],
    "Nepal": [
        {
            "label": "BA",
            "value": "Bagmati Zone"
        },
        {
            "label": "BH",
            "value": "Bheri Zone"
        },
        {
            "label": "1",
            "value": "Central Region"
        },
        {
            "label": "DH",
            "value": "Dhaulagiri Zone"
        },
        {
            "label": "4",
            "value": "Eastern Development Region"
        },
        {
            "label": "5",
            "value": "Far-Western Development Region"
        },
        {
            "label": "GA",
            "value": "Gandaki Zone"
        },
        {
            "label": "JA",
            "value": "Janakpur Zone"
        },
        {
            "label": "KA",
            "value": "Karnali Zone"
        },
        {
            "label": "KO",
            "value": "Kosi Zone"
        },
        {
            "label": "LU",
            "value": "Lumbini Zone"
        },
        {
            "label": "MA",
            "value": "Mahakali Zone"
        },
        {
            "label": "ME",
            "value": "Mechi Zone"
        },
        {
            "label": "2",
            "value": "Mid-Western Region"
        },
        {
            "label": "NA",
            "value": "Narayani Zone"
        },
        {
            "label": "RA",
            "value": "Rapti Zone"
        },
        {
            "label": "SA",
            "value": "Sagarmatha Zone"
        },
        {
            "label": "SE",
            "value": "Seti Zone"
        },
        {
            "label": "3",
            "value": "Western Region"
        }
    ],
    "Netherlands Antilles": [

    ],
    "Netherlands The": [
        {
            "label": "BQ1",
            "value": "Bonaire"
        },
        {
            "label": "DR",
            "value": "Drenthe"
        },
        {
            "label": "FL",
            "value": "Flevoland"
        },
        {
            "label": "FR",
            "value": "Friesland"
        },
        {
            "label": "GE",
            "value": "Gelderland"
        },
        {
            "label": "GR",
            "value": "Groningen"
        },
        {
            "label": "LI",
            "value": "Limburg"
        },
        {
            "label": "NB",
            "value": "North Brabant"
        },
        {
            "label": "NH",
            "value": "North Holland"
        },
        {
            "label": "OV",
            "value": "Overijssel"
        },
        {
            "label": "BQ2",
            "value": "Saba"
        },
        {
            "label": "BQ3",
            "value": "Sint Eustatius"
        },
        {
            "label": "ZH",
            "value": "South Holland"
        },
        {
            "label": "UT",
            "value": "Utrecht"
        },
        {
            "label": "ZE",
            "value": "Zeeland"
        }
    ],
    "New Caledonia": [

    ],
    "New Zealand": [
        {
            "label": "AUK",
            "value": "Auckland Region"
        },
        {
            "label": "BOP",
            "value": "Bay of Plenty Region"
        },
        {
            "label": "CAN",
            "value": "Canterbury Region"
        },
        {
            "label": "CIT",
            "value": "Chatham Islands"
        },
        {
            "label": "GIS",
            "value": "Gisborne District"
        },
        {
            "label": "HKB",
            "value": "Hawke's Bay Region"
        },
        {
            "label": "MWT",
            "value": "Manawatu-Wanganui Region"
        },
        {
            "label": "MBH",
            "value": "Marlborough Region"
        },
        {
            "label": "NSN",
            "value": "Nelson Region"
        },
        {
            "label": "NTL",
            "value": "Northland Region"
        },
        {
            "label": "OTA",
            "value": "Otago Region"
        },
        {
            "label": "STL",
            "value": "Southland Region"
        },
        {
            "label": "TKI",
            "value": "Taranaki Region"
        },
        {
            "label": "TAS",
            "value": "Tasman District"
        },
        {
            "label": "WKO",
            "value": "Waikato Region"
        },
        {
            "label": "WGN",
            "value": "Wellington Region"
        },
        {
            "label": "WTC",
            "value": "West Coast Region"
        }
    ],
    "Nicaragua": [
        {
            "label": "BO",
            "value": "Boaco Department"
        },
        {
            "label": "CA",
            "value": "Carazo Department"
        },
        {
            "label": "CI",
            "value": "Chinandega Department"
        },
        {
            "label": "CO",
            "value": "Chontales Department"
        },
        {
            "label": "ES",
            "value": "Estelí Department"
        },
        {
            "label": "GR",
            "value": "Granada Department"
        },
        {
            "label": "JI",
            "value": "Jinotega Department"
        },
        {
            "label": "LE",
            "value": "León Department"
        },
        {
            "label": "MD",
            "value": "Madriz Department"
        },
        {
            "label": "MN",
            "value": "Managua Department"
        },
        {
            "label": "MS",
            "value": "Masaya Department"
        },
        {
            "label": "MT",
            "value": "Matagalpa Department"
        },
        {
            "label": "AN",
            "value": "North Caribbean Coast Autonomous Region"
        },
        {
            "label": "SJ",
            "value": "Río San Juan Department"
        },
        {
            "label": "RI",
            "value": "Rivas Department"
        },
        {
            "label": "AS",
            "value": "South Caribbean Coast Autonomous Region"
        }
    ],
    "Niger": [
        {
            "label": "1",
            "value": "Agadez Region"
        },
        {
            "label": "2",
            "value": "Diffa Region"
        },
        {
            "label": "3",
            "value": "Dosso Region"
        },
        {
            "label": "4",
            "value": "Maradi Region"
        },
        {
            "label": "5",
            "value": "Tahoua Region"
        },
        {
            "label": "6",
            "value": "Tillabéri Region"
        },
        {
            "label": "7",
            "value": "Zinder Region"
        }
    ],
    "Nigeria": [
        {
            "label": "AB",
            "value": "Abia State"
        },
        {
            "label": "AD",
            "value": "Adamawa State"
        },
        {
            "label": "AK",
            "value": "Akwa Ibom State"
        },
        {
            "label": "AN",
            "value": "Anambra State"
        },
        {
            "label": "BA",
            "value": "Bauchi State"
        },
        {
            "label": "BY",
            "value": "Bayelsa State"
        },
        {
            "label": "BE",
            "value": "Benue State"
        },
        {
            "label": "BO",
            "value": "Borno State"
        },
        {
            "label": "CR",
            "value": "Cross River State"
        },
        {
            "label": "DE",
            "value": "Delta State"
        },
        {
            "label": "EB",
            "value": "Ebonyi State"
        },
        {
            "label": "ED",
            "value": "Edo State"
        },
        {
            "label": "EK",
            "value": "Ekiti State"
        },
        {
            "label": "EN",
            "value": "Enugu State"
        },
        {
            "label": "FC",
            "value": "Federal Capital Territory"
        },
        {
            "label": "GO",
            "value": "Gombe State"
        },
        {
            "label": "IM",
            "value": "Imo State"
        },
        {
            "label": "JI",
            "value": "Jigawa State"
        },
        {
            "label": "KD",
            "value": "Kaduna State"
        },
        {
            "label": "KN",
            "value": "Kano State"
        },
        {
            "label": "KT",
            "value": "Katsina State"
        },
        {
            "label": "KE",
            "value": "Kebbi State"
        },
        {
            "label": "KO",
            "value": "Kogi State"
        },
        {
            "label": "KW",
            "value": "Kwara State"
        },
        {
            "label": "LA",
            "value": "Lagos"
        },
        {
            "label": "NA",
            "value": "Nasarawa State"
        },
        {
            "label": "NI",
            "value": "Niger State"
        },
        {
            "label": "OG",
            "value": "Ogun State"
        },
        {
            "label": "ON",
            "value": "Ondo State"
        },
        {
            "label": "OS",
            "value": "Osun State"
        },
        {
            "label": "OY",
            "value": "Oyo State"
        },
        {
            "label": "PL",
            "value": "Plateau State"
        },
        {
            "label": "SO",
            "value": "Sokoto State"
        },
        {
            "label": "TA",
            "value": "Taraba State"
        },
        {
            "label": "YO",
            "value": "Yobe State"
        },
        {
            "label": "ZA",
            "value": "Zamfara State"
        }
    ],
    "Niue": [

    ],
    "Norfolk Island": [

    ],
    "Northern Mariana Islands": [

    ],
    "Norway": [
        {
            "label": "02",
            "value": "Akershus"
        },
        {
            "label": "06",
            "value": "Buskerud"
        },
        {
            "label": "20",
            "value": "Finnmark"
        },
        {
            "label": "04",
            "value": "Hedmark"
        },
        {
            "label": "12",
            "value": "Hordaland"
        },
        {
            "label": "22",
            "value": "Jan Mayen"
        },
        {
            "label": "15",
            "value": "Møre og Romsdal"
        },
        {
            "label": "17",
            "value": "Nord-Trøndelag"
        },
        {
            "label": "18",
            "value": "Nordland"
        },
        {
            "label": "05",
            "value": "Oppland"
        },
        {
            "label": "03",
            "value": "Oslo"
        },
        {
            "label": "01",
            "value": "Østfold"
        },
        {
            "label": "11",
            "value": "Rogaland"
        },
        {
            "label": "14",
            "value": "Sogn og Fjordane"
        },
        {
            "label": "16",
            "value": "Sør-Trøndelag"
        },
        {
            "label": "21",
            "value": "Svalbard"
        },
        {
            "label": "08",
            "value": "Telemark"
        },
        {
            "label": "19",
            "value": "Troms"
        },
        {
            "label": "50",
            "value": "Trøndelag"
        },
        {
            "label": "10",
            "value": "Vest-Agder"
        },
        {
            "label": "07",
            "value": "Vestfold"
        }
    ],
    "Oman": [
        {
            "label": "DA",
            "value": "Ad Dakhiliyah Governorate"
        },
        {
            "label": "ZA",
            "value": "Ad Dhahirah Governorate"
        },
        {
            "label": "BS",
            "value": "Al Batinah North Governorate"
        },
        {
            "label": "BA",
            "value": "Al Batinah Region"
        },
        {
            "label": "BJ",
            "value": "Al Batinah South Governorate"
        },
        {
            "label": "BU",
            "value": "Al Buraimi Governorate"
        },
        {
            "label": "WU",
            "value": "Al Wusta Governorate"
        },
        {
            "label": "SS",
            "value": "Ash Sharqiyah North Governorate"
        },
        {
            "label": "SH",
            "value": "Ash Sharqiyah Region"
        },
        {
            "label": "SJ",
            "value": "Ash Sharqiyah South Governorate"
        },
        {
            "label": "ZU",
            "value": "Dhofar Governorate"
        },
        {
            "label": "MU",
            "value": "Musandam Governorate"
        },
        {
            "label": "MA",
            "value": "Muscat Governorate"
        }
    ],
    "Pakistan": [
        {
            "label": "JK",
            "value": "Azad Kashmir"
        },
        {
            "label": "BA",
            "value": "Balochistan"
        },
        {
            "label": "TA",
            "value": "Federally Administered Tribal Areas"
        },
        {
            "label": "GB",
            "value": "Gilgit-Baltistan"
        },
        {
            "label": "IS",
            "value": "Islamabad Capital Territory"
        },
        {
            "label": "KP",
            "value": "Khyber Pakhtunkhwa"
        },
        {
            "label": "PB",
            "value": "Punjab"
        },
        {
            "label": "SD",
            "value": "Sindh"
        }
    ],
    "Palau": [
        {
            "label": "002",
            "value": "Aimeliik"
        },
        {
            "label": "004",
            "value": "Airai"
        },
        {
            "label": "010",
            "value": "Angaur"
        },
        {
            "label": "050",
            "value": "Hatohobei"
        },
        {
            "label": "100",
            "value": "Kayangel"
        },
        {
            "label": "150",
            "value": "Koror"
        },
        {
            "label": "212",
            "value": "Melekeok"
        },
        {
            "label": "214",
            "value": "Ngaraard"
        },
        {
            "label": "218",
            "value": "Ngarchelong"
        },
        {
            "label": "222",
            "value": "Ngardmau"
        },
        {
            "label": "224",
            "value": "Ngatpang"
        },
        {
            "label": "226",
            "value": "Ngchesar"
        },
        {
            "label": "227",
            "value": "Ngeremlengui"
        },
        {
            "label": "228",
            "value": "Ngiwal"
        },
        {
            "label": "350",
            "value": "Peleliu"
        },
        {
            "label": "370",
            "value": "Sonsorol"
        }
    ],
    "Palestinian Territory Occupied": [

    ],
    "Panama": [
        {
            "label": "1",
            "value": "Bocas del Toro Province"
        },
        {
            "label": "4",
            "value": "Chiriquí Province"
        },
        {
            "label": "2",
            "value": "Coclé Province"
        },
        {
            "label": "3",
            "value": "Colón Province"
        },
        {
            "label": "5",
            "value": "Darién Province"
        },
        {
            "label": "EM",
            "value": "Emberá-Wounaan Comarca"
        },
        {
            "label": "KY",
            "value": "Guna Yala"
        },
        {
            "label": "6",
            "value": "Herrera Province"
        },
        {
            "label": "7",
            "value": "Los Santos Province"
        },
        {
            "label": "NB",
            "value": "Ngöbe-Buglé Comarca"
        },
        {
            "label": "10",
            "value": "Panamá Oeste Province"
        },
        {
            "label": "8",
            "value": "Panamá Province"
        },
        {
            "label": "9",
            "value": "Veraguas Province"
        }
    ],
    "Papua new Guinea": [
        {
            "label": "NSB",
            "value": "Bougainville"
        },
        {
            "label": "CPM",
            "value": "Central Province"
        },
        {
            "label": "CPK",
            "value": "Chimbu Province"
        },
        {
            "label": "EBR",
            "value": "East New Britain"
        },
        {
            "label": "EHG",
            "value": "Eastern Highlands Province"
        },
        {
            "label": "EPW",
            "value": "Enga Province"
        },
        {
            "label": "GPK",
            "value": "Gulf"
        },
        {
            "label": "HLA",
            "value": "Hela"
        },
        {
            "label": "JWK",
            "value": "Jiwaka Province"
        },
        {
            "label": "MPM",
            "value": "Madang Province"
        },
        {
            "label": "MRL",
            "value": "Manus Province"
        },
        {
            "label": "MBA",
            "value": "Milne Bay Province"
        },
        {
            "label": "MPL",
            "value": "Morobe Province"
        },
        {
            "label": "NIK",
            "value": "New Ireland Province"
        },
        {
            "label": "NPP",
            "value": "Oro Province"
        },
        {
            "label": "NCD",
            "value": "Port Moresby"
        },
        {
            "label": "SAN",
            "value": "Sandaun Province"
        },
        {
            "label": "SHM",
            "value": "Southern Highlands Province"
        },
        {
            "label": "WBK",
            "value": "West New Britain Province"
        },
        {
            "label": "WHM",
            "value": "Western Highlands Province"
        },
        {
            "label": "WPD",
            "value": "Western Province"
        }
    ],
    "Paraguay": [
        {
            "label": "16",
            "value": "Alto Paraguay Department"
        },
        {
            "label": "10",
            "value": "Alto Paraná Department"
        },
        {
            "label": "13",
            "value": "Amambay Department"
        },
        {
            "label": "19",
            "value": "Boquerón Department"
        },
        {
            "label": "5",
            "value": "Caaguazú"
        },
        {
            "label": "6",
            "value": "Caazapá"
        },
        {
            "label": "14",
            "value": "Canindeyú"
        },
        {
            "label": "11",
            "value": "Central Department"
        },
        {
            "label": "1",
            "value": "Concepción Department"
        },
        {
            "label": "3",
            "value": "Cordillera Department"
        },
        {
            "label": "4",
            "value": "Guairá Department"
        },
        {
            "label": "7",
            "value": "Itapúa"
        },
        {
            "label": "8",
            "value": "Misiones Department"
        },
        {
            "label": "12",
            "value": "Ñeembucú Department"
        },
        {
            "label": "9",
            "value": "Paraguarí Department"
        },
        {
            "label": "15",
            "value": "Presidente Hayes Department"
        },
        {
            "label": "2",
            "value": "San Pedro Department"
        }
    ],
    "Peru": [
        {
            "label": "AMA",
            "value": "Amazonas"
        },
        {
            "label": "ANC",
            "value": "Áncash"
        },
        {
            "label": "APU",
            "value": "Apurímac"
        },
        {
            "label": "ARE",
            "value": "Arequipa"
        },
        {
            "label": "AYA",
            "value": "Ayacucho"
        },
        {
            "label": "CAJ",
            "value": "Cajamarca"
        },
        {
            "label": "CAL",
            "value": "Callao"
        },
        {
            "label": "CUS",
            "value": "Cusco"
        },
        {
            "label": "HUV",
            "value": "Huancavelica"
        },
        {
            "label": "HUC",
            "value": "Huanuco"
        },
        {
            "label": "ICA",
            "value": "Ica"
        },
        {
            "label": "JUN",
            "value": "Junín"
        },
        {
            "label": "LAL",
            "value": "La Libertad"
        },
        {
            "label": "LAM",
            "value": "Lambayeque"
        },
        {
            "label": "LIM",
            "value": "Lima"
        },
        {
            "label": "MDD",
            "value": "Madre de Dios"
        },
        {
            "label": "MOQ",
            "value": "Moquegua"
        },
        {
            "label": "PAS",
            "value": "Pasco"
        },
        {
            "label": "PIU",
            "value": "Piura"
        },
        {
            "label": "PUN",
            "value": "Puno"
        },
        {
            "label": "SAM",
            "value": "San Martín"
        },
        {
            "label": "TAC",
            "value": "Tacna"
        },
        {
            "label": "TUM",
            "value": "Tumbes"
        },
        {
            "label": "UCA",
            "value": "Ucayali"
        }
    ],
    "Philippines": [
        {
            "label": "ABR",
            "value": "Abra"
        },
        {
            "label": "AGN",
            "value": "Agusan del Norte"
        },
        {
            "label": "AGS",
            "value": "Agusan del Sur"
        },
        {
            "label": "AKL",
            "value": "Aklan"
        },
        {
            "label": "ALB",
            "value": "Albay"
        },
        {
            "label": "ANT",
            "value": "Antique"
        },
        {
            "label": "APA",
            "value": "Apayao"
        },
        {
            "label": "AUR",
            "value": "Aurora"
        },
        {
            "label": "14",
            "value": "Autonomous Region in Muslim Mindanao"
        },
        {
            "label": "BAS",
            "value": "Basilan"
        },
        {
            "label": "BAN",
            "value": "Bataan"
        },
        {
            "label": "BTN",
            "value": "Batanes"
        },
        {
            "label": "BTG",
            "value": "Batangas"
        },
        {
            "label": "BEN",
            "value": "Benguet"
        },
        {
            "label": "05",
            "value": "Bicol Region"
        },
        {
            "label": "BIL",
            "value": "Biliran"
        },
        {
            "label": "BOH",
            "value": "Bohol"
        },
        {
            "label": "BUK",
            "value": "Bukidnon"
        },
        {
            "label": "BUL",
            "value": "Bulacan"
        },
        {
            "label": "CAG",
            "value": "Cagayan"
        },
        {
            "label": "02",
            "value": "Cagayan Valley"
        },
        {
            "label": "40",
            "value": "Calabarzon"
        },
        {
            "label": "CAN",
            "value": "Camarines Norte"
        },
        {
            "label": "CAS",
            "value": "Camarines Sur"
        },
        {
            "label": "CAM",
            "value": "Camiguin"
        },
        {
            "label": "CAP",
            "value": "Capiz"
        },
        {
            "label": "13",
            "value": "Caraga"
        },
        {
            "label": "CAT",
            "value": "Catanduanes"
        },
        {
            "label": "CAV",
            "value": "Cavite"
        },
        {
            "label": "CEB",
            "value": "Cebu"
        },
        {
            "label": "03",
            "value": "Central Luzon"
        },
        {
            "label": "07",
            "value": "Central Visayas"
        },
        {
            "label": "COM",
            "value": "Compostela Valley"
        },
        {
            "label": "15",
            "value": "Cordillera Administrative Region"
        },
        {
            "label": "NCO",
            "value": "Cotabato"
        },
        {
            "label": "DAV",
            "value": "Davao del Norte"
        },
        {
            "label": "DAS",
            "value": "Davao del Sur"
        },
        {
            "label": "DVO",
            "value": "Davao Occidental"
        },
        {
            "label": "DAO",
            "value": "Davao Oriental"
        },
        {
            "label": "11",
            "value": "Davao Region"
        },
        {
            "label": "DIN",
            "value": "Dinagat Islands"
        },
        {
            "label": "EAS",
            "value": "Eastern Samar"
        },
        {
            "label": "08",
            "value": "Eastern Visayas"
        },
        {
            "label": "GUI",
            "value": "Guimaras"
        },
        {
            "label": "IFU",
            "value": "Ifugao"
        },
        {
            "label": "ILN",
            "value": "Ilocos Norte"
        },
        {
            "label": "01",
            "value": "Ilocos Region"
        },
        {
            "label": "ILS",
            "value": "Ilocos Sur"
        },
        {
            "label": "ILI",
            "value": "Iloilo"
        },
        {
            "label": "ISA",
            "value": "Isabela"
        },
        {
            "label": "KAL",
            "value": "Kalinga"
        },
        {
            "label": "LUN",
            "value": "La Union"
        },
        {
            "label": "LAG",
            "value": "Laguna"
        },
        {
            "label": "LAN",
            "value": "Lanao del Norte"
        },
        {
            "label": "LAS",
            "value": "Lanao del Sur"
        },
        {
            "label": "LEY",
            "value": "Leyte"
        },
        {
            "label": "MAG",
            "value": "Maguindanao"
        },
        {
            "label": "MAD",
            "value": "Marinduque"
        },
        {
            "label": "MAS",
            "value": "Masbate"
        },
        {
            "label": "00",
            "value": "Metro Manila"
        },
        {
            "label": "41",
            "value": "Mimaropa"
        },
        {
            "label": "MSC",
            "value": "Misamis Occidental"
        },
        {
            "label": "MSR",
            "value": "Misamis Oriental"
        },
        {
            "label": "MOU",
            "value": "Mountain Province"
        },
        {
            "label": "NEC",
            "value": "Negros Occidental"
        },
        {
            "label": "NER",
            "value": "Negros Oriental"
        },
        {
            "label": "10",
            "value": "Northern Mindanao"
        },
        {
            "label": "NSA",
            "value": "Northern Samar"
        },
        {
            "label": "NUE",
            "value": "Nueva Ecija"
        },
        {
            "label": "NUV",
            "value": "Nueva Vizcaya"
        },
        {
            "label": "MDC",
            "value": "Occidental Mindoro"
        },
        {
            "label": "MDR",
            "value": "Oriental Mindoro"
        },
        {
            "label": "PLW",
            "value": "Palawan"
        },
        {
            "label": "PAM",
            "value": "Pampanga"
        },
        {
            "label": "PAN",
            "value": "Pangasinan"
        },
        {
            "label": "QUE",
            "value": "Quezon"
        },
        {
            "label": "QUI",
            "value": "Quirino"
        },
        {
            "label": "RIZ",
            "value": "Rizal"
        },
        {
            "label": "ROM",
            "value": "Romblon"
        },
        {
            "label": "SAR",
            "value": "Sarangani"
        },
        {
            "label": "SIG",
            "value": "Siquijor"
        },
        {
            "label": "12",
            "value": "Soccsksargen"
        },
        {
            "label": "SOR",
            "value": "Sorsogon"
        },
        {
            "label": "SCO",
            "value": "South Cotabato"
        },
        {
            "label": "SLE",
            "value": "Southern Leyte"
        },
        {
            "label": "SUK",
            "value": "Sultan Kudarat"
        },
        {
            "label": "SLU",
            "value": "Sulu"
        },
        {
            "label": "SUN",
            "value": "Surigao del Norte"
        },
        {
            "label": "SUR",
            "value": "Surigao del Sur"
        },
        {
            "label": "TAR",
            "value": "Tarlac"
        },
        {
            "label": "TAW",
            "value": "Tawi-Tawi"
        },
        {
            "label": "06",
            "value": "Western Visayas"
        },
        {
            "label": "ZMB",
            "value": "Zambales"
        },
        {
            "label": "ZAN",
            "value": "Zamboanga del Norte"
        },
        {
            "label": "ZAS",
            "value": "Zamboanga del Sur"
        },
        {
            "label": "09",
            "value": "Zamboanga Peninsula"
        },
        {
            "label": "ZSI",
            "value": "Zamboanga Sibugay"
        }
    ],
    "Pitcairn Island": [

    ],
    "Poland": [
        {
            "label": "WP",
            "value": "Greater Poland Voivodeship"
        },
        {
            "label": "KI",
            "value": "Kielce"
        },
        {
            "label": "KP",
            "value": "Kuyavian-Pomeranian Voivodeship"
        },
        {
            "label": "MA",
            "value": "Lesser Poland Voivodeship"
        },
        {
            "label": "DS",
            "value": "Lower Silesian Voivodeship"
        },
        {
            "label": "LU",
            "value": "Lublin Voivodeship"
        },
        {
            "label": "LB",
            "value": "Lubusz Voivodeship"
        },
        {
            "label": "LD",
            "value": "Łódź Voivodeship"
        },
        {
            "label": "MZ",
            "value": "Masovian Voivodeship"
        },
        {
            "label": "OP",
            "value": "Opole Voivodeship"
        },
        {
            "label": "PK",
            "value": "Podkarpackie Voivodeship"
        },
        {
            "label": "PD",
            "value": "Podlaskie Voivodeship"
        },
        {
            "label": "PM",
            "value": "Pomeranian Voivodeship"
        },
        {
            "label": "SL",
            "value": "Silesian Voivodeship"
        },
        {
            "label": "SK",
            "value": "Świętokrzyskie Voivodeship"
        },
        {
            "label": "WN",
            "value": "Warmian-Masurian Voivodeship"
        },
        {
            "label": "ZP",
            "value": "West Pomeranian Voivodeship"
        }
    ],
    "Portugal": [
        {
            "label": "01",
            "value": "Aveiro District"
        },
        {
            "label": "20",
            "value": "Azores"
        },
        {
            "label": "02",
            "value": "Beja District"
        },
        {
            "label": "03",
            "value": "Braga District"
        },
        {
            "label": "04",
            "value": "Bragança District"
        },
        {
            "label": "05",
            "value": "Castelo Branco District"
        },
        {
            "label": "06",
            "value": "Coimbra District"
        },
        {
            "label": "07",
            "value": "Évora District"
        },
        {
            "label": "08",
            "value": "Faro District"
        },
        {
            "label": "09",
            "value": "Guarda District"
        },
        {
            "label": "10",
            "value": "Leiria District"
        },
        {
            "label": "11",
            "value": "Lisbon District"
        },
        {
            "label": "30",
            "value": "Madeira"
        },
        {
            "label": "12",
            "value": "Portalegre District"
        },
        {
            "label": "13",
            "value": "Porto District"
        },
        {
            "label": "14",
            "value": "Santarém District"
        },
        {
            "label": "15",
            "value": "Setúbal District"
        },
        {
            "label": "16",
            "value": "Viana do Castelo District"
        },
        {
            "label": "17",
            "value": "Vila Real District"
        },
        {
            "label": "18",
            "value": "Viseu District"
        }
    ],
    "Puerto Rico": [

    ],
    "Qatar": [
        {
            "label": "ZA",
            "value": "Al Daayen"
        },
        {
            "label": "KH",
            "value": "Al Khor"
        },
        {
            "label": "RA",
            "value": "Al Rayyan Municipality"
        },
        {
            "label": "WA",
            "value": "Al Wakrah"
        },
        {
            "label": "SH",
            "value": "Al-Shahaniya"
        },
        {
            "label": "DA",
            "value": "Doha"
        },
        {
            "label": "MS",
            "value": "Madinat ash Shamal"
        },
        {
            "label": "US",
            "value": "Umm Salal Municipality"
        }
    ],
    "Reunion": [

    ],
    "Romania": [
        {
            "label": "AB",
            "value": "Alba"
        },
        {
            "label": "AR",
            "value": "Arad County"
        },
        {
            "label": "AG",
            "value": "Arges"
        },
        {
            "label": "BC",
            "value": "Bacău County"
        },
        {
            "label": "BH",
            "value": "Bihor County"
        },
        {
            "label": "BN",
            "value": "Bistrița-Năsăud County"
        },
        {
            "label": "BT",
            "value": "Botoșani County"
        },
        {
            "label": "BR",
            "value": "Braila"
        },
        {
            "label": "BV",
            "value": "Brașov County"
        },
        {
            "label": "B",
            "value": "Bucharest"
        },
        {
            "label": "BZ",
            "value": "Buzău County"
        },
        {
            "label": "CL",
            "value": "Călărași County"
        },
        {
            "label": "CS",
            "value": "Caraș-Severin County"
        },
        {
            "label": "CJ",
            "value": "Cluj County"
        },
        {
            "label": "CT",
            "value": "Constanța County"
        },
        {
            "label": "CV",
            "value": "Covasna County"
        },
        {
            "label": "DB",
            "value": "Dâmbovița County"
        },
        {
            "label": "DJ",
            "value": "Dolj County"
        },
        {
            "label": "GL",
            "value": "Galați County"
        },
        {
            "label": "GR",
            "value": "Giurgiu County"
        },
        {
            "label": "GJ",
            "value": "Gorj County"
        },
        {
            "label": "HR",
            "value": "Harghita County"
        },
        {
            "label": "HD",
            "value": "Hunedoara County"
        },
        {
            "label": "IL",
            "value": "Ialomița County"
        },
        {
            "label": "IS",
            "value": "Iași County"
        },
        {
            "label": "IF",
            "value": "Ilfov County"
        },
        {
            "label": "MM",
            "value": "Maramureș County"
        },
        {
            "label": "MH",
            "value": "Mehedinți County"
        },
        {
            "label": "NT",
            "value": "Neamț County"
        },
        {
            "label": "OT",
            "value": "Olt County"
        },
        {
            "label": "PH",
            "value": "Prahova County"
        },
        {
            "label": "SJ",
            "value": "Sălaj County"
        },
        {
            "label": "SM",
            "value": "Satu Mare County"
        },
        {
            "label": "SB",
            "value": "Sibiu County"
        },
        {
            "label": "SV",
            "value": "Suceava County"
        },
        {
            "label": "TR",
            "value": "Teleorman County"
        },
        {
            "label": "TM",
            "value": "Timiș County"
        },
        {
            "label": "TL",
            "value": "Tulcea County"
        },
        {
            "label": "VL",
            "value": "Vâlcea County"
        },
        {
            "label": "VS",
            "value": "Vaslui County"
        },
        {
            "label": "VN",
            "value": "Vrancea County"
        }
    ],
    "Russia": [
        {
            "label": "ALT",
            "value": "Altai Krai"
        },
        {
            "label": "AL",
            "value": "Altai Republic"
        },
        {
            "label": "AMU",
            "value": "Amur Oblast"
        },
        {
            "label": "ARK",
            "value": "Arkhangelsk"
        },
        {
            "label": "AST",
            "value": "Astrakhan Oblast"
        },
        {
            "label": "BEL",
            "value": "Belgorod Oblast"
        },
        {
            "label": "BRY",
            "value": "Bryansk Oblast"
        },
        {
            "label": "CE",
            "value": "Chechen Republic"
        },
        {
            "label": "CHE",
            "value": "Chelyabinsk Oblast"
        },
        {
            "label": "CHU",
            "value": "Chukotka Autonomous Okrug"
        },
        {
            "label": "CU",
            "value": "Chuvash Republic"
        },
        {
            "label": "IRK",
            "value": "Irkutsk"
        },
        {
            "label": "IVA",
            "value": "Ivanovo Oblast"
        },
        {
            "label": "YEV",
            "value": "Jewish Autonomous Oblast"
        },
        {
            "label": "KB",
            "value": "Kabardino-Balkar Republic"
        },
        {
            "label": "KGD",
            "value": "Kaliningrad"
        },
        {
            "label": "KLU",
            "value": "Kaluga Oblast"
        },
        {
            "label": "KAM",
            "value": "Kamchatka Krai"
        },
        {
            "label": "KC",
            "value": "Karachay-Cherkess Republic"
        },
        {
            "label": "KEM",
            "value": "Kemerovo Oblast"
        },
        {
            "label": "KHA",
            "value": "Khabarovsk Krai"
        },
        {
            "label": "KHM",
            "value": "Khanty-Mansi Autonomous Okrug"
        },
        {
            "label": "KIR",
            "value": "Kirov Oblast"
        },
        {
            "label": "KO",
            "value": "Komi Republic"
        },
        {
            "label": "KOS",
            "value": "Kostroma Oblast"
        },
        {
            "label": "KDA",
            "value": "Krasnodar Krai"
        },
        {
            "label": "KYA",
            "value": "Krasnoyarsk Krai"
        },
        {
            "label": "KGN",
            "value": "Kurgan Oblast"
        },
        {
            "label": "KRS",
            "value": "Kursk Oblast"
        },
        {
            "label": "LEN",
            "value": "Leningrad Oblast"
        },
        {
            "label": "LIP",
            "value": "Lipetsk Oblast"
        },
        {
            "label": "MAG",
            "value": "Magadan Oblast"
        },
        {
            "label": "ME",
            "value": "Mari El Republic"
        },
        {
            "label": "MOW",
            "value": "Moscow"
        },
        {
            "label": "MOS",
            "value": "Moscow Oblast"
        },
        {
            "label": "MUR",
            "value": "Murmansk Oblast"
        },
        {
            "label": "NEN",
            "value": "Nenets Autonomous Okrug"
        },
        {
            "label": "NIZ",
            "value": "Nizhny Novgorod Oblast"
        },
        {
            "label": "NGR",
            "value": "Novgorod Oblast"
        },
        {
            "label": "NVS",
            "value": "Novosibirsk"
        },
        {
            "label": "OMS",
            "value": "Omsk Oblast"
        },
        {
            "label": "ORE",
            "value": "Orenburg Oblast"
        },
        {
            "label": "ORL",
            "value": "Oryol Oblast"
        },
        {
            "label": "PNZ",
            "value": "Penza Oblast"
        },
        {
            "label": "PER",
            "value": "Perm Krai"
        },
        {
            "label": "PRI",
            "value": "Primorsky Krai"
        },
        {
            "label": "PSK",
            "value": "Pskov Oblast"
        },
        {
            "label": "AD",
            "value": "Republic of Adygea"
        },
        {
            "label": "BA",
            "value": "Republic of Bashkortostan"
        },
        {
            "label": "BU",
            "value": "Republic of Buryatia"
        },
        {
            "label": "DA",
            "value": "Republic of Dagestan"
        },
        {
            "label": "IN",
            "value": "Republic of Ingushetia"
        },
        {
            "label": "KL",
            "value": "Republic of Kalmykia"
        },
        {
            "label": "KR",
            "value": "Republic of Karelia"
        },
        {
            "label": "KK",
            "value": "Republic of Khakassia"
        },
        {
            "label": "MO",
            "value": "Republic of Mordovia"
        },
        {
            "label": "SE",
            "value": "Republic of North Ossetia-Alania"
        },
        {
            "label": "TA",
            "value": "Republic of Tatarstan"
        },
        {
            "label": "ROS",
            "value": "Rostov Oblast"
        },
        {
            "label": "RYA",
            "value": "Ryazan Oblast"
        },
        {
            "label": "SPE",
            "value": "Saint Petersburg"
        },
        {
            "label": "SA",
            "value": "Sakha Republic"
        },
        {
            "label": "SAK",
            "value": "Sakhalin"
        },
        {
            "label": "SAM",
            "value": "Samara Oblast"
        },
        {
            "label": "SAR",
            "value": "Saratov Oblast"
        },
        {
            "label": "UA-40",
            "value": "Sevastopol"
        },
        {
            "label": "SMO",
            "value": "Smolensk Oblast"
        },
        {
            "label": "STA",
            "value": "Stavropol Krai"
        },
        {
            "label": "SVE",
            "value": "Sverdlovsk"
        },
        {
            "label": "TAM",
            "value": "Tambov Oblast"
        },
        {
            "label": "TOM",
            "value": "Tomsk Oblast"
        },
        {
            "label": "TUL",
            "value": "Tula Oblast"
        },
        {
            "label": "TY",
            "value": "Tuva Republic"
        },
        {
            "label": "TVE",
            "value": "Tver Oblast"
        },
        {
            "label": "TYU",
            "value": "Tyumen Oblast"
        },
        {
            "label": "UD",
            "value": "Udmurt Republic"
        },
        {
            "label": "ULY",
            "value": "Ulyanovsk Oblast"
        },
        {
            "label": "VLA",
            "value": "Vladimir Oblast"
        },
        {
            "label": "VLG",
            "value": "Vologda Oblast"
        },
        {
            "label": "VOR",
            "value": "Voronezh Oblast"
        },
        {
            "label": "YAN",
            "value": "Yamalo-Nenets Autonomous Okrug"
        },
        {
            "label": "YAR",
            "value": "Yaroslavl Oblast"
        },
        {
            "label": "ZAB",
            "value": "Zabaykalsky Krai"
        }
    ],
    "Rwanda": [
        {
            "label": "02",
            "value": "Eastern Province"
        },
        {
            "label": "01",
            "value": "Kigali district"
        },
        {
            "label": "03",
            "value": "Northern Province"
        },
        {
            "label": "05",
            "value": "Southern Province"
        },
        {
            "label": "04",
            "value": "Western Province"
        }
    ],
    "Saint Helena": [

    ],
    "Saint Kitts And Nevis": [
        {
            "label": "01",
            "value": "Christ Church Nichola Town Parish"
        },
        {
            "label": "N",
            "value": "Nevis"
        },
        {
            "label": "02",
            "value": "Saint Anne Sandy Point Parish"
        },
        {
            "label": "04",
            "value": "Saint George Gingerland Parish"
        },
        {
            "label": "05",
            "value": "Saint James Windward Parish"
        },
        {
            "label": "06",
            "value": "Saint John Capisterre Parish"
        },
        {
            "label": "07",
            "value": "Saint John Figtree Parish"
        },
        {
            "label": "K",
            "value": "Saint Kitts"
        },
        {
            "label": "08",
            "value": "Saint Mary Cayon Parish"
        },
        {
            "label": "09",
            "value": "Saint Paul Capisterre Parish"
        },
        {
            "label": "10",
            "value": "Saint Paul Charlestown Parish"
        },
        {
            "label": "11",
            "value": "Saint Peter Basseterre Parish"
        },
        {
            "label": "12",
            "value": "Saint Thomas Lowland Parish"
        },
        {
            "label": "13",
            "value": "Saint Thomas Middle Island Parish"
        },
        {
            "label": "15",
            "value": "Trinity Palmetto Point Parish"
        }
    ],
    "Saint Lucia": [
        {
            "label": "01",
            "value": "Anse la Raye Quarter"
        },
        {
            "label": "12",
            "value": "Canaries"
        },
        {
            "label": "02",
            "value": "Castries Quarter"
        },
        {
            "label": "03",
            "value": "Choiseul Quarter"
        },
        {
            "label": "04",
            "value": "Dauphin Quarter"
        },
        {
            "label": "05",
            "value": "Dennery Quarter"
        },
        {
            "label": "06",
            "value": "Gros Islet Quarter"
        },
        {
            "label": "07",
            "value": "Laborie Quarter"
        },
        {
            "label": "08",
            "value": "Micoud Quarter"
        },
        {
            "label": "09",
            "value": "Praslin Quarter"
        },
        {
            "label": "10",
            "value": "Soufrière Quarter"
        },
        {
            "label": "11",
            "value": "Vieux Fort Quarter"
        }
    ],
    "Saint Pierre and Miquelon": [

    ],
    "Saint Vincent And The Grenadines": [
        {
            "label": "01",
            "value": "Charlotte Parish"
        },
        {
            "label": "06",
            "value": "Grenadines Parish"
        },
        {
            "label": "02",
            "value": "Saint Andrew Parish"
        },
        {
            "label": "03",
            "value": "Saint David Parish"
        },
        {
            "label": "04",
            "value": "Saint George Parish"
        },
        {
            "label": "05",
            "value": "Saint Patrick Parish"
        }
    ],
    "Saint-Barthelemy": [

    ],
    "Saint-Martin (French part)": [

    ],
    "Samoa": [
        {
            "label": "AA",
            "value": "A'ana"
        },
        {
            "label": "AL",
            "value": "Aiga-i-le-Tai"
        },
        {
            "label": "AT",
            "value": "Atua"
        },
        {
            "label": "FA",
            "value": "Fa'asaleleaga"
        },
        {
            "label": "GE",
            "value": "Gaga'emauga"
        },
        {
            "label": "GI",
            "value": "Gaga'ifomauga"
        },
        {
            "label": "PA",
            "value": "Palauli"
        },
        {
            "label": "SA",
            "value": "Satupa'itea"
        },
        {
            "label": "TU",
            "value": "Tuamasaga"
        },
        {
            "label": "VF",
            "value": "Va'a-o-Fonoti"
        },
        {
            "label": "VS",
            "value": "Vaisigano"
        }
    ],
    "San Marino": [
        {
            "label": "01",
            "value": "Acquaviva"
        },
        {
            "label": "06",
            "value": "Borgo Maggiore"
        },
        {
            "label": "02",
            "value": "Chiesanuova"
        },
        {
            "label": "03",
            "value": "Domagnano"
        },
        {
            "label": "04",
            "value": "Faetano"
        },
        {
            "label": "05",
            "value": "Fiorentino"
        },
        {
            "label": "08",
            "value": "Montegiardino"
        },
        {
            "label": "07",
            "value": "San Marino"
        },
        {
            "label": "09",
            "value": "Serravalle"
        }
    ],
    "Sao Tome and Principe": [
        {
            "label": "P",
            "value": "Príncipe Province"
        },
        {
            "label": "S",
            "value": "São Tomé Province"
        }
    ],
    "Saudi Arabia": [
        {
            "label": "14",
            "value": "'Asir Region"
        },
        {
            "label": "11",
            "value": "Al Bahah Region"
        },
        {
            "label": "12",
            "value": "Al Jawf Region"
        },
        {
            "label": "03",
            "value": "Al Madinah Region"
        },
        {
            "label": "05",
            "value": "Al-Qassim Region"
        },
        {
            "label": "04",
            "value": "Eastern Province"
        },
        {
            "label": "06",
            "value": "Ha'il Region"
        },
        {
            "label": "09",
            "value": "Jizan Region"
        },
        {
            "label": "02",
            "value": "Makkah Region"
        },
        {
            "label": "10",
            "value": "Najran Region"
        },
        {
            "label": "08",
            "value": "Northern Borders Region"
        },
        {
            "label": "01",
            "value": "Riyadh Region"
        },
        {
            "label": "07",
            "value": "Tabuk Region"
        }
    ],
    "Senegal": [
        {
            "label": "DK",
            "value": "Dakar"
        },
        {
            "label": "DB",
            "value": "Diourbel Region"
        },
        {
            "label": "FK",
            "value": "Fatick"
        },
        {
            "label": "KA",
            "value": "Kaffrine"
        },
        {
            "label": "KL",
            "value": "Kaolack"
        },
        {
            "label": "KE",
            "value": "Kédougou"
        },
        {
            "label": "KD",
            "value": "Kolda"
        },
        {
            "label": "LG",
            "value": "Louga"
        },
        {
            "label": "MT",
            "value": "Matam"
        },
        {
            "label": "SL",
            "value": "Saint-Louis"
        },
        {
            "label": "SE",
            "value": "Sédhiou"
        },
        {
            "label": "TC",
            "value": "Tambacounda Region"
        },
        {
            "label": "TH",
            "value": "Thiès Region"
        },
        {
            "label": "ZG",
            "value": "Ziguinchor"
        }
    ],
    "Serbia": [
        {
            "label": "00",
            "value": "Belgrade"
        },
        {
            "label": "14",
            "value": "Bor District"
        },
        {
            "label": "11",
            "value": "Braničevo District"
        },
        {
            "label": "02",
            "value": "Central Banat District"
        },
        {
            "label": "23",
            "value": "Jablanica District"
        },
        {
            "label": "09",
            "value": "Kolubara District"
        },
        {
            "label": "08",
            "value": "Mačva District"
        },
        {
            "label": "17",
            "value": "Moravica District"
        },
        {
            "label": "20",
            "value": "Nišava District"
        },
        {
            "label": "01",
            "value": "North Bačka District"
        },
        {
            "label": "03",
            "value": "North Banat District"
        },
        {
            "label": "24",
            "value": "Pčinja District"
        },
        {
            "label": "22",
            "value": "Pirot District"
        },
        {
            "label": "10",
            "value": "Podunavlje District"
        },
        {
            "label": "13",
            "value": "Pomoravlje District"
        },
        {
            "label": "19",
            "value": "Rasina District"
        },
        {
            "label": "18",
            "value": "Raška District"
        },
        {
            "label": "06",
            "value": "South Bačka District"
        },
        {
            "label": "04",
            "value": "South Banat District"
        },
        {
            "label": "07",
            "value": "Srem District"
        },
        {
            "label": "12",
            "value": "Šumadija District"
        },
        {
            "label": "21",
            "value": "Toplica District"
        },
        {
            "label": "VO",
            "value": "Vojvodina"
        },
        {
            "label": "05",
            "value": "West Bačka District"
        },
        {
            "label": "15",
            "value": "Zaječar District"
        },
        {
            "label": "16",
            "value": "Zlatibor District"
        }
    ],
    "Seychelles": [
        {
            "label": "02",
            "value": "Anse Boileau"
        },
        {
            "label": "05",
            "value": "Anse Royale"
        },
        {
            "label": "01",
            "value": "Anse-aux-Pins"
        },
        {
            "label": "04",
            "value": "Au Cap"
        },
        {
            "label": "06",
            "value": "Baie Lazare"
        },
        {
            "label": "07",
            "value": "Baie Sainte Anne"
        },
        {
            "label": "08",
            "value": "Beau Vallon"
        },
        {
            "label": "09",
            "value": "Bel Air"
        },
        {
            "label": "10",
            "value": "Bel Ombre"
        },
        {
            "label": "11",
            "value": "Cascade"
        },
        {
            "label": "12",
            "value": "Glacis"
        },
        {
            "label": "13",
            "value": "Grand'Anse Mahé"
        },
        {
            "label": "14",
            "value": "Grand'Anse Praslin"
        },
        {
            "label": "15",
            "value": "La Digue"
        },
        {
            "label": "16",
            "value": "La Rivière Anglaise"
        },
        {
            "label": "24",
            "value": "Les Mamelles"
        },
        {
            "label": "17",
            "value": "Mont Buxton"
        },
        {
            "label": "18",
            "value": "Mont Fleuri"
        },
        {
            "label": "19",
            "value": "Plaisance"
        },
        {
            "label": "20",
            "value": "Pointe La Rue"
        },
        {
            "label": "21",
            "value": "Port Glaud"
        },
        {
            "label": "25",
            "value": "Roche Caiman"
        },
        {
            "label": "22",
            "value": "Saint Louis"
        },
        {
            "label": "23",
            "value": "Takamaka"
        }
    ],
    "Sierra Leone": [
        {
            "label": "E",
            "value": "Eastern Province"
        },
        {
            "label": "N",
            "value": "Northern Province"
        },
        {
            "label": "S",
            "value": "Southern Province"
        },
        {
            "label": "W",
            "value": "Western Area"
        }
    ],
    "Singapore": [
        {
            "label": "01",
            "value": "Central Singapore Community Development Council"
        },
        {
            "label": "02",
            "value": "North East Community Development Council"
        },
        {
            "label": "03",
            "value": "North West Community Development Council"
        },
        {
            "label": "04",
            "value": "South East Community Development Council"
        },
        {
            "label": "05",
            "value": "South West Community Development Council"
        }
    ],
    "Slovakia": [
        {
            "label": "BC",
            "value": "Banská Bystrica Region"
        },
        {
            "label": "BL",
            "value": "Bratislava Region"
        },
        {
            "label": "KI",
            "value": "Košice Region"
        },
        {
            "label": "NI",
            "value": "Nitra Region"
        },
        {
            "label": "PV",
            "value": "Prešov Region"
        },
        {
            "label": "TC",
            "value": "Trenčín Region"
        },
        {
            "label": "TA",
            "value": "Trnava Region"
        },
        {
            "label": "ZI",
            "value": "Žilina Region"
        }
    ],
    "Slovenia": [
        {
            "label": "001",
            "value": "Ajdovščina Municipality"
        },
        {
            "label": "213",
            "value": "Ankaran Municipality"
        },
        {
            "label": "002",
            "value": "Beltinci Municipality"
        },
        {
            "label": "148",
            "value": "Benedikt Municipality"
        },
        {
            "label": "149",
            "value": "Bistrica ob Sotli Municipality"
        },
        {
            "label": "003",
            "value": "Bled Municipality"
        },
        {
            "label": "150",
            "value": "Bloke Municipality"
        },
        {
            "label": "004",
            "value": "Bohinj Municipality"
        },
        {
            "label": "005",
            "value": "Borovnica Municipality"
        },
        {
            "label": "006",
            "value": "Bovec Municipality"
        },
        {
            "label": "151",
            "value": "Braslovče Municipality"
        },
        {
            "label": "007",
            "value": "Brda Municipality"
        },
        {
            "label": "009",
            "value": "Brežice Municipality"
        },
        {
            "label": "008",
            "value": "Brezovica Municipality"
        },
        {
            "label": "152",
            "value": "Cankova Municipality"
        },
        {
            "label": "012",
            "value": "Cerklje na Gorenjskem Municipality"
        },
        {
            "label": "013",
            "value": "Cerknica Municipality"
        },
        {
            "label": "014",
            "value": "Cerkno Municipality"
        },
        {
            "label": "153",
            "value": "Cerkvenjak Municipality"
        },
        {
            "label": "011",
            "value": "City Municipality of Celje"
        },
        {
            "label": "085",
            "value": "City Municipality of Novo Mesto"
        },
        {
            "label": "015",
            "value": "Črenšovci Municipality"
        },
        {
            "label": "016",
            "value": "Črna na Koroškem Municipality"
        },
        {
            "label": "017",
            "value": "Črnomelj Municipality"
        },
        {
            "label": "018",
            "value": "Destrnik Municipality"
        },
        {
            "label": "019",
            "value": "Divača Municipality"
        },
        {
            "label": "154",
            "value": "Dobje Municipality"
        },
        {
            "label": "020",
            "value": "Dobrepolje Municipality"
        },
        {
            "label": "155",
            "value": "Dobrna Municipality"
        },
        {
            "label": "021",
            "value": "Dobrova–Polhov Gradec Municipality"
        },
        {
            "label": "156",
            "value": "Dobrovnik Municipality"
        },
        {
            "label": "022",
            "value": "Dol pri Ljubljani Municipality"
        },
        {
            "label": "157",
            "value": "Dolenjske Toplice Municipality"
        },
        {
            "label": "023",
            "value": "Domžale Municipality"
        },
        {
            "label": "024",
            "value": "Dornava Municipality"
        },
        {
            "label": "025",
            "value": "Dravograd Municipality"
        },
        {
            "label": "026",
            "value": "Duplek Municipality"
        },
        {
            "label": "027",
            "value": "Gorenja Vas–Poljane Municipality"
        },
        {
            "label": "028",
            "value": "Gorišnica Municipality"
        },
        {
            "label": "207",
            "value": "Gorje Municipality"
        },
        {
            "label": "029",
            "value": "Gornja Radgona Municipality"
        },
        {
            "label": "030",
            "value": "Gornji Grad Municipality"
        },
        {
            "label": "031",
            "value": "Gornji Petrovci Municipality"
        },
        {
            "label": "158",
            "value": "Grad Municipality"
        },
        {
            "label": "032",
            "value": "Grosuplje Municipality"
        },
        {
            "label": "159",
            "value": "Hajdina Municipality"
        },
        {
            "label": "160",
            "value": "Hoče–Slivnica Municipality"
        },
        {
            "label": "161",
            "value": "Hodoš Municipality"
        },
        {
            "label": "162",
            "value": "Horjul Municipality"
        },
        {
            "label": "034",
            "value": "Hrastnik Municipality"
        },
        {
            "label": "035",
            "value": "Hrpelje–Kozina Municipality"
        },
        {
            "label": "036",
            "value": "Idrija Municipality"
        },
        {
            "label": "037",
            "value": "Ig Municipality"
        },
        {
            "label": "039",
            "value": "Ivančna Gorica Municipality"
        },
        {
            "label": "040",
            "value": "Izola Municipality"
        },
        {
            "label": "041",
            "value": "Jesenice Municipality"
        },
        {
            "label": "163",
            "value": "Jezersko Municipality"
        },
        {
            "label": "042",
            "value": "Juršinci Municipality"
        },
        {
            "label": "043",
            "value": "Kamnik Municipality"
        },
        {
            "label": "044",
            "value": "Kanal ob Soči Municipality"
        },
        {
            "label": "045",
            "value": "Kidričevo Municipality"
        },
        {
            "label": "046",
            "value": "Kobarid Municipality"
        },
        {
            "label": "047",
            "value": "Kobilje Municipality"
        },
        {
            "label": "048",
            "value": "Kočevje Municipality"
        },
        {
            "label": "049",
            "value": "Komen Municipality"
        },
        {
            "label": "164",
            "value": "Komenda Municipality"
        },
        {
            "label": "050",
            "value": "Koper City Municipality"
        },
        {
            "label": "197",
            "value": "Kostanjevica na Krki Municipality"
        },
        {
            "label": "165",
            "value": "Kostel Municipality"
        },
        {
            "label": "051",
            "value": "Kozje Municipality"
        },
        {
            "label": "052",
            "value": "Kranj City Municipality"
        },
        {
            "label": "053",
            "value": "Kranjska Gora Municipality"
        },
        {
            "label": "166",
            "value": "Križevci Municipality"
        },
        {
            "label": "055",
            "value": "Kungota"
        },
        {
            "label": "056",
            "value": "Kuzma Municipality"
        },
        {
            "label": "057",
            "value": "Laško Municipality"
        },
        {
            "label": "058",
            "value": "Lenart Municipality"
        },
        {
            "label": "059",
            "value": "Lendava Municipality"
        },
        {
            "label": "060",
            "value": "Litija Municipality"
        },
        {
            "label": "061",
            "value": "Ljubljana City Municipality"
        },
        {
            "label": "062",
            "value": "Ljubno Municipality"
        },
        {
            "label": "063",
            "value": "Ljutomer Municipality"
        },
        {
            "label": "208",
            "value": "Log–Dragomer Municipality"
        },
        {
            "label": "064",
            "value": "Logatec Municipality"
        },
        {
            "label": "065",
            "value": "Loška Dolina Municipality"
        },
        {
            "label": "066",
            "value": "Loški Potok Municipality"
        },
        {
            "label": "167",
            "value": "Lovrenc na Pohorju Municipality"
        },
        {
            "label": "067",
            "value": "Luče Municipality"
        },
        {
            "label": "068",
            "value": "Lukovica Municipality"
        },
        {
            "label": "069",
            "value": "Majšperk Municipality"
        },
        {
            "label": "198",
            "value": "Makole Municipality"
        },
        {
            "label": "070",
            "value": "Maribor City Municipality"
        },
        {
            "label": "168",
            "value": "Markovci Municipality"
        },
        {
            "label": "071",
            "value": "Medvode Municipality"
        },
        {
            "label": "072",
            "value": "Mengeš Municipality"
        },
        {
            "label": "073",
            "value": "Metlika Municipality"
        },
        {
            "label": "074",
            "value": "Mežica Municipality"
        },
        {
            "label": "169",
            "value": "Miklavž na Dravskem Polju Municipality"
        },
        {
            "label": "075",
            "value": "Miren–Kostanjevica Municipality"
        },
        {
            "label": "212",
            "value": "Mirna Municipality"
        },
        {
            "label": "170",
            "value": "Mirna Peč Municipality"
        },
        {
            "label": "076",
            "value": "Mislinja Municipality"
        },
        {
            "label": "199",
            "value": "Mokronog–Trebelno Municipality"
        },
        {
            "label": "077",
            "value": "Moravče Municipality"
        },
        {
            "label": "078",
            "value": "Moravske Toplice Municipality"
        },
        {
            "label": "079",
            "value": "Mozirje Municipality"
        },
        {
            "label": "195",
            "value": "Municipality of Apače"
        },
        {
            "label": "196",
            "value": "Municipality of Cirkulane"
        },
        {
            "label": "038",
            "value": "Municipality of Ilirska Bistrica"
        },
        {
            "label": "054",
            "value": "Municipality of Krško"
        },
        {
            "label": "123",
            "value": "Municipality of Škofljica"
        },
        {
            "label": "080",
            "value": "Murska Sobota City Municipality"
        },
        {
            "label": "081",
            "value": "Muta Municipality"
        },
        {
            "label": "082",
            "value": "Naklo Municipality"
        },
        {
            "label": "083",
            "value": "Nazarje Municipality"
        },
        {
            "label": "084",
            "value": "Nova Gorica City Municipality"
        },
        {
            "label": "086",
            "value": "Odranci Municipality"
        },
        {
            "label": "171",
            "value": "Oplotnica"
        },
        {
            "label": "087",
            "value": "Ormož Municipality"
        },
        {
            "label": "088",
            "value": "Osilnica Municipality"
        },
        {
            "label": "089",
            "value": "Pesnica Municipality"
        },
        {
            "label": "090",
            "value": "Piran Municipality"
        },
        {
            "label": "091",
            "value": "Pivka Municipality"
        },
        {
            "label": "092",
            "value": "Podčetrtek Municipality"
        },
        {
            "label": "172",
            "value": "Podlehnik Municipality"
        },
        {
            "label": "093",
            "value": "Podvelka Municipality"
        },
        {
            "label": "200",
            "value": "Poljčane Municipality"
        },
        {
            "label": "173",
            "value": "Polzela Municipality"
        },
        {
            "label": "094",
            "value": "Postojna Municipality"
        },
        {
            "label": "174",
            "value": "Prebold Municipality"
        },
        {
            "label": "095",
            "value": "Preddvor Municipality"
        },
        {
            "label": "175",
            "value": "Prevalje Municipality"
        },
        {
            "label": "096",
            "value": "Ptuj City Municipality"
        },
        {
            "label": "097",
            "value": "Puconci Municipality"
        },
        {
            "label": "098",
            "value": "Rače–Fram Municipality"
        },
        {
            "label": "099",
            "value": "Radeče Municipality"
        },
        {
            "label": "100",
            "value": "Radenci Municipality"
        },
        {
            "label": "101",
            "value": "Radlje ob Dravi Municipality"
        },
        {
            "label": "102",
            "value": "Radovljica Municipality"
        },
        {
            "label": "103",
            "value": "Ravne na Koroškem Municipality"
        },
        {
            "label": "176",
            "value": "Razkrižje Municipality"
        },
        {
            "label": "209",
            "value": "Rečica ob Savinji Municipality"
        },
        {
            "label": "201",
            "value": "Renče–Vogrsko Municipality"
        },
        {
            "label": "104",
            "value": "Ribnica Municipality"
        },
        {
            "label": "177",
            "value": "Ribnica na Pohorju Municipality"
        },
        {
            "label": "106",
            "value": "Rogaška Slatina Municipality"
        },
        {
            "label": "105",
            "value": "Rogašovci Municipality"
        },
        {
            "label": "107",
            "value": "Rogatec Municipality"
        },
        {
            "label": "108",
            "value": "Ruše Municipality"
        },
        {
            "label": "033",
            "value": "Šalovci Municipality"
        },
        {
            "label": "178",
            "value": "Selnica ob Dravi Municipality"
        },
        {
            "label": "109",
            "value": "Semič Municipality"
        },
        {
            "label": "183",
            "value": "Šempeter–Vrtojba Municipality"
        },
        {
            "label": "117",
            "value": "Šenčur Municipality"
        },
        {
            "label": "118",
            "value": "Šentilj Municipality"
        },
        {
            "label": "119",
            "value": "Šentjernej Municipality"
        },
        {
            "label": "120",
            "value": "Šentjur Municipality"
        },
        {
            "label": "211",
            "value": "Šentrupert Municipality"
        },
        {
            "label": "110",
            "value": "Sevnica Municipality"
        },
        {
            "label": "111",
            "value": "Sežana Municipality"
        },
        {
            "label": "121",
            "value": "Škocjan Municipality"
        },
        {
            "label": "122",
            "value": "Škofja Loka Municipality"
        },
        {
            "label": "112",
            "value": "Slovenj Gradec City Municipality"
        },
        {
            "label": "113",
            "value": "Slovenska Bistrica Municipality"
        },
        {
            "label": "114",
            "value": "Slovenske Konjice Municipality"
        },
        {
            "label": "124",
            "value": "Šmarje pri Jelšah Municipality"
        },
        {
            "label": "206",
            "value": "Šmarješke Toplice Municipality"
        },
        {
            "label": "125",
            "value": "Šmartno ob Paki Municipality"
        },
        {
            "label": "194",
            "value": "Šmartno pri Litiji Municipality"
        },
        {
            "label": "179",
            "value": "Sodražica Municipality"
        },
        {
            "label": "180",
            "value": "Solčava Municipality"
        },
        {
            "label": "126",
            "value": "Šoštanj Municipality"
        },
        {
            "label": "202",
            "value": "Središče ob Dravi"
        },
        {
            "label": "115",
            "value": "Starše Municipality"
        },
        {
            "label": "127",
            "value": "Štore Municipality"
        },
        {
            "label": "203",
            "value": "Straža Municipality"
        },
        {
            "label": "181",
            "value": "Sveta Ana Municipality"
        },
        {
            "label": "204",
            "value": "Sveta Trojica v Slovenskih Goricah Municipality"
        },
        {
            "label": "182",
            "value": "Sveti Andraž v Slovenskih Goricah Municipality"
        },
        {
            "label": "116",
            "value": "Sveti Jurij ob Ščavnici Municipality"
        },
        {
            "label": "210",
            "value": "Sveti Jurij v Slovenskih Goricah Municipality"
        },
        {
            "label": "205",
            "value": "Sveti Tomaž Municipality"
        },
        {
            "label": "184",
            "value": "Tabor Municipality"
        },
        {
            "label": "010",
            "value": "Tišina Municipality"
        },
        {
            "label": "128",
            "value": "Tolmin Municipality"
        },
        {
            "label": "129",
            "value": "Trbovlje Municipality"
        },
        {
            "label": "130",
            "value": "Trebnje Municipality"
        },
        {
            "label": "185",
            "value": "Trnovska Vas Municipality"
        },
        {
            "label": "131",
            "value": "Tržič Municipality"
        },
        {
            "label": "186",
            "value": "Trzin Municipality"
        },
        {
            "label": "132",
            "value": "Turnišče Municipality"
        },
        {
            "label": "187",
            "value": "Velika Polana Municipality"
        },
        {
            "label": "134",
            "value": "Velike Lašče Municipality"
        },
        {
            "label": "188",
            "value": "Veržej Municipality"
        },
        {
            "label": "135",
            "value": "Videm Municipality"
        },
        {
            "label": "136",
            "value": "Vipava Municipality"
        },
        {
            "label": "137",
            "value": "Vitanje Municipality"
        },
        {
            "label": "138",
            "value": "Vodice Municipality"
        },
        {
            "label": "139",
            "value": "Vojnik Municipality"
        },
        {
            "label": "189",
            "value": "Vransko Municipality"
        },
        {
            "label": "140",
            "value": "Vrhnika Municipality"
        },
        {
            "label": "141",
            "value": "Vuzenica Municipality"
        },
        {
            "label": "142",
            "value": "Zagorje ob Savi Municipality"
        },
        {
            "label": "190",
            "value": "Žalec Municipality"
        },
        {
            "label": "143",
            "value": "Zavrč Municipality"
        },
        {
            "label": "146",
            "value": "Železniki Municipality"
        },
        {
            "label": "191",
            "value": "Žetale Municipality"
        },
        {
            "label": "147",
            "value": "Žiri Municipality"
        },
        {
            "label": "192",
            "value": "Žirovnica Municipality"
        },
        {
            "label": "144",
            "value": "Zreče Municipality"
        },
        {
            "label": "193",
            "value": "Žužemberk Municipality"
        }
    ],
    "Solomon Islands": [
        {
            "label": "CE",
            "value": "Central Province"
        },
        {
            "label": "CH",
            "value": "Choiseul Province"
        },
        {
            "label": "GU",
            "value": "Guadalcanal Province"
        },
        {
            "label": "CT",
            "value": "Honiara"
        },
        {
            "label": "IS",
            "value": "Isabel Province"
        },
        {
            "label": "MK",
            "value": "Makira-Ulawa Province"
        },
        {
            "label": "ML",
            "value": "Malaita Province"
        },
        {
            "label": "RB",
            "value": "Rennell and Bellona Province"
        },
        {
            "label": "TE",
            "value": "Temotu Province"
        },
        {
            "label": "WE",
            "value": "Western Province"
        }
    ],
    "Somalia": [
        {
            "label": "AW",
            "value": "Awdal Region"
        },
        {
            "label": "BK",
            "value": "Bakool"
        },
        {
            "label": "BN",
            "value": "Banaadir"
        },
        {
            "label": "BR",
            "value": "Bari"
        },
        {
            "label": "BY",
            "value": "Bay"
        },
        {
            "label": "GA",
            "value": "Galguduud"
        },
        {
            "label": "GE",
            "value": "Gedo"
        },
        {
            "label": "HI",
            "value": "Hiran"
        },
        {
            "label": "JH",
            "value": "Lower Juba"
        },
        {
            "label": "SH",
            "value": "Lower Shebelle"
        },
        {
            "label": "JD",
            "value": "Middle Juba"
        },
        {
            "label": "SD",
            "value": "Middle Shebelle"
        },
        {
            "label": "MU",
            "value": "Mudug"
        },
        {
            "label": "NU",
            "value": "Nugal"
        },
        {
            "label": "SA",
            "value": "Sanaag Region"
        },
        {
            "label": "TO",
            "value": "Togdheer Region"
        }
    ],
    "South Africa": [
        {
            "label": "EC",
            "value": "Eastern Cape"
        },
        {
            "label": "FS",
            "value": "Free State"
        },
        {
            "label": "GP",
            "value": "Gauteng"
        },
        {
            "label": "KZN",
            "value": "KwaZulu-Natal"
        },
        {
            "label": "LP",
            "value": "Limpopo"
        },
        {
            "label": "MP",
            "value": "Mpumalanga"
        },
        {
            "label": "NW",
            "value": "North West"
        },
        {
            "label": "NC",
            "value": "Northern Cape"
        },
        {
            "label": "WC",
            "value": "Western Cape"
        }
    ],
    "South Georgia": [

    ],
    "South Sudan": [
        {
            "label": "EC",
            "value": "Central Equatoria"
        },
        {
            "label": "EE",
            "value": "Eastern Equatoria"
        },
        {
            "label": "JG",
            "value": "Jonglei State"
        },
        {
            "label": "LK",
            "value": "Lakes"
        },
        {
            "label": "BN",
            "value": "Northern Bahr el Ghazal"
        },
        {
            "label": "UY",
            "value": "Unity"
        },
        {
            "label": "NU",
            "value": "Upper Nile"
        },
        {
            "label": "WR",
            "value": "Warrap"
        },
        {
            "label": "BW",
            "value": "Western Bahr el Ghazal"
        },
        {
            "label": "EW",
            "value": "Western Equatoria"
        }
    ],
    "Spain": [
        {
            "label": "C",
            "value": "A Coruña Province"
        },
        {
            "label": "AB",
            "value": "Albacete Province"
        },
        {
            "label": "A",
            "value": "Alicante Province"
        },
        {
            "label": "AL",
            "value": "Almería Province"
        },
        {
            "label": "AN",
            "value": "Andalusia"
        },
        {
            "label": "VI",
            "value": "Araba Álava"
        },
        {
            "label": "AR",
            "value": "Aragon"
        },
        {
            "label": "BA",
            "value": "Badajoz Province"
        },
        {
            "label": "PM",
            "value": "Balearic Islands"
        },
        {
            "label": "B",
            "value": "Barcelona Province"
        },
        {
            "label": "PV",
            "value": "Basque Country"
        },
        {
            "label": "BI",
            "value": "Biscay"
        },
        {
            "label": "BU",
            "value": "Burgos Province"
        },
        {
            "label": "CC",
            "value": "Cáceres Province"
        },
        {
            "label": "CA",
            "value": "Cádiz Province"
        },
        {
            "label": "CN",
            "value": "Canary Islands"
        },
        {
            "label": "S",
            "value": "Cantabria"
        },
        {
            "label": "CS",
            "value": "Castellón Province"
        },
        {
            "label": "CL",
            "value": "Castile and León"
        },
        {
            "label": "CM",
            "value": "Castile-La Mancha"
        },
        {
            "label": "CT",
            "value": "Catalonia"
        },
        {
            "label": "CE",
            "value": "Ceuta"
        },
        {
            "label": "CR",
            "value": "Ciudad Real Province"
        },
        {
            "label": "MD",
            "value": "Community of Madrid"
        },
        {
            "label": "CO",
            "value": "Córdoba Province"
        },
        {
            "label": "CU",
            "value": "Cuenca Province"
        },
        {
            "label": "EX",
            "value": "Extremadura"
        },
        {
            "label": "GA",
            "value": "Galicia"
        },
        {
            "label": "SS",
            "value": "Gipuzkoa"
        },
        {
            "label": "GI",
            "value": "Girona Province"
        },
        {
            "label": "GR",
            "value": "Granada Province"
        },
        {
            "label": "GU",
            "value": "Guadalajara Province"
        },
        {
            "label": "H",
            "value": "Huelva Province"
        },
        {
            "label": "HU",
            "value": "Huesca Province"
        },
        {
            "label": "J",
            "value": "Jaén Province"
        },
        {
            "label": "RI",
            "value": "La Rioja"
        },
        {
            "label": "GC",
            "value": "Las Palmas Province"
        },
        {
            "label": "LE",
            "value": "León Province"
        },
        {
            "label": "L",
            "value": "Lleida Province"
        },
        {
            "label": "LU",
            "value": "Lugo Province"
        },
        {
            "label": "M",
            "value": "Madrid Province"
        },
        {
            "label": "MA",
            "value": "Málaga Province"
        },
        {
            "label": "ML",
            "value": "Melilla"
        },
        {
            "label": "MU",
            "value": "Murcia Province"
        },
        {
            "label": "NC",
            "value": "Navarre"
        },
        {
            "label": "OR",
            "value": "Ourense Province"
        },
        {
            "label": "P",
            "value": "Palencia Province"
        },
        {
            "label": "PO",
            "value": "Pontevedra Province"
        },
        {
            "label": "O",
            "value": "Province of Asturias"
        },
        {
            "label": "AV",
            "value": "Province of Ávila"
        },
        {
            "label": "MC",
            "value": "Region of Murcia"
        },
        {
            "label": "SA",
            "value": "Salamanca Province"
        },
        {
            "label": "TF",
            "value": "Santa Cruz de Tenerife Province"
        },
        {
            "label": "SG",
            "value": "Segovia Province"
        },
        {
            "label": "SE",
            "value": "Seville Province"
        },
        {
            "label": "SO",
            "value": "Soria Province"
        },
        {
            "label": "T",
            "value": "Tarragona Province"
        },
        {
            "label": "TE",
            "value": "Teruel Province"
        },
        {
            "label": "TO",
            "value": "Toledo Province"
        },
        {
            "label": "V",
            "value": "Valencia Province"
        },
        {
            "label": "VC",
            "value": "Valencian Community"
        },
        {
            "label": "VA",
            "value": "Valladolid Province"
        },
        {
            "label": "ZA",
            "value": "Zamora Province"
        },
        {
            "label": "Z",
            "value": "Zaragoza Province"
        }
    ],
    "Sri Lanka": [
        {
            "label": "52",
            "value": "Ampara District"
        },
        {
            "label": "71",
            "value": "Anuradhapura District"
        },
        {
            "label": "81",
            "value": "Badulla District"
        },
        {
            "label": "51",
            "value": "Batticaloa District"
        },
        {
            "label": "2",
            "value": "Central Province"
        },
        {
            "label": "11",
            "value": "Colombo District"
        },
        {
            "label": "5",
            "value": "Eastern Province"
        },
        {
            "label": "31",
            "value": "Galle District"
        },
        {
            "label": "12",
            "value": "Gampaha District"
        },
        {
            "label": "33",
            "value": "Hambantota District"
        },
        {
            "label": "41",
            "value": "Jaffna District"
        },
        {
            "label": "13",
            "value": "Kalutara District"
        },
        {
            "label": "21",
            "value": "Kandy District"
        },
        {
            "label": "92",
            "value": "Kegalle District"
        },
        {
            "label": "42",
            "value": "Kilinochchi District"
        },
        {
            "label": "43",
            "value": "Mannar District"
        },
        {
            "label": "22",
            "value": "Matale District"
        },
        {
            "label": "32",
            "value": "Matara District"
        },
        {
            "label": "82",
            "value": "Monaragala District"
        },
        {
            "label": "45",
            "value": "Mullaitivu District"
        },
        {
            "label": "7",
            "value": "North Central Province"
        },
        {
            "label": "6",
            "value": "North Western Province"
        },
        {
            "label": "4",
            "value": "Northern Province"
        },
        {
            "label": "23",
            "value": "Nuwara Eliya District"
        },
        {
            "label": "72",
            "value": "Polonnaruwa District"
        },
        {
            "label": "62",
            "value": "Puttalam District"
        },
        {
            "label": "91",
            "value": "Ratnapura district"
        },
        {
            "label": "9",
            "value": "Sabaragamuwa Province"
        },
        {
            "label": "3",
            "value": "Southern Province"
        },
        {
            "label": "53",
            "value": "Trincomalee District"
        },
        {
            "label": "8",
            "value": "Uva Province"
        },
        {
            "label": "44",
            "value": "Vavuniya District"
        },
        {
            "label": "1",
            "value": "Western Province"
        }
    ],
    "Sudan": [
        {
            "label": "GZ",
            "value": "Al Jazirah"
        },
        {
            "label": "GD",
            "value": "Al Qadarif"
        },
        {
            "label": "NB",
            "value": "Blue Nile"
        },
        {
            "label": "DC",
            "value": "Central Darfur"
        },
        {
            "label": "DE",
            "value": "East Darfur"
        },
        {
            "label": "KA",
            "value": "Kassala"
        },
        {
            "label": "KH",
            "value": "Khartoum"
        },
        {
            "label": "DN",
            "value": "North Darfur"
        },
        {
            "label": "KN",
            "value": "North Kordofan"
        },
        {
            "label": "NO",
            "value": "Northern"
        },
        {
            "label": "RS",
            "value": "Red Sea"
        },
        {
            "label": "NR",
            "value": "River Nile"
        },
        {
            "label": "SI",
            "value": "Sennar"
        },
        {
            "label": "DS",
            "value": "South Darfur"
        },
        {
            "label": "KS",
            "value": "South Kordofan"
        },
        {
            "label": "DW",
            "value": "West Darfur"
        },
        {
            "label": "GK",
            "value": "West Kordofan"
        },
        {
            "label": "NW",
            "value": "White Nile"
        }
    ],
    "Suriname": [
        {
            "label": "BR",
            "value": "Brokopondo District"
        },
        {
            "label": "CM",
            "value": "Commewijne District"
        },
        {
            "label": "CR",
            "value": "Coronie District"
        },
        {
            "label": "MA",
            "value": "Marowijne District"
        },
        {
            "label": "NI",
            "value": "Nickerie District"
        },
        {
            "label": "PR",
            "value": "Para District"
        },
        {
            "label": "PM",
            "value": "Paramaribo District"
        },
        {
            "label": "SA",
            "value": "Saramacca District"
        },
        {
            "label": "SI",
            "value": "Sipaliwini District"
        },
        {
            "label": "WA",
            "value": "Wanica District"
        }
    ],
    "Svalbard And Jan Mayen Islands": [

    ],
    "Swaziland": [
        {
            "label": "HH",
            "value": "Hhohho District"
        },
        {
            "label": "LU",
            "value": "Lubombo District"
        },
        {
            "label": "MA",
            "value": "Manzini District"
        },
        {
            "label": "SH",
            "value": "Shiselweni District"
        }
    ],
    "Sweden": [
        {
            "label": "K",
            "value": "Blekinge"
        },
        {
            "label": "W",
            "value": "Dalarna County"
        },
        {
            "label": "X",
            "value": "Gävleborg County"
        },
        {
            "label": "I",
            "value": "Gotland County"
        },
        {
            "label": "N",
            "value": "Halland County"
        },
        {
            "label": "F",
            "value": "Jönköping County"
        },
        {
            "label": "H",
            "value": "Kalmar County"
        },
        {
            "label": "G",
            "value": "Kronoberg County"
        },
        {
            "label": "BD",
            "value": "Norrbotten County"
        },
        {
            "label": "T",
            "value": "Örebro County"
        },
        {
            "label": "E",
            "value": "Östergötland County"
        },
        {
            "label": "M",
            "value": "Skåne County"
        },
        {
            "label": "D",
            "value": "Södermanland County"
        },
        {
            "label": "AB",
            "value": "Stockholm County"
        },
        {
            "label": "C",
            "value": "Uppsala County"
        },
        {
            "label": "S",
            "value": "Värmland County"
        },
        {
            "label": "AC",
            "value": "Västerbotten County"
        },
        {
            "label": "Y",
            "value": "Västernorrland County"
        },
        {
            "label": "U",
            "value": "Västmanland County"
        },
        {
            "label": "O",
            "value": "Västra Götaland County"
        }
    ],
    "Switzerland": [
        {
            "label": "AG",
            "value": "Aargau"
        },
        {
            "label": "AR",
            "value": "Appenzell Ausserrhoden"
        },
        {
            "label": "AI",
            "value": "Appenzell Innerrhoden"
        },
        {
            "label": "BL",
            "value": "Basel-Landschaft"
        },
        {
            "label": "BE",
            "value": "canton of Bern"
        },
        {
            "label": "FR",
            "value": "Canton of Fribourg"
        },
        {
            "label": "GE",
            "value": "Canton of Geneva"
        },
        {
            "label": "JU",
            "value": "Canton of Jura"
        },
        {
            "label": "LU",
            "value": "Canton of Lucerne"
        },
        {
            "label": "NE",
            "value": "Canton of Neuchâtel"
        },
        {
            "label": "SH",
            "value": "Canton of Schaffhausen"
        },
        {
            "label": "SO",
            "value": "Canton of Solothurn"
        },
        {
            "label": "SG",
            "value": "Canton of St. Gallen"
        },
        {
            "label": "VS",
            "value": "Canton of Valais"
        },
        {
            "label": "VD",
            "value": "Canton of Vaud"
        },
        {
            "label": "ZG",
            "value": "Canton of Zug"
        },
        {
            "label": "ZH",
            "value": "canton of Zürich"
        },
        {
            "label": "GL",
            "value": "Glarus"
        },
        {
            "label": "GR",
            "value": "Graubünden"
        },
        {
            "label": "NW",
            "value": "Nidwalden"
        },
        {
            "label": "OW",
            "value": "Obwalden"
        },
        {
            "label": "SZ",
            "value": "Schwyz"
        },
        {
            "label": "TG",
            "value": "Thurgau"
        },
        {
            "label": "TI",
            "value": "Ticino"
        },
        {
            "label": "UR",
            "value": "Uri"
        }
    ],
    "Syria": [
        {
            "label": "HA",
            "value": "Al-Hasakah Governorate"
        },
        {
            "label": "RA",
            "value": "Al-Raqqah Governorate"
        },
        {
            "label": "HL",
            "value": "Aleppo Governorate"
        },
        {
            "label": "SU",
            "value": "As-Suwayda Governorate"
        },
        {
            "label": "DI",
            "value": "Damascus Governorate"
        },
        {
            "label": "DR",
            "value": "Daraa Governorate"
        },
        {
            "label": "DY",
            "value": "Deir ez-Zor Governorate"
        },
        {
            "label": "HM",
            "value": "Hama Governorate"
        },
        {
            "label": "HI",
            "value": "Homs Governorate"
        },
        {
            "label": "ID",
            "value": "Idlib Governorate"
        },
        {
            "label": "LA",
            "value": "Latakia Governorate"
        },
        {
            "label": "QU",
            "value": "Quneitra Governorate"
        },
        {
            "label": "RD",
            "value": "Rif Dimashq Governorate"
        },
        {
            "label": "TA",
            "value": "Tartus Governorate"
        }
    ],
    "Taiwan": [
        {
            "label": "CHA",
            "value": "Changhua County"
        },
        {
            "label": "CYQ",
            "value": "Chiayi City"
        },
        {
            "label": "CYI",
            "value": "Chiayi County"
        },
        {
            "label": "HSZ",
            "value": "Hsinchu"
        },
        {
            "label": "HSQ",
            "value": "Hsinchu County"
        },
        {
            "label": "HUA",
            "value": "Hualien County"
        },
        {
            "label": "KHH",
            "value": "Kaohsiung"
        },
        {
            "label": "KHQ",
            "value": "Kaohsiung County"
        },
        {
            "label": "KIN",
            "value": "Kinmen"
        },
        {
            "label": "LIE",
            "value": "Lienchiang County"
        },
        {
            "label": "MIA",
            "value": "Miaoli County"
        },
        {
            "label": "NAN",
            "value": "Nantou County"
        },
        {
            "label": "PEN",
            "value": "Penghu County"
        },
        {
            "label": "PIF",
            "value": "Pingtung County"
        },
        {
            "label": "TXG",
            "value": "Taichung"
        },
        {
            "label": "TXQ",
            "value": "Taichung County"
        },
        {
            "label": "TNN",
            "value": "Tainan"
        },
        {
            "label": "TNQ",
            "value": "Tainan County"
        },
        {
            "label": "TPE",
            "value": "Taipei"
        },
        {
            "label": "TTT",
            "value": "Taitung County"
        },
        {
            "label": "TAO",
            "value": "Taoyuan City"
        },
        {
            "label": "ILA",
            "value": "Yilan County"
        },
        {
            "label": "YUN",
            "value": "Yunlin County"
        }
    ],
    "Tajikistan": [
        {
            "label": "RA",
            "value": "districts of Republican Subordination"
        },
        {
            "label": "GB",
            "value": "Gorno-Badakhshan Autonomous Province"
        },
        {
            "label": "KT",
            "value": "Khatlon Province"
        },
        {
            "label": "SU",
            "value": "Sughd Province"
        }
    ],
    "Tanzania": [
        {
            "label": "01",
            "value": "Arusha Region"
        },
        {
            "label": "02",
            "value": "Dar es Salaam Region"
        },
        {
            "label": "03",
            "value": "Dodoma Region"
        },
        {
            "label": "27",
            "value": "Geita Region"
        },
        {
            "label": "04",
            "value": "Iringa Region"
        },
        {
            "label": "05",
            "value": "Kagera Region"
        },
        {
            "label": "28",
            "value": "Katavi Region"
        },
        {
            "label": "08",
            "value": "Kigoma Region"
        },
        {
            "label": "09",
            "value": "Kilimanjaro Region"
        },
        {
            "label": "12",
            "value": "Lindi Region"
        },
        {
            "label": "26",
            "value": "Manyara Region"
        },
        {
            "label": "13",
            "value": "Mara Region"
        },
        {
            "label": "16",
            "value": "Morogoro Region"
        },
        {
            "label": "17",
            "value": "Mtwara Region"
        },
        {
            "label": "18",
            "value": "Mwanza Region"
        },
        {
            "label": "29",
            "value": "Njombe Region"
        },
        {
            "label": "06",
            "value": "North Pemba Region"
        },
        {
            "label": "19",
            "value": "Pwani Region"
        },
        {
            "label": "20",
            "value": "Rukwa Region"
        },
        {
            "label": "21",
            "value": "Ruvuma Region"
        },
        {
            "label": "22",
            "value": "Shinyanga Region"
        },
        {
            "label": "30",
            "value": "Simiyu Region"
        },
        {
            "label": "23",
            "value": "Singida Region"
        },
        {
            "label": "10",
            "value": "South Pemba Region"
        },
        {
            "label": "24",
            "value": "Tabora Region"
        },
        {
            "label": "25",
            "value": "Tanga Region"
        },
        {
            "label": "11",
            "value": "Zanzibar Central South Region"
        },
        {
            "label": "07",
            "value": "Zanzibar North Region"
        },
        {
            "label": "15",
            "value": "Zanzibar Urban West Region"
        }
    ],
    "Thailand": [
        {
            "label": "37",
            "value": "Amnat Charoen"
        },
        {
            "label": "15",
            "value": "Ang Thong"
        },
        {
            "label": "10",
            "value": "Bangkok"
        },
        {
            "label": "38",
            "value": "Bueng Kan"
        },
        {
            "label": "31",
            "value": "Buri Ram"
        },
        {
            "label": "24",
            "value": "Chachoengsao"
        },
        {
            "label": "18",
            "value": "Chai Nat"
        },
        {
            "label": "22",
            "value": "Chanthaburi"
        },
        {
            "label": "50",
            "value": "Chiang Mai"
        },
        {
            "label": "57",
            "value": "Chiang Rai"
        },
        {
            "label": "20",
            "value": "Chon Buri"
        },
        {
            "label": "86",
            "value": "Chumphon"
        },
        {
            "label": "46",
            "value": "Kalasin"
        },
        {
            "label": "62",
            "value": "Kamphaeng Phet"
        },
        {
            "label": "71",
            "value": "Kanchanaburi"
        },
        {
            "label": "40",
            "value": "Khon Kaen"
        },
        {
            "label": "81",
            "value": "Krabi"
        },
        {
            "label": "52",
            "value": "Lampang"
        },
        {
            "label": "51",
            "value": "Lamphun"
        },
        {
            "label": "42",
            "value": "Loei"
        },
        {
            "label": "16",
            "value": "Lopburi"
        },
        {
            "label": "58",
            "value": "Mae Hong Son"
        },
        {
            "label": "44",
            "value": "Maha Sarakham"
        },
        {
            "label": "49",
            "value": "Mukdahan"
        },
        {
            "label": "26",
            "value": "Nakhon Nayok"
        },
        {
            "label": "73",
            "value": "Nakhon Pathom"
        },
        {
            "label": "48",
            "value": "Nakhon Phanom"
        },
        {
            "label": "30",
            "value": "Nakhon Ratchasima"
        },
        {
            "label": "60",
            "value": "Nakhon Sawan"
        },
        {
            "label": "80",
            "value": "Nakhon Si Thammarat"
        },
        {
            "label": "55",
            "value": "Nan"
        },
        {
            "label": "96",
            "value": "Narathiwat"
        },
        {
            "label": "39",
            "value": "Nong Bua Lam Phu"
        },
        {
            "label": "43",
            "value": "Nong Khai"
        },
        {
            "label": "12",
            "value": "Nonthaburi"
        },
        {
            "label": "13",
            "value": "Pathum Thani"
        },
        {
            "label": "94",
            "value": "Pattani"
        },
        {
            "label": "S",
            "value": "Pattaya"
        },
        {
            "label": "82",
            "value": "Phang Nga"
        },
        {
            "label": "93",
            "value": "Phatthalung"
        },
        {
            "label": "56",
            "value": "Phayao"
        },
        {
            "label": "67",
            "value": "Phetchabun"
        },
        {
            "label": "76",
            "value": "Phetchaburi"
        },
        {
            "label": "66",
            "value": "Phichit"
        },
        {
            "label": "65",
            "value": "Phitsanulok"
        },
        {
            "label": "14",
            "value": "Phra Nakhon Si Ayutthaya"
        },
        {
            "label": "54",
            "value": "Phrae"
        },
        {
            "label": "83",
            "value": "Phuket"
        },
        {
            "label": "25",
            "value": "Prachin Buri"
        },
        {
            "label": "77",
            "value": "Prachuap Khiri Khan"
        },
        {
            "label": "85",
            "value": "Ranong"
        },
        {
            "label": "70",
            "value": "Ratchaburi"
        },
        {
            "label": "21",
            "value": "Rayong"
        },
        {
            "label": "45",
            "value": "Roi Et"
        },
        {
            "label": "27",
            "value": "Sa Kaeo"
        },
        {
            "label": "47",
            "value": "Sakon Nakhon"
        },
        {
            "label": "11",
            "value": "Samut Prakan"
        },
        {
            "label": "74",
            "value": "Samut Sakhon"
        },
        {
            "label": "75",
            "value": "Samut Songkhram"
        },
        {
            "label": "19",
            "value": "Saraburi"
        },
        {
            "label": "91",
            "value": "Satun"
        },
        {
            "label": "33",
            "value": "Si Sa Ket"
        },
        {
            "label": "17",
            "value": "Sing Buri"
        },
        {
            "label": "90",
            "value": "Songkhla"
        },
        {
            "label": "64",
            "value": "Sukhothai"
        },
        {
            "label": "72",
            "value": "Suphanburi"
        },
        {
            "label": "84",
            "value": "Surat Thani"
        },
        {
            "label": "32",
            "value": "Surin"
        },
        {
            "label": "63",
            "value": "Tak"
        },
        {
            "label": "92",
            "value": "Trang"
        },
        {
            "label": "23",
            "value": "Trat"
        },
        {
            "label": "34",
            "value": "Ubon Ratchathani"
        },
        {
            "label": "41",
            "value": "Udon Thani"
        },
        {
            "label": "61",
            "value": "Uthai Thani"
        },
        {
            "label": "53",
            "value": "Uttaradit"
        },
        {
            "label": "95",
            "value": "Yala"
        },
        {
            "label": "35",
            "value": "Yasothon"
        }
    ],
    "Togo": [
        {
            "label": "C",
            "value": "Centrale Region"
        },
        {
            "label": "K",
            "value": "Kara Region"
        },
        {
            "label": "M",
            "value": "Maritime"
        },
        {
            "label": "P",
            "value": "Plateaux Region"
        },
        {
            "label": "S",
            "value": "Savanes Region"
        }
    ],
    "Tokelau": [

    ],
    "Tonga": [
        {
            "label": "02",
            "value": "Haʻapai"
        },
        {
            "label": "01",
            "value": "ʻEua"
        },
        {
            "label": "03",
            "value": "Niuas"
        },
        {
            "label": "04",
            "value": "Tongatapu"
        },
        {
            "label": "05",
            "value": "Vavaʻu"
        }
    ],
    "Trinidad And Tobago": [
        {
            "label": "ARI",
            "value": "Arima"
        },
        {
            "label": "CHA",
            "value": "Chaguanas"
        },
        {
            "label": "CTT",
            "value": "Couva-Tabaquite-Talparo Regional Corporation"
        },
        {
            "label": "DMN",
            "value": "Diego Martin Regional Corporation"
        },
        {
            "label": "ETO",
            "value": "Eastern Tobago"
        },
        {
            "label": "PED",
            "value": "Penal-Debe Regional Corporation"
        },
        {
            "label": "PTF",
            "value": "Point Fortin"
        },
        {
            "label": "POS",
            "value": "Port of Spain"
        },
        {
            "label": "PRT",
            "value": "Princes Town Regional Corporation"
        },
        {
            "label": "MRC",
            "value": "Rio Claro-Mayaro Regional Corporation"
        },
        {
            "label": "SFO",
            "value": "San Fernando"
        },
        {
            "label": "SJL",
            "value": "San Juan-Laventille Regional Corporation"
        },
        {
            "label": "SGE",
            "value": "Sangre Grande Regional Corporation"
        },
        {
            "label": "SIP",
            "value": "Siparia Regional Corporation"
        },
        {
            "label": "TUP",
            "value": "Tunapuna-Piarco Regional Corporation"
        },
        {
            "label": "WTO",
            "value": "Western Tobago"
        }
    ],
    "Tunisia": [
        {
            "label": "12",
            "value": "Ariana Governorate"
        },
        {
            "label": "13",
            "value": "Ben Arous Governorate"
        },
        {
            "label": "23",
            "value": "Bizerte Governorate"
        },
        {
            "label": "81",
            "value": "Gabès Governorate"
        },
        {
            "label": "71",
            "value": "Gafsa Governorate"
        },
        {
            "label": "32",
            "value": "Jendouba Governorate"
        },
        {
            "label": "41",
            "value": "Kairouan Governorate"
        },
        {
            "label": "42",
            "value": "Kasserine Governorate"
        },
        {
            "label": "31",
            "value": "Kassrine"
        },
        {
            "label": "73",
            "value": "Kebili Governorate"
        },
        {
            "label": "33",
            "value": "Kef Governorate"
        },
        {
            "label": "53",
            "value": "Mahdia Governorate"
        },
        {
            "label": "14",
            "value": "Manouba Governorate"
        },
        {
            "label": "82",
            "value": "Medenine Governorate"
        },
        {
            "label": "52",
            "value": "Monastir Governorate"
        },
        {
            "label": "61",
            "value": "Sfax Governorate"
        },
        {
            "label": "43",
            "value": "Sidi Bouzid Governorate"
        },
        {
            "label": "34",
            "value": "Siliana Governorate"
        },
        {
            "label": "51",
            "value": "Sousse Governorate"
        },
        {
            "label": "83",
            "value": "Tataouine Governorate"
        },
        {
            "label": "72",
            "value": "Tozeur Governorate"
        },
        {
            "label": "11",
            "value": "Tunis Governorate"
        },
        {
            "label": "22",
            "value": "Zaghouan Governorate"
        }
    ],
    "Turkey": [
        {
            "label": "01",
            "value": "Adana Province"
        },
        {
            "label": "02",
            "value": "Adıyaman Province"
        },
        {
            "label": "03",
            "value": "Afyonkarahisar Province"
        },
        {
            "label": "04",
            "value": "Ağrı Province"
        },
        {
            "label": "68",
            "value": "Aksaray Province"
        },
        {
            "label": "05",
            "value": "Amasya Province"
        },
        {
            "label": "06",
            "value": "Ankara Province"
        },
        {
            "label": "07",
            "value": "Antalya Province"
        },
        {
            "label": "75",
            "value": "Ardahan Province"
        },
        {
            "label": "08",
            "value": "Artvin Province"
        },
        {
            "label": "09",
            "value": "Aydın Province"
        },
        {
            "label": "10",
            "value": "Balıkesir Province"
        },
        {
            "label": "74",
            "value": "Bartın Province"
        },
        {
            "label": "72",
            "value": "Batman Province"
        },
        {
            "label": "69",
            "value": "Bayburt Province"
        },
        {
            "label": "11",
            "value": "Bilecik Province"
        },
        {
            "label": "12",
            "value": "Bingöl Province"
        },
        {
            "label": "13",
            "value": "Bitlis Province"
        },
        {
            "label": "14",
            "value": "Bolu Province"
        },
        {
            "label": "15",
            "value": "Burdur Province"
        },
        {
            "label": "16",
            "value": "Bursa Province"
        },
        {
            "label": "17",
            "value": "Çanakkale Province"
        },
        {
            "label": "18",
            "value": "Çankırı Province"
        },
        {
            "label": "19",
            "value": "Çorum Province"
        },
        {
            "label": "20",
            "value": "Denizli Province"
        },
        {
            "label": "21",
            "value": "Diyarbakır Province"
        },
        {
            "label": "81",
            "value": "Düzce Province"
        },
        {
            "label": "22",
            "value": "Edirne Province"
        },
        {
            "label": "23",
            "value": "Elazığ Province"
        },
        {
            "label": "24",
            "value": "Erzincan Province"
        },
        {
            "label": "25",
            "value": "Erzurum Province"
        },
        {
            "label": "26",
            "value": "Eskişehir Province"
        },
        {
            "label": "27",
            "value": "Gaziantep Province"
        },
        {
            "label": "28",
            "value": "Giresun Province"
        },
        {
            "label": "29",
            "value": "Gümüşhane Province"
        },
        {
            "label": "30",
            "value": "Hakkâri Province"
        },
        {
            "label": "31",
            "value": "Hatay Province"
        },
        {
            "label": "76",
            "value": "Iğdır Province"
        },
        {
            "label": "32",
            "value": "Isparta Province"
        },
        {
            "label": "34",
            "value": "Istanbul Province"
        },
        {
            "label": "35",
            "value": "İzmir Province"
        },
        {
            "label": "46",
            "value": "Kahramanmaraş Province"
        },
        {
            "label": "78",
            "value": "Karabük Province"
        },
        {
            "label": "70",
            "value": "Karaman Province"
        },
        {
            "label": "36",
            "value": "Kars Province"
        },
        {
            "label": "37",
            "value": "Kastamonu Province"
        },
        {
            "label": "38",
            "value": "Kayseri Province"
        },
        {
            "label": "79",
            "value": "Kilis Province"
        },
        {
            "label": "71",
            "value": "Kırıkkale Province"
        },
        {
            "label": "39",
            "value": "Kırklareli Province"
        },
        {
            "label": "40",
            "value": "Kırşehir Province"
        },
        {
            "label": "41",
            "value": "Kocaeli Province"
        },
        {
            "label": "42",
            "value": "Konya Province"
        },
        {
            "label": "43",
            "value": "Kütahya Province"
        },
        {
            "label": "44",
            "value": "Malatya Province"
        },
        {
            "label": "45",
            "value": "Manisa Province"
        },
        {
            "label": "47",
            "value": "Mardin Province"
        },
        {
            "label": "33",
            "value": "Mersin Province"
        },
        {
            "label": "48",
            "value": "Muğla Province"
        },
        {
            "label": "49",
            "value": "Muş Province"
        },
        {
            "label": "50",
            "value": "Nevşehir Province"
        },
        {
            "label": "51",
            "value": "Niğde Province"
        },
        {
            "label": "52",
            "value": "Ordu Province"
        },
        {
            "label": "80",
            "value": "Osmaniye Province"
        },
        {
            "label": "53",
            "value": "Rize Province"
        },
        {
            "label": "54",
            "value": "Sakarya Province"
        },
        {
            "label": "55",
            "value": "Samsun Province"
        },
        {
            "label": "63",
            "value": "Şanlıurfa Province"
        },
        {
            "label": "56",
            "value": "Siirt Province"
        },
        {
            "label": "57",
            "value": "Sinop Province"
        },
        {
            "label": "58",
            "value": "Sivas Province"
        },
        {
            "label": "73",
            "value": "Şırnak Province"
        },
        {
            "label": "59",
            "value": "Tekirdağ Province"
        },
        {
            "label": "60",
            "value": "Tokat Province"
        },
        {
            "label": "61",
            "value": "Trabzon Province"
        },
        {
            "label": "62",
            "value": "Tunceli Province"
        },
        {
            "label": "64",
            "value": "Uşak Province"
        },
        {
            "label": "65",
            "value": "Van Province"
        },
        {
            "label": "77",
            "value": "Yalova Province"
        },
        {
            "label": "66",
            "value": "Yozgat Province"
        },
        {
            "label": "67",
            "value": "Zonguldak Province"
        }
    ],
    "Turkmenistan": [
        {
            "label": "A",
            "value": "Ahal Region"
        },
        {
            "label": "S",
            "value": "Ashgabat"
        },
        {
            "label": "B",
            "value": "Balkan Region"
        },
        {
            "label": "D",
            "value": "Daşoguz Region"
        },
        {
            "label": "L",
            "value": "Lebap Region"
        },
        {
            "label": "M",
            "value": "Mary Region"
        }
    ],
    "Turks And Caicos Islands": [

    ],
    "Tuvalu": [
        {
            "label": "FUN",
            "value": "Funafuti"
        },
        {
            "label": "NMG",
            "value": "Nanumanga"
        },
        {
            "label": "NMA",
            "value": "Nanumea"
        },
        {
            "label": "NIT",
            "value": "Niutao Island Council"
        },
        {
            "label": "NUI",
            "value": "Nui"
        },
        {
            "label": "NKF",
            "value": "Nukufetau"
        },
        {
            "label": "NKL",
            "value": "Nukulaelae"
        },
        {
            "label": "VAI",
            "value": "Vaitupu"
        }
    ],
    "Uganda": [
        {
            "label": "314",
            "value": "Abim District"
        },
        {
            "label": "301",
            "value": "Adjumani District"
        },
        {
            "label": "322",
            "value": "Agago District"
        },
        {
            "label": "323",
            "value": "Alebtong District"
        },
        {
            "label": "315",
            "value": "Amolatar District"
        },
        {
            "label": "324",
            "value": "Amudat District"
        },
        {
            "label": "216",
            "value": "Amuria District"
        },
        {
            "label": "316",
            "value": "Amuru District"
        },
        {
            "label": "302",
            "value": "Apac District"
        },
        {
            "label": "303",
            "value": "Arua District"
        },
        {
            "label": "217",
            "value": "Budaka District"
        },
        {
            "label": "218",
            "value": "Bududa District"
        },
        {
            "label": "201",
            "value": "Bugiri District"
        },
        {
            "label": "420",
            "value": "Buhweju District"
        },
        {
            "label": "117",
            "value": "Buikwe District"
        },
        {
            "label": "219",
            "value": "Bukedea District"
        },
        {
            "label": "118",
            "value": "Bukomansimbi District"
        },
        {
            "label": "220",
            "value": "Bukwo District"
        },
        {
            "label": "225",
            "value": "Bulambuli District"
        },
        {
            "label": "416",
            "value": "Buliisa District"
        },
        {
            "label": "401",
            "value": "Bundibugyo District"
        },
        {
            "label": "430",
            "value": "Bunyangabu District"
        },
        {
            "label": "402",
            "value": "Bushenyi District"
        },
        {
            "label": "202",
            "value": "Busia District"
        },
        {
            "label": "221",
            "value": "Butaleja District"
        },
        {
            "label": "119",
            "value": "Butambala District"
        },
        {
            "label": "233",
            "value": "Butebo District"
        },
        {
            "label": "120",
            "value": "Buvuma District"
        },
        {
            "label": "226",
            "value": "Buyende District"
        },
        {
            "label": "C",
            "value": "Central Region"
        },
        {
            "label": "317",
            "value": "Dokolo District"
        },
        {
            "label": "E",
            "value": "Eastern Region"
        },
        {
            "label": "121",
            "value": "Gomba District"
        },
        {
            "label": "304",
            "value": "Gulu District"
        },
        {
            "label": "417",
            "value": "Ibanda District"
        },
        {
            "label": "203",
            "value": "Iganga District"
        },
        {
            "label": "418",
            "value": "Isingiro District"
        },
        {
            "label": "204",
            "value": "Jinja District"
        },
        {
            "label": "318",
            "value": "Kaabong District"
        },
        {
            "label": "404",
            "value": "Kabale District"
        },
        {
            "label": "405",
            "value": "Kabarole District"
        },
        {
            "label": "213",
            "value": "Kaberamaido District"
        },
        {
            "label": "427",
            "value": "Kagadi District"
        },
        {
            "label": "428",
            "value": "Kakumiro District"
        },
        {
            "label": "101",
            "value": "Kalangala District"
        },
        {
            "label": "222",
            "value": "Kaliro District"
        },
        {
            "label": "122",
            "value": "Kalungu District"
        },
        {
            "label": "102",
            "value": "Kampala District"
        },
        {
            "label": "205",
            "value": "Kamuli District"
        },
        {
            "label": "413",
            "value": "Kamwenge District"
        },
        {
            "label": "414",
            "value": "Kanungu District"
        },
        {
            "label": "206",
            "value": "Kapchorwa District"
        },
        {
            "label": "406",
            "value": "Kasese District"
        },
        {
            "label": "207",
            "value": "Katakwi District"
        },
        {
            "label": "112",
            "value": "Kayunga District"
        },
        {
            "label": "407",
            "value": "Kibaale District"
        },
        {
            "label": "103",
            "value": "Kiboga District"
        },
        {
            "label": "227",
            "value": "Kibuku District"
        },
        {
            "label": "419",
            "value": "Kiruhura District"
        },
        {
            "label": "421",
            "value": "Kiryandongo District"
        },
        {
            "label": "408",
            "value": "Kisoro District"
        },
        {
            "label": "305",
            "value": "Kitgum District"
        },
        {
            "label": "319",
            "value": "Koboko District"
        },
        {
            "label": "325",
            "value": "Kole District"
        },
        {
            "label": "306",
            "value": "Kotido District"
        },
        {
            "label": "208",
            "value": "Kumi District"
        },
        {
            "label": "228",
            "value": "Kween District"
        },
        {
            "label": "123",
            "value": "Kyankwanzi District"
        },
        {
            "label": "422",
            "value": "Kyegegwa District"
        },
        {
            "label": "415",
            "value": "Kyenjojo District"
        },
        {
            "label": "125",
            "value": "Kyotera District"
        },
        {
            "label": "326",
            "value": "Lamwo District"
        },
        {
            "label": "307",
            "value": "Lira District"
        },
        {
            "label": "229",
            "value": "Luuka District"
        },
        {
            "label": "104",
            "value": "Luwero District"
        },
        {
            "label": "124",
            "value": "Lwengo District"
        },
        {
            "label": "114",
            "value": "Lyantonde District"
        },
        {
            "label": "223",
            "value": "Manafwa District"
        },
        {
            "label": "320",
            "value": "Maracha District"
        },
        {
            "label": "105",
            "value": "Masaka District"
        },
        {
            "label": "409",
            "value": "Masindi District"
        },
        {
            "label": "214",
            "value": "Mayuge District"
        },
        {
            "label": "209",
            "value": "Mbale District"
        },
        {
            "label": "410",
            "value": "Mbarara District"
        },
        {
            "label": "423",
            "value": "Mitooma District"
        },
        {
            "label": "115",
            "value": "Mityana District"
        },
        {
            "label": "308",
            "value": "Moroto District"
        },
        {
            "label": "309",
            "value": "Moyo District"
        },
        {
            "label": "106",
            "value": "Mpigi District"
        },
        {
            "label": "107",
            "value": "Mubende District"
        },
        {
            "label": "108",
            "value": "Mukono District"
        },
        {
            "label": "311",
            "value": "Nakapiripirit District"
        },
        {
            "label": "116",
            "value": "Nakaseke District"
        },
        {
            "label": "109",
            "value": "Nakasongola District"
        },
        {
            "label": "230",
            "value": "Namayingo District"
        },
        {
            "label": "234",
            "value": "Namisindwa District"
        },
        {
            "label": "224",
            "value": "Namutumba District"
        },
        {
            "label": "327",
            "value": "Napak District"
        },
        {
            "label": "310",
            "value": "Nebbi District"
        },
        {
            "label": "231",
            "value": "Ngora District"
        },
        {
            "label": "N",
            "value": "Northern Region"
        },
        {
            "label": "424",
            "value": "Ntoroko District"
        },
        {
            "label": "411",
            "value": "Ntungamo District"
        },
        {
            "label": "328",
            "value": "Nwoya District"
        },
        {
            "label": "331",
            "value": "Omoro District"
        },
        {
            "label": "329",
            "value": "Otuke District"
        },
        {
            "label": "321",
            "value": "Oyam District"
        },
        {
            "label": "312",
            "value": "Pader District"
        },
        {
            "label": "332",
            "value": "Pakwach District"
        },
        {
            "label": "210",
            "value": "Pallisa District"
        },
        {
            "label": "110",
            "value": "Rakai District"
        },
        {
            "label": "429",
            "value": "Rubanda District"
        },
        {
            "label": "425",
            "value": "Rubirizi District"
        },
        {
            "label": "431",
            "value": "Rukiga District"
        },
        {
            "label": "412",
            "value": "Rukungiri District"
        },
        {
            "label": "111",
            "value": "Sembabule District"
        },
        {
            "label": "232",
            "value": "Serere District"
        },
        {
            "label": "426",
            "value": "Sheema District"
        },
        {
            "label": "215",
            "value": "Sironko District"
        },
        {
            "label": "211",
            "value": "Soroti District"
        },
        {
            "label": "212",
            "value": "Tororo District"
        },
        {
            "label": "113",
            "value": "Wakiso District"
        },
        {
            "label": "W",
            "value": "Western Region"
        },
        {
            "label": "313",
            "value": "Yumbe District"
        },
        {
            "label": "330",
            "value": "Zombo District"
        }
    ],
    "Ukraine": [
        {
            "label": "43",
            "value": "Autonomous Republic of Crimea"
        },
        {
            "label": "71",
            "value": "Cherkasy Oblast"
        },
        {
            "label": "74",
            "value": "Chernihiv Oblast"
        },
        {
            "label": "77",
            "value": "Chernivtsi Oblast"
        },
        {
            "label": "12",
            "value": "Dnipropetrovsk Oblast"
        },
        {
            "label": "14",
            "value": "Donetsk Oblast"
        },
        {
            "label": "26",
            "value": "Ivano-Frankivsk Oblast"
        },
        {
            "label": "63",
            "value": "Kharkiv Oblast"
        },
        {
            "label": "65",
            "value": "Kherson Oblast"
        },
        {
            "label": "68",
            "value": "Khmelnytsky Oblast"
        },
        {
            "label": "30",
            "value": "Kiev"
        },
        {
            "label": "35",
            "value": "Kirovohrad Oblast"
        },
        {
            "label": "32",
            "value": "Kyiv Oblast"
        },
        {
            "label": "09",
            "value": "Luhansk Oblast"
        },
        {
            "label": "46",
            "value": "Lviv Oblast"
        },
        {
            "label": "48",
            "value": "Mykolaiv Oblast"
        },
        {
            "label": "51",
            "value": "Odessa Oblast"
        },
        {
            "label": "56",
            "value": "Rivne Oblast"
        },
        {
            "label": "59",
            "value": "Sumy Oblast"
        },
        {
            "label": "61",
            "value": "Ternopil Oblast"
        },
        {
            "label": "05",
            "value": "Vinnytsia Oblast"
        },
        {
            "label": "07",
            "value": "Volyn Oblast"
        },
        {
            "label": "21",
            "value": "Zakarpattia Oblast"
        },
        {
            "label": "23",
            "value": "Zaporizhzhya Oblast"
        },
        {
            "label": "18",
            "value": "Zhytomyr Oblast"
        }
    ],
    "United Arab Emirates": [
        {
            "label": "AZ",
            "value": "Abu Dhabi Emirate"
        },
        {
            "label": "AJ",
            "value": "Ajman Emirate"
        },
        {
            "label": "DU",
            "value": "Dubai"
        },
        {
            "label": "FU",
            "value": "Fujairah"
        },
        {
            "label": "RK",
            "value": "Ras al-Khaimah"
        },
        {
            "label": "SH",
            "value": "Sharjah Emirate"
        },
        {
            "label": "UQ",
            "value": "Umm al-Quwain"
        }
    ],
    "United Kingdom": [
        {
            "label": "ABE",
            "value": "Aberdeen"
        },
        {
            "label": "ABD",
            "value": "Aberdeenshire"
        },
        {
            "label": "ANS",
            "value": "Angus"
        },
        {
            "label": "ANT",
            "value": "Antrim"
        },
        {
            "label": "ANN",
            "value": "Antrim and Newtownabbey"
        },
        {
            "label": "ARD",
            "value": "Ards"
        },
        {
            "label": "AND",
            "value": "Ards and North Down"
        },
        {
            "label": "AGB",
            "value": "Argyll and Bute"
        },
        {
            "label": "ARM",
            "value": "Armagh City and District Council"
        },
        {
            "label": "ABC",
            "value": "Armagh, Banbridge and Craigavon"
        },
        {
            "label": "SH-AC",
            "value": "Ascension Island"
        },
        {
            "label": "BLA",
            "value": "Ballymena Borough"
        },
        {
            "label": "BLY",
            "value": "Ballymoney"
        },
        {
            "label": "BNB",
            "value": "Banbridge"
        },
        {
            "label": "BNS",
            "value": "Barnsley"
        },
        {
            "label": "BAS",
            "value": "Bath and North East Somerset"
        },
        {
            "label": "BDF",
            "value": "Bedford"
        },
        {
            "label": "BFS",
            "value": "Belfast district"
        },
        {
            "label": "BIR",
            "value": "Birmingham"
        },
        {
            "label": "BBD",
            "value": "Blackburn with Darwen"
        },
        {
            "label": "BPL",
            "value": "Blackpool"
        },
        {
            "label": "BGW",
            "value": "Blaenau Gwent County Borough"
        },
        {
            "label": "BOL",
            "value": "Bolton"
        },
        {
            "label": "BMH",
            "value": "Bournemouth"
        },
        {
            "label": "BRC",
            "value": "Bracknell Forest"
        },
        {
            "label": "BRD",
            "value": "Bradford"
        },
        {
            "label": "BGE",
            "value": "Bridgend County Borough"
        },
        {
            "label": "BNH",
            "value": "Brighton and Hove"
        },
        {
            "label": "BKM",
            "value": "Buckinghamshire"
        },
        {
            "label": "BUR",
            "value": "Bury"
        },
        {
            "label": "CAY",
            "value": "Caerphilly County Borough"
        },
        {
            "label": "CLD",
            "value": "Calderdale"
        },
        {
            "label": "CAM",
            "value": "Cambridgeshire"
        },
        {
            "label": "CMN",
            "value": "Carmarthenshire"
        },
        {
            "label": "CKF",
            "value": "Carrickfergus Borough Council"
        },
        {
            "label": "CSR",
            "value": "Castlereagh"
        },
        {
            "label": "CCG",
            "value": "Causeway Coast and Glens"
        },
        {
            "label": "CBF",
            "value": "Central Bedfordshire"
        },
        {
            "label": "CGN",
            "value": "Ceredigion"
        },
        {
            "label": "CHE",
            "value": "Cheshire East"
        },
        {
            "label": "CHW",
            "value": "Cheshire West and Chester"
        },
        {
            "label": "CRF",
            "value": "City and County of Cardiff"
        },
        {
            "label": "SWA",
            "value": "City and County of Swansea"
        },
        {
            "label": "BST",
            "value": "City of Bristol"
        },
        {
            "label": "DER",
            "value": "City of Derby"
        },
        {
            "label": "KHL",
            "value": "City of Kingston upon Hull"
        },
        {
            "label": "LCE",
            "value": "City of Leicester"
        },
        {
            "label": "LND",
            "value": "City of London"
        },
        {
            "label": "NGM",
            "value": "City of Nottingham"
        },
        {
            "label": "PTE",
            "value": "City of Peterborough"
        },
        {
            "label": "PLY",
            "value": "City of Plymouth"
        },
        {
            "label": "POR",
            "value": "City of Portsmouth"
        },
        {
            "label": "STH",
            "value": "City of Southampton"
        },
        {
            "label": "STE",
            "value": "City of Stoke-on-Trent"
        },
        {
            "label": "SND",
            "value": "City of Sunderland"
        },
        {
            "label": "WSM",
            "value": "City of Westminster"
        },
        {
            "label": "WLV",
            "value": "City of Wolverhampton"
        },
        {
            "label": "YOR",
            "value": "City of York"
        },
        {
            "label": "CLK",
            "value": "Clackmannanshire"
        },
        {
            "label": "CLR",
            "value": "Coleraine Borough Council"
        },
        {
            "label": "CWY",
            "value": "Conwy County Borough"
        },
        {
            "label": "CKT",
            "value": "Cookstown District Council"
        },
        {
            "label": "CON",
            "value": "Cornwall"
        },
        {
            "label": "DUR",
            "value": "County Durham"
        },
        {
            "label": "COV",
            "value": "Coventry"
        },
        {
            "label": "CGV",
            "value": "Craigavon Borough Council"
        },
        {
            "label": "CMA",
            "value": "Cumbria"
        },
        {
            "label": "DAL",
            "value": "Darlington"
        },
        {
            "label": "DEN",
            "value": "Denbighshire"
        },
        {
            "label": "DBY",
            "value": "Derbyshire"
        },
        {
            "label": "DRS",
            "value": "Derry City and Strabane"
        },
        {
            "label": "DRY",
            "value": "Derry City Council"
        },
        {
            "label": "DEV",
            "value": "Devon"
        },
        {
            "label": "DNC",
            "value": "Doncaster"
        },
        {
            "label": "DOR",
            "value": "Dorset"
        },
        {
            "label": "DOW",
            "value": "Down District Council"
        },
        {
            "label": "DUD",
            "value": "Dudley"
        },
        {
            "label": "DGY",
            "value": "Dumfries and Galloway"
        },
        {
            "label": "DND",
            "value": "Dundee"
        },
        {
            "label": "DGN",
            "value": "Dungannon and South Tyrone Borough Council"
        },
        {
            "label": "EAY",
            "value": "East Ayrshire"
        },
        {
            "label": "EDU",
            "value": "East Dunbartonshire"
        },
        {
            "label": "ELN",
            "value": "East Lothian"
        },
        {
            "label": "ERW",
            "value": "East Renfrewshire"
        },
        {
            "label": "ERY",
            "value": "East Riding of Yorkshire"
        },
        {
            "label": "ESX",
            "value": "East Sussex"
        },
        {
            "label": "EDH",
            "value": "Edinburgh"
        },
        {
            "label": "ENG",
            "value": "England"
        },
        {
            "label": "ESS",
            "value": "Essex"
        },
        {
            "label": "FAL",
            "value": "Falkirk"
        },
        {
            "label": "FMO",
            "value": "Fermanagh and Omagh"
        },
        {
            "label": "FER",
            "value": "Fermanagh District Council"
        },
        {
            "label": "FIF",
            "value": "Fife"
        },
        {
            "label": "FLN",
            "value": "Flintshire"
        },
        {
            "label": "GAT",
            "value": "Gateshead"
        },
        {
            "label": "GLG",
            "value": "Glasgow"
        },
        {
            "label": "GLS",
            "value": "Gloucestershire"
        },
        {
            "label": "GWN",
            "value": "Gwynedd"
        },
        {
            "label": "HAL",
            "value": "Halton"
        },
        {
            "label": "HAM",
            "value": "Hampshire"
        },
        {
            "label": "HPL",
            "value": "Hartlepool"
        },
        {
            "label": "HEF",
            "value": "Herefordshire"
        },
        {
            "label": "HRT",
            "value": "Hertfordshire"
        },
        {
            "label": "HLD",
            "value": "Highland"
        },
        {
            "label": "IVC",
            "value": "Inverclyde"
        },
        {
            "label": "IOW",
            "value": "Isle of Wight"
        },
        {
            "label": "IOS",
            "value": "Isles of Scilly"
        },
        {
            "label": "KEN",
            "value": "Kent"
        },
        {
            "label": "KIR",
            "value": "Kirklees"
        },
        {
            "label": "KWL",
            "value": "Knowsley"
        },
        {
            "label": "LAN",
            "value": "Lancashire"
        },
        {
            "label": "LRN",
            "value": "Larne Borough Council"
        },
        {
            "label": "LDS",
            "value": "Leeds"
        },
        {
            "label": "LEC",
            "value": "Leicestershire"
        },
        {
            "label": "LMV",
            "value": "Limavady Borough Council"
        },
        {
            "label": "LIN",
            "value": "Lincolnshire"
        },
        {
            "label": "LBC",
            "value": "Lisburn and Castlereagh"
        },
        {
            "label": "LSB",
            "value": "Lisburn City Council"
        },
        {
            "label": "LIV",
            "value": "Liverpool"
        },
        {
            "label": "BDG",
            "value": "London Borough of Barking and Dagenham"
        },
        {
            "label": "BNE",
            "value": "London Borough of Barnet"
        },
        {
            "label": "BEX",
            "value": "London Borough of Bexley"
        },
        {
            "label": "BEN",
            "value": "London Borough of Brent"
        },
        {
            "label": "BRY",
            "value": "London Borough of Bromley"
        },
        {
            "label": "CMD",
            "value": "London Borough of Camden"
        },
        {
            "label": "CRY",
            "value": "London Borough of Croydon"
        },
        {
            "label": "EAL",
            "value": "London Borough of Ealing"
        },
        {
            "label": "ENF",
            "value": "London Borough of Enfield"
        },
        {
            "label": "HCK",
            "value": "London Borough of Hackney"
        },
        {
            "label": "HMF",
            "value": "London Borough of Hammersmith and Fulham"
        },
        {
            "label": "HRY",
            "value": "London Borough of Haringey"
        },
        {
            "label": "HRW",
            "value": "London Borough of Harrow"
        },
        {
            "label": "HAV",
            "value": "London Borough of Havering"
        },
        {
            "label": "HIL",
            "value": "London Borough of Hillingdon"
        },
        {
            "label": "HNS",
            "value": "London Borough of Hounslow"
        },
        {
            "label": "ISL",
            "value": "London Borough of Islington"
        },
        {
            "label": "LBH",
            "value": "London Borough of Lambeth"
        },
        {
            "label": "LEW",
            "value": "London Borough of Lewisham"
        },
        {
            "label": "MRT",
            "value": "London Borough of Merton"
        },
        {
            "label": "NWM",
            "value": "London Borough of Newham"
        },
        {
            "label": "RDB",
            "value": "London Borough of Redbridge"
        },
        {
            "label": "RIC",
            "value": "London Borough of Richmond upon Thames"
        },
        {
            "label": "SWK",
            "value": "London Borough of Southwark"
        },
        {
            "label": "STN",
            "value": "London Borough of Sutton"
        },
        {
            "label": "TWH",
            "value": "London Borough of Tower Hamlets"
        },
        {
            "label": "WFT",
            "value": "London Borough of Waltham Forest"
        },
        {
            "label": "WND",
            "value": "London Borough of Wandsworth"
        },
        {
            "label": "MFT",
            "value": "Magherafelt District Council"
        },
        {
            "label": "MAN",
            "value": "Manchester"
        },
        {
            "label": "MDW",
            "value": "Medway"
        },
        {
            "label": "MTY",
            "value": "Merthyr Tydfil County Borough"
        },
        {
            "label": "WGN",
            "value": "Metropolitan Borough of Wigan"
        },
        {
            "label": "MEA",
            "value": "Mid and East Antrim"
        },
        {
            "label": "MUL",
            "value": "Mid Ulster"
        },
        {
            "label": "MDB",
            "value": "Middlesbrough"
        },
        {
            "label": "MLN",
            "value": "Midlothian"
        },
        {
            "label": "MIK",
            "value": "Milton Keynes"
        },
        {
            "label": "MON",
            "value": "Monmouthshire"
        },
        {
            "label": "MRY",
            "value": "Moray"
        },
        {
            "label": "MYL",
            "value": "Moyle District Council"
        },
        {
            "label": "NTL",
            "value": "Neath Port Talbot County Borough"
        },
        {
            "label": "NET",
            "value": "Newcastle upon Tyne"
        },
        {
            "label": "NWP",
            "value": "Newport"
        },
        {
            "label": "NYM",
            "value": "Newry and Mourne District Council"
        },
        {
            "label": "NMD",
            "value": "Newry, Mourne and Down"
        },
        {
            "label": "NTA",
            "value": "Newtownabbey Borough Council"
        },
        {
            "label": "NFK",
            "value": "Norfolk"
        },
        {
            "label": "NAY",
            "value": "North Ayrshire"
        },
        {
            "label": "NDN",
            "value": "North Down Borough Council"
        },
        {
            "label": "NEL",
            "value": "North East Lincolnshire"
        },
        {
            "label": "NLK",
            "value": "North Lanarkshire"
        },
        {
            "label": "NLN",
            "value": "North Lincolnshire"
        },
        {
            "label": "NSM",
            "value": "North Somerset"
        },
        {
            "label": "NTY",
            "value": "North Tyneside"
        },
        {
            "label": "NYK",
            "value": "North Yorkshire"
        },
        {
            "label": "NTH",
            "value": "Northamptonshire"
        },
        {
            "label": "NIR",
            "value": "Northern Ireland"
        },
        {
            "label": "NBL",
            "value": "Northumberland"
        },
        {
            "label": "NTT",
            "value": "Nottinghamshire"
        },
        {
            "label": "OLD",
            "value": "Oldham"
        },
        {
            "label": "OMH",
            "value": "Omagh District Council"
        },
        {
            "label": "ORK",
            "value": "Orkney Islands"
        },
        {
            "label": "ELS",
            "value": "Outer Hebrides"
        },
        {
            "label": "OXF",
            "value": "Oxfordshire"
        },
        {
            "label": "PEM",
            "value": "Pembrokeshire"
        },
        {
            "label": "PKN",
            "value": "Perth and Kinross"
        },
        {
            "label": "POL",
            "value": "Poole"
        },
        {
            "label": "POW",
            "value": "Powys"
        },
        {
            "label": "RDG",
            "value": "Reading"
        },
        {
            "label": "RCC",
            "value": "Redcar and Cleveland"
        },
        {
            "label": "RFW",
            "value": "Renfrewshire"
        },
        {
            "label": "RCT",
            "value": "Rhondda Cynon Taf"
        },
        {
            "label": "RCH",
            "value": "Rochdale"
        },
        {
            "label": "ROT",
            "value": "Rotherham"
        },
        {
            "label": "GRE",
            "value": "Royal Borough of Greenwich"
        },
        {
            "label": "KEC",
            "value": "Royal Borough of Kensington and Chelsea"
        },
        {
            "label": "KTT",
            "value": "Royal Borough of Kingston upon Thames"
        },
        {
            "label": "RUT",
            "value": "Rutland"
        },
        {
            "label": "SH-HL",
            "value": "Saint Helena"
        },
        {
            "label": "SLF",
            "value": "Salford"
        },
        {
            "label": "SAW",
            "value": "Sandwell"
        },
        {
            "label": "SCT",
            "value": "Scotland"
        },
        {
            "label": "SCB",
            "value": "Scottish Borders"
        },
        {
            "label": "SFT",
            "value": "Sefton"
        },
        {
            "label": "SHF",
            "value": "Sheffield"
        },
        {
            "label": "ZET",
            "value": "Shetland Islands"
        },
        {
            "label": "SHR",
            "value": "Shropshire"
        },
        {
            "label": "SLG",
            "value": "Slough"
        },
        {
            "label": "SOL",
            "value": "Solihull"
        },
        {
            "label": "SOM",
            "value": "Somerset"
        },
        {
            "label": "SAY",
            "value": "South Ayrshire"
        },
        {
            "label": "SGC",
            "value": "South Gloucestershire"
        },
        {
            "label": "SLK",
            "value": "South Lanarkshire"
        },
        {
            "label": "STY",
            "value": "South Tyneside"
        },
        {
            "label": "SOS",
            "value": "Southend-on-Sea"
        },
        {
            "label": "SHN",
            "value": "St Helens"
        },
        {
            "label": "STS",
            "value": "Staffordshire"
        },
        {
            "label": "STG",
            "value": "Stirling"
        },
        {
            "label": "SKP",
            "value": "Stockport"
        },
        {
            "label": "STT",
            "value": "Stockton-on-Tees"
        },
        {
            "label": "STB",
            "value": "Strabane District Council"
        },
        {
            "label": "SFK",
            "value": "Suffolk"
        },
        {
            "label": "SRY",
            "value": "Surrey"
        },
        {
            "label": "SWD",
            "value": "Swindon"
        },
        {
            "label": "TAM",
            "value": "Tameside"
        },
        {
            "label": "TFW",
            "value": "Telford and Wrekin"
        },
        {
            "label": "THR",
            "value": "Thurrock"
        },
        {
            "label": "TOB",
            "value": "Torbay"
        },
        {
            "label": "TOF",
            "value": "Torfaen"
        },
        {
            "label": "TRF",
            "value": "Trafford"
        },
        {
            "label": "UKM",
            "value": "United Kingdom"
        },
        {
            "label": "VGL",
            "value": "Vale of Glamorgan"
        },
        {
            "label": "WKF",
            "value": "Wakefield"
        },
        {
            "label": "WLS",
            "value": "Wales"
        },
        {
            "label": "WLL",
            "value": "Walsall"
        },
        {
            "label": "WRT",
            "value": "Warrington"
        },
        {
            "label": "WAR",
            "value": "Warwickshire"
        },
        {
            "label": "WBK",
            "value": "West Berkshire"
        },
        {
            "label": "WDU",
            "value": "West Dunbartonshire"
        },
        {
            "label": "WLN",
            "value": "West Lothian"
        },
        {
            "label": "WSX",
            "value": "West Sussex"
        },
        {
            "label": "WIL",
            "value": "Wiltshire"
        },
        {
            "label": "WNM",
            "value": "Windsor and Maidenhead"
        },
        {
            "label": "WRL",
            "value": "Wirral"
        },
        {
            "label": "WOK",
            "value": "Wokingham"
        },
        {
            "label": "WOR",
            "value": "Worcestershire"
        },
        {
            "label": "WRX",
            "value": "Wrexham County Borough"
        }
    ],
    "United States": [
        {
            "label": "AL",
            "value": "Alabama"
        },
        {
            "label": "AK",
            "value": "Alaska"
        },
        {
            "label": "AS",
            "value": "American Samoa"
        },
        {
            "label": "AZ",
            "value": "Arizona"
        },
        {
            "label": "AR",
            "value": "Arkansas"
        },
        {
            "label": "UM-81",
            "value": "Baker Island"
        },
        {
            "label": "CA",
            "value": "California"
        },
        {
            "label": "CO",
            "value": "Colorado"
        },
        {
            "label": "CT",
            "value": "Connecticut"
        },
        {
            "label": "DE",
            "value": "Delaware"
        },
        {
            "label": "DC",
            "value": "District of Columbia"
        },
        {
            "label": "FL",
            "value": "Florida"
        },
        {
            "label": "GA",
            "value": "Georgia"
        },
        {
            "label": "GU",
            "value": "Guam"
        },
        {
            "label": "HI",
            "value": "Hawaii"
        },
        {
            "label": "UM-84",
            "value": "Howland Island"
        },
        {
            "label": "ID",
            "value": "Idaho"
        },
        {
            "label": "IL",
            "value": "Illinois"
        },
        {
            "label": "IN",
            "value": "Indiana"
        },
        {
            "label": "IA",
            "value": "Iowa"
        },
        {
            "label": "UM-86",
            "value": "Jarvis Island"
        },
        {
            "label": "UM-67",
            "value": "Johnston Atoll"
        },
        {
            "label": "KS",
            "value": "Kansas"
        },
        {
            "label": "KY",
            "value": "Kentucky"
        },
        {
            "label": "UM-89",
            "value": "Kingman Reef"
        },
        {
            "label": "LA",
            "value": "Louisiana"
        },
        {
            "label": "ME",
            "value": "Maine"
        },
        {
            "label": "MD",
            "value": "Maryland"
        },
        {
            "label": "MA",
            "value": "Massachusetts"
        },
        {
            "label": "MI",
            "value": "Michigan"
        },
        {
            "label": "UM-71",
            "value": "Midway Atoll"
        },
        {
            "label": "MN",
            "value": "Minnesota"
        },
        {
            "label": "MS",
            "value": "Mississippi"
        },
        {
            "label": "MO",
            "value": "Missouri"
        },
        {
            "label": "MT",
            "value": "Montana"
        },
        {
            "label": "UM-76",
            "value": "Navassa Island"
        },
        {
            "label": "NE",
            "value": "Nebraska"
        },
        {
            "label": "NV",
            "value": "Nevada"
        },
        {
            "label": "NH",
            "value": "New Hampshire"
        },
        {
            "label": "NJ",
            "value": "New Jersey"
        },
        {
            "label": "NM",
            "value": "New Mexico"
        },
        {
            "label": "NY",
            "value": "New York"
        },
        {
            "label": "NC",
            "value": "North Carolina"
        },
        {
            "label": "ND",
            "value": "North Dakota"
        },
        {
            "label": "MP",
            "value": "Northern Mariana Islands"
        },
        {
            "label": "OH",
            "value": "Ohio"
        },
        {
            "label": "OK",
            "value": "Oklahoma"
        },
        {
            "label": "OR",
            "value": "Oregon"
        },
        {
            "label": "UM-95",
            "value": "Palmyra Atoll"
        },
        {
            "label": "PA",
            "value": "Pennsylvania"
        },
        {
            "label": "PR",
            "value": "Puerto Rico"
        },
        {
            "label": "RI",
            "value": "Rhode Island"
        },
        {
            "label": "SC",
            "value": "South Carolina"
        },
        {
            "label": "SD",
            "value": "South Dakota"
        },
        {
            "label": "TN",
            "value": "Tennessee"
        },
        {
            "label": "TX",
            "value": "Texas"
        },
        {
            "label": "UM",
            "value": "United States Minor Outlying Islands"
        },
        {
            "label": "VI",
            "value": "United States Virgin Islands"
        },
        {
            "label": "UT",
            "value": "Utah"
        },
        {
            "label": "VT",
            "value": "Vermont"
        },
        {
            "label": "VA",
            "value": "Virginia"
        },
        {
            "label": "UM-79",
            "value": "Wake Island"
        },
        {
            "label": "WA",
            "value": "Washington"
        },
        {
            "label": "WV",
            "value": "West Virginia"
        },
        {
            "label": "WI",
            "value": "Wisconsin"
        },
        {
            "label": "WY",
            "value": "Wyoming"
        }
    ],
    "United States Minor Outlying Islands": [

    ],
    "Uruguay": [
        {
            "label": "AR",
            "value": "Artigas Department"
        },
        {
            "label": "CA",
            "value": "Canelones Department"
        },
        {
            "label": "CL",
            "value": "Cerro Largo Department"
        },
        {
            "label": "CO",
            "value": "Colonia Department"
        },
        {
            "label": "DU",
            "value": "Durazno Department"
        },
        {
            "label": "FS",
            "value": "Flores Department"
        },
        {
            "label": "FD",
            "value": "Florida Department"
        },
        {
            "label": "LA",
            "value": "Lavalleja Department"
        },
        {
            "label": "MA",
            "value": "Maldonado Department"
        },
        {
            "label": "MO",
            "value": "Montevideo Department"
        },
        {
            "label": "PA",
            "value": "Paysandú Department"
        },
        {
            "label": "RN",
            "value": "Río Negro Department"
        },
        {
            "label": "RV",
            "value": "Rivera Department"
        },
        {
            "label": "RO",
            "value": "Rocha Department"
        },
        {
            "label": "SA",
            "value": "Salto Department"
        },
        {
            "label": "SJ",
            "value": "San José Department"
        },
        {
            "label": "SO",
            "value": "Soriano Department"
        },
        {
            "label": "TA",
            "value": "Tacuarembó Department"
        },
        {
            "label": "TT",
            "value": "Treinta y Tres Department"
        }
    ],
    "Uzbekistan": [
        {
            "label": "AN",
            "value": "Andijan Region"
        },
        {
            "label": "BU",
            "value": "Bukhara Region"
        },
        {
            "label": "FA",
            "value": "Fergana Region"
        },
        {
            "label": "JI",
            "value": "Jizzakh Region"
        },
        {
            "label": "QR",
            "value": "Karakalpakstan"
        },
        {
            "label": "NG",
            "value": "Namangan Region"
        },
        {
            "label": "NW",
            "value": "Navoiy Region"
        },
        {
            "label": "QA",
            "value": "Qashqadaryo Region"
        },
        {
            "label": "SA",
            "value": "Samarqand Region"
        },
        {
            "label": "SI",
            "value": "Sirdaryo Region"
        },
        {
            "label": "SU",
            "value": "Surxondaryo Region"
        },
        {
            "label": "TK",
            "value": "Tashkent"
        },
        {
            "label": "TO",
            "value": "Tashkent Region"
        },
        {
            "label": "XO",
            "value": "Xorazm Region"
        }
    ],
    "Vanuatu": [
        {
            "label": "MAP",
            "value": "Malampa"
        },
        {
            "label": "PAM",
            "value": "Penama"
        },
        {
            "label": "SAM",
            "value": "Sanma"
        },
        {
            "label": "SEE",
            "value": "Shefa"
        },
        {
            "label": "TAE",
            "value": "Tafea"
        },
        {
            "label": "TOB",
            "value": "Torba"
        }
    ],
    "Vatican City State (Holy See)": [

    ],
    "Venezuela": [
        {
            "label": "Z",
            "value": "Amazonas"
        },
        {
            "label": "B",
            "value": "Anzoátegui"
        },
        {
            "label": "C",
            "value": "Apure"
        },
        {
            "label": "D",
            "value": "Aragua"
        },
        {
            "label": "E",
            "value": "Barinas"
        },
        {
            "label": "F",
            "value": "Bolívar"
        },
        {
            "label": "A",
            "value": "Capital District"
        },
        {
            "label": "G",
            "value": "Carabobo"
        },
        {
            "label": "H",
            "value": "Cojedes"
        },
        {
            "label": "Y",
            "value": "Delta Amacuro"
        },
        {
            "label": "I",
            "value": "Falcón"
        },
        {
            "label": "W",
            "value": "Federal Dependencies of Venezuela"
        },
        {
            "label": "J",
            "value": "Guárico"
        },
        {
            "label": "K",
            "value": "Lara"
        },
        {
            "label": "L",
            "value": "Mérida"
        },
        {
            "label": "M",
            "value": "Miranda"
        },
        {
            "label": "N",
            "value": "Monagas"
        },
        {
            "label": "O",
            "value": "Nueva Esparta"
        },
        {
            "label": "P",
            "value": "Portuguesa"
        },
        {
            "label": "R",
            "value": "Sucre"
        },
        {
            "label": "S",
            "value": "Táchira"
        },
        {
            "label": "T",
            "value": "Trujillo"
        },
        {
            "label": "X",
            "value": "Vargas"
        },
        {
            "label": "U",
            "value": "Yaracuy"
        },
        {
            "label": "V",
            "value": "Zulia"
        }
    ],
    "Vietnam": [
        {
            "label": "44",
            "value": "An Giang"
        },
        {
            "label": "43",
            "value": "Bà Rịa-Vũng Tàu"
        },
        {
            "label": "54",
            "value": "Bắc Giang"
        },
        {
            "label": "53",
            "value": "Bắc Kạn"
        },
        {
            "label": "55",
            "value": "Bạc Liêu"
        },
        {
            "label": "56",
            "value": "Bắc Ninh"
        },
        {
            "label": "50",
            "value": "Bến Tre"
        },
        {
            "label": "57",
            "value": "Bình Dương"
        },
        {
            "label": "31",
            "value": "Bình Định"
        },
        {
            "label": "58",
            "value": "Bình Phước"
        },
        {
            "label": "40",
            "value": "Bình Thuận"
        },
        {
            "label": "59",
            "value": "Cà Mau"
        },
        {
            "label": "04",
            "value": "Cao Bằng"
        },
        {
            "label": "DN",
            "value": "Da Nang"
        },
        {
            "label": "33",
            "value": "Đắk Lắk"
        },
        {
            "label": "72",
            "value": "Đắk Nông"
        },
        {
            "label": "71",
            "value": "Điện Biên"
        },
        {
            "label": "39",
            "value": "Đồng Nai"
        },
        {
            "label": "45",
            "value": "Đồng Tháp"
        },
        {
            "label": "30",
            "value": "Gia Lai"
        },
        {
            "label": "03",
            "value": "Hà Giang"
        },
        {
            "label": "63",
            "value": "Hà Nam"
        },
        {
            "label": "15",
            "value": "Hà Tây"
        },
        {
            "label": "23",
            "value": "Hà Tĩnh"
        },
        {
            "label": "61",
            "value": "Hải Dương"
        },
        {
            "label": "HP",
            "value": "Haiphong"
        },
        {
            "label": "HN",
            "value": "Hanoi"
        },
        {
            "label": "73",
            "value": "Hậu Giang"
        },
        {
            "label": "SG",
            "value": "Ho Chi Minh City"
        },
        {
            "label": "14",
            "value": "Hòa Bình"
        },
        {
            "label": "66",
            "value": "Hưng Yên"
        },
        {
            "label": "34",
            "value": "Khánh Hòa"
        },
        {
            "label": "47",
            "value": "Kiên Giang"
        },
        {
            "label": "28",
            "value": "Kon Tum"
        },
        {
            "label": "01",
            "value": "Lai Châu"
        },
        {
            "label": "35",
            "value": "Lâm Đồng"
        },
        {
            "label": "09",
            "value": "Lạng Sơn"
        },
        {
            "label": "02",
            "value": "Lào Cai"
        },
        {
            "label": "41",
            "value": "Long An"
        },
        {
            "label": "67",
            "value": "Nam Định"
        },
        {
            "label": "22",
            "value": "Nghệ An"
        },
        {
            "label": "18",
            "value": "Ninh Bình"
        },
        {
            "label": "36",
            "value": "Ninh Thuận"
        },
        {
            "label": "68",
            "value": "Phú Thọ"
        },
        {
            "label": "32",
            "value": "Phú Yên"
        },
        {
            "label": "24",
            "value": "Quảng Bình"
        },
        {
            "label": "27",
            "value": "Quảng Nam"
        },
        {
            "label": "29",
            "value": "Quảng Ngãi"
        },
        {
            "label": "13",
            "value": "Quảng Ninh"
        },
        {
            "label": "25",
            "value": "Quảng Trị"
        },
        {
            "label": "52",
            "value": "Sóc Trăng"
        },
        {
            "label": "05",
            "value": "Sơn La"
        },
        {
            "label": "37",
            "value": "Tây Ninh"
        },
        {
            "label": "20",
            "value": "Thái Bình"
        },
        {
            "label": "69",
            "value": "Thái Nguyên"
        },
        {
            "label": "21",
            "value": "Thanh Hóa"
        },
        {
            "label": "26",
            "value": "Thừa Thiên-Huế"
        },
        {
            "label": "46",
            "value": "Tiền Giang"
        },
        {
            "label": "51",
            "value": "Trà Vinh"
        },
        {
            "label": "07",
            "value": "Tuyên Quang"
        },
        {
            "label": "49",
            "value": "Vĩnh Long"
        },
        {
            "label": "70",
            "value": "Vĩnh Phúc"
        },
        {
            "label": "06",
            "value": "Yên Bái"
        }
    ],
    "Virgin Islands (British)": [

    ],
    "Virgin Islands (US)": [

    ],
    "Wallis And Futuna Islands": [

    ],
    "Western Sahara": [

    ],
    "Yemen": [
        {
            "label": "AD",
            "value": "'Adan Governorate"
        },
        {
            "label": "AM",
            "value": "'Amran Governorate"
        },
        {
            "label": "AB",
            "value": "Abyan Governorate"
        },
        {
            "label": "BA",
            "value": "Al Bayda' Governorate"
        },
        {
            "label": "HU",
            "value": "Al Hudaydah Governorate"
        },
        {
            "label": "JA",
            "value": "Al Jawf Governorate"
        },
        {
            "label": "MR",
            "value": "Al Mahrah Governorate"
        },
        {
            "label": "MW",
            "value": "Al Mahwit Governorate"
        },
        {
            "label": "DH",
            "value": "Dhamar Governorate"
        },
        {
            "label": "HD",
            "value": "Hadhramaut Governorate"
        },
        {
            "label": "HJ",
            "value": "Hajjah Governorate"
        },
        {
            "label": "IB",
            "value": "Ibb Governorate"
        },
        {
            "label": "LA",
            "value": "Lahij Governorate"
        },
        {
            "label": "MA",
            "value": "Ma'rib Governorate"
        },
        {
            "label": "RA",
            "value": "Raymah Governorate"
        },
        {
            "label": "SD",
            "value": "Saada Governorate"
        },
        {
            "label": "SA",
            "value": "Sana'a"
        },
        {
            "label": "SN",
            "value": "Sana'a Governorate"
        },
        {
            "label": "SH",
            "value": "Shabwah Governorate"
        },
        {
            "label": "SU",
            "value": "Socotra Governorate"
        },
        {
            "label": "TA",
            "value": "Ta'izz Governorate"
        }
    ],
    "Zambia": [
        {
            "label": "02",
            "value": "Central Province"
        },
        {
            "label": "08",
            "value": "Copperbelt Province"
        },
        {
            "label": "03",
            "value": "Eastern Province"
        },
        {
            "label": "04",
            "value": "Luapula Province"
        },
        {
            "label": "09",
            "value": "Lusaka Province"
        },
        {
            "label": "10",
            "value": "Muchinga Province"
        },
        {
            "label": "05",
            "value": "Northern Province"
        },
        {
            "label": "06",
            "value": "Northwestern Province"
        },
        {
            "label": "07",
            "value": "Southern Province"
        },
        {
            "label": "01",
            "value": "Western Province"
        }
    ],
    "Zimbabwe": [
        {
            "label": "BU",
            "value": "Bulawayo Province"
        },
        {
            "label": "HA",
            "value": "Harare Province"
        },
        {
            "label": "MA",
            "value": "Manicaland"
        },
        {
            "label": "MC",
            "value": "Mashonaland Central Province"
        },
        {
            "label": "ME",
            "value": "Mashonaland East Province"
        },
        {
            "label": "MW",
            "value": "Mashonaland West Province"
        },
        {
            "label": "MV",
            "value": "Masvingo Province"
        },
        {
            "label": "MN",
            "value": "Matabeleland North Province"
        },
        {
            "label": "MS",
            "value": "Matabeleland South Province"
        },
        {
            "label": "MI",
            "value": "Midlands Province"
        }
    ]
}

export const countryNames = [
    'Afghanistan',
    'Aland Islands',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua And Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas The',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cape Verde',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos (Keeling) Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Congo The Democratic Republic Of The',
    'Cook Islands',
    'Costa Rica',
    'Cote D\'Ivoire (Ivory Coast)',
    'Croatia (Hrvatska)',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'East Timor',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji Islands',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gabon',
    'Gambia The',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey and Alderney',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard and McDonald Islands',
    'Honduras',
    'Hong Kong S.A.R.',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea North',
    'Korea South',
    'Kosovo',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau S.A.R.',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Man (Isle of)',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands Antilles',
    'Netherlands The',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestinian Territory Occupied',
    'Panama',
    'Papua new Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn Island',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Helena',
    'Saint Kitts And Nevis',
    'Saint Lucia',
    'Saint Pierre and Miquelon',
    'Saint Vincent And The Grenadines',
    'Saint-Barthelemy',
    'Saint-Martin (French part)',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard And Jan Mayen Islands',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad And Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks And Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'United States Minor Outlying Islands',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Vatican City State (Holy See)',
    'Venezuela',
    'Vietnam',
    'Virgin Islands (British)',
    'Virgin Islands (US)',
    'Wallis And Futuna Islands',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe'
]


